// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, legacy-wfp, components, utilities;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: var(--font-sans);
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --spacing: 0.25rem;
    --container-xs: 20rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --container-lg: 32rem;
    --container-xl: 36rem;
    --container-2xl: 42rem;
    --container-3xl: 48rem;
    --container-4xl: 56rem;
    --container-5xl: 64rem;
    --container-6xl: 72rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --tracking-widest: 0.1em;
    --leading-tight: 1.25;
    --leading-snug: 1.375;
    --leading-normal: 1.5;
    --leading-relaxed: 1.625;
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --font-emoji: var(--font-emoji);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .\\@container\\/card-header {
    container-type: inline-size !important;
    container-name: card-header !important;
  }
  .\\@container\\/field-group {
    container-type: inline-size !important;
    container-name: field-group !important;
  }
  .pointer-events-none {
    pointer-events: none !important;
  }
  .invisible {
    visibility: hidden !important;
  }
  .visible {
    visibility: visible !important;
  }
  .sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip-path: inset(50%) !important;
    white-space: nowrap !important;
    border-width: 0 !important;
  }
  .absolute {
    position: absolute !important;
  }
  .fixed {
    position: fixed !important;
  }
  .relative {
    position: relative !important;
  }
  .static {
    position: static !important;
  }
  .sticky {
    position: sticky !important;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0) !important;
  }
  .inset-x-0 {
    inset-inline: calc(var(--spacing) * 0) !important;
  }
  .inset-y-0 {
    inset-block: calc(var(--spacing) * 0) !important;
  }
  .start {
    inset-inline-start: var(--spacing) !important;
  }
  .end {
    inset-inline-end: var(--spacing) !important;
  }
  .end-3 {
    inset-inline-end: calc(var(--spacing) * 3) !important;
  }
  .-top-12 {
    top: calc(var(--spacing) * -12) !important;
  }
  .top-0 {
    top: calc(var(--spacing) * 0) !important;
  }
  .top-1\\.5 {
    top: calc(var(--spacing) * 1.5) !important;
  }
  .top-1\\/2 {
    top: calc(1 / 2 * 100%) !important;
  }
  .top-2 {
    top: calc(var(--spacing) * 2) !important;
  }
  .top-3 {
    top: calc(var(--spacing) * 3) !important;
  }
  .top-3\\.5 {
    top: calc(var(--spacing) * 3.5) !important;
  }
  .top-4 {
    top: calc(var(--spacing) * 4) !important;
  }
  .top-9 {
    top: calc(var(--spacing) * 9) !important;
  }
  .top-\\[1px\\] {
    top: 1px !important;
  }
  .top-\\[50\\%\\] {
    top: 50% !important;
  }
  .top-\\[60\\%\\] {
    top: 60% !important;
  }
  .top-full {
    top: 100% !important;
  }
  .-right-6 {
    right: calc(var(--spacing) * -6) !important;
  }
  .-right-12 {
    right: calc(var(--spacing) * -12) !important;
  }
  .right-0 {
    right: calc(var(--spacing) * 0) !important;
  }
  .right-1 {
    right: calc(var(--spacing) * 1) !important;
  }
  .right-2 {
    right: calc(var(--spacing) * 2) !important;
  }
  .right-3 {
    right: calc(var(--spacing) * 3) !important;
  }
  .right-4 {
    right: calc(var(--spacing) * 4) !important;
  }
  .-bottom-12 {
    bottom: calc(var(--spacing) * -12) !important;
  }
  .bottom-0 {
    bottom: calc(var(--spacing) * 0) !important;
  }
  .bottom-1 {
    bottom: calc(var(--spacing) * 1) !important;
  }
  .bottom-2 {
    bottom: calc(var(--spacing) * 2) !important;
  }
  .bottom-3 {
    bottom: calc(var(--spacing) * 3) !important;
  }
  .-left-12 {
    left: calc(var(--spacing) * -12) !important;
  }
  .left-0 {
    left: calc(var(--spacing) * 0) !important;
  }
  .left-1\\/2 {
    left: calc(1 / 2 * 100%) !important;
  }
  .left-2 {
    left: calc(var(--spacing) * 2) !important;
  }
  .left-3 {
    left: calc(var(--spacing) * 3) !important;
  }
  .left-4\\.5 {
    left: calc(var(--spacing) * 4.5) !important;
  }
  .left-\\[1\\.125rem\\] {
    left: 1.125rem !important;
  }
  .left-\\[50\\%\\] {
    left: 50% !important;
  }
  .isolate {
    isolation: isolate !important;
  }
  .z-0 {
    z-index: 0 !important;
  }
  .z-10 {
    z-index: 10 !important;
  }
  .z-20 {
    z-index: 20 !important;
  }
  .z-40 {
    z-index: 40 !important;
  }
  .z-50 {
    z-index: 50 !important;
  }
  .z-99999 {
    z-index: 99999 !important;
  }
  .z-\\[1\\] {
    z-index: 1 !important;
  }
  .order-first {
    order: -9999 !important;
  }
  .order-last {
    order: 9999 !important;
  }
  .col-start-2 {
    grid-column-start: 2 !important;
  }
  .row-1 {
    grid-row: 1 !important;
  }
  .row-span-2 {
    grid-row: span 2 / span 2 !important;
  }
  .row-span-3 {
    grid-row: span 3 / span 3 !important;
  }
  .row-span-4 {
    grid-row: span 4 / span 4 !important;
  }
  .row-start-1 {
    grid-row-start: 1 !important;
  }
  .container {
    width: 100% !important;
    @media (width >= 40rem) {
      max-width: 40rem !important;
    }
    @media (width >= 48rem) {
      max-width: 48rem !important;
    }
    @media (width >= 64rem) {
      max-width: 64rem !important;
    }
    @media (width >= 80rem) {
      max-width: 80rem !important;
    }
    @media (width >= 96rem) {
      max-width: 96rem !important;
    }
  }
  .m-0 {
    margin: calc(var(--spacing) * 0) !important;
  }
  .-mx-1 {
    margin-inline: calc(var(--spacing) * -1) !important;
  }
  .mx-2 {
    margin-inline: calc(var(--spacing) * 2) !important;
  }
  .mx-3\\.5 {
    margin-inline: calc(var(--spacing) * 3.5) !important;
  }
  .mx-6 {
    margin-inline: calc(var(--spacing) * 6) !important;
  }
  .mx-auto {
    margin-inline: auto !important;
  }
  .-my-2 {
    margin-block: calc(var(--spacing) * -2) !important;
  }
  .my-0 {
    margin-block: calc(var(--spacing) * 0) !important;
  }
  .my-1 {
    margin-block: calc(var(--spacing) * 1) !important;
  }
  .my-2 {
    margin-block: calc(var(--spacing) * 2) !important;
  }
  .my-4 {
    margin-block: calc(var(--spacing) * 4) !important;
  }
  .my-8 {
    margin-block: calc(var(--spacing) * 8) !important;
  }
  .ms-auto {
    margin-inline-start: auto !important;
  }
  .-mt-4 {
    margin-top: calc(var(--spacing) * -4) !important;
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5) !important;
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1) !important;
  }
  .mt-1\\.5 {
    margin-top: calc(var(--spacing) * 1.5) !important;
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2) !important;
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3) !important;
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4) !important;
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6) !important;
  }
  .mt-8 {
    margin-top: calc(var(--spacing) * 8) !important;
  }
  .mt-auto {
    margin-top: auto !important;
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2) !important;
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1) !important;
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2) !important;
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3) !important;
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4) !important;
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6) !important;
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8) !important;
  }
  .mb-10 {
    margin-bottom: calc(var(--spacing) * 10) !important;
  }
  .-ml-4 {
    margin-left: calc(var(--spacing) * -4) !important;
  }
  .ml-0\\.5 {
    margin-left: calc(var(--spacing) * 0.5) !important;
  }
  .ml-1 {
    margin-left: calc(var(--spacing) * 1) !important;
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2) !important;
  }
  .ml-4 {
    margin-left: calc(var(--spacing) * 4) !important;
  }
  .ml-auto {
    margin-left: auto !important;
  }
  .line-clamp-1 {
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 1 !important;
  }
  .line-clamp-2 {
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 2 !important;
  }
  .block {
    display: block !important;
  }
  .contents {
    display: contents !important;
  }
  .flex {
    display: flex !important;
  }
  .grid {
    display: grid !important;
  }
  .hidden {
    display: none !important;
  }
  .inline {
    display: inline !important;
  }
  .inline-block {
    display: inline-block !important;
  }
  .inline-flex {
    display: inline-flex !important;
  }
  .table {
    display: table !important;
  }
  .table-caption {
    display: table-caption !important;
  }
  .table-cell {
    display: table-cell !important;
  }
  .table-row {
    display: table-row !important;
  }
  .field-sizing-content {
    field-sizing: content !important;
  }
  .aspect-\\[16\\/10\\] {
    aspect-ratio: 16/10 !important;
  }
  .aspect-square {
    aspect-ratio: 1 / 1 !important;
  }
  .size-\\(--cell-size\\) {
    width: var(--cell-size) !important;
    height: var(--cell-size) !important;
  }
  .size-1\\.5 {
    width: calc(var(--spacing) * 1.5) !important;
    height: calc(var(--spacing) * 1.5) !important;
  }
  .size-2 {
    width: calc(var(--spacing) * 2) !important;
    height: calc(var(--spacing) * 2) !important;
  }
  .size-2\\.5 {
    width: calc(var(--spacing) * 2.5) !important;
    height: calc(var(--spacing) * 2.5) !important;
  }
  .size-3 {
    width: calc(var(--spacing) * 3) !important;
    height: calc(var(--spacing) * 3) !important;
  }
  .size-3\\.5 {
    width: calc(var(--spacing) * 3.5) !important;
    height: calc(var(--spacing) * 3.5) !important;
  }
  .size-4 {
    width: calc(var(--spacing) * 4) !important;
    height: calc(var(--spacing) * 4) !important;
  }
  .size-5 {
    width: calc(var(--spacing) * 5) !important;
    height: calc(var(--spacing) * 5) !important;
  }
  .size-6 {
    width: calc(var(--spacing) * 6) !important;
    height: calc(var(--spacing) * 6) !important;
  }
  .size-7 {
    width: calc(var(--spacing) * 7) !important;
    height: calc(var(--spacing) * 7) !important;
  }
  .size-8 {
    width: calc(var(--spacing) * 8) !important;
    height: calc(var(--spacing) * 8) !important;
  }
  .size-9 {
    width: calc(var(--spacing) * 9) !important;
    height: calc(var(--spacing) * 9) !important;
  }
  .size-10 {
    width: calc(var(--spacing) * 10) !important;
    height: calc(var(--spacing) * 10) !important;
  }
  .size-11 {
    width: calc(var(--spacing) * 11) !important;
    height: calc(var(--spacing) * 11) !important;
  }
  .size-12 {
    width: calc(var(--spacing) * 12) !important;
    height: calc(var(--spacing) * 12) !important;
  }
  .size-14 {
    width: calc(var(--spacing) * 14) !important;
    height: calc(var(--spacing) * 14) !important;
  }
  .size-16 {
    width: calc(var(--spacing) * 16) !important;
    height: calc(var(--spacing) * 16) !important;
  }
  .size-20 {
    width: calc(var(--spacing) * 20) !important;
    height: calc(var(--spacing) * 20) !important;
  }
  .size-24 {
    width: calc(var(--spacing) * 24) !important;
    height: calc(var(--spacing) * 24) !important;
  }
  .size-auto {
    width: auto !important;
    height: auto !important;
  }
  .size-full {
    width: 100% !important;
    height: 100% !important;
  }
  .h-\\(--cell-size\\) {
    height: var(--cell-size) !important;
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5) !important;
  }
  .h-2 {
    height: calc(var(--spacing) * 2) !important;
  }
  .h-4 {
    height: calc(var(--spacing) * 4) !important;
  }
  .h-5 {
    height: calc(var(--spacing) * 5) !important;
  }
  .h-6 {
    height: calc(var(--spacing) * 6) !important;
  }
  .h-7 {
    height: calc(var(--spacing) * 7) !important;
  }
  .h-8 {
    height: calc(var(--spacing) * 8) !important;
  }
  .h-9 {
    height: calc(var(--spacing) * 9) !important;
  }
  .h-10 {
    height: calc(var(--spacing) * 10) !important;
  }
  .h-12 {
    height: calc(var(--spacing) * 12) !important;
  }
  .h-14 {
    height: calc(var(--spacing) * 14) !important;
  }
  .h-16 {
    height: calc(var(--spacing) * 16) !important;
  }
  .h-20 {
    height: calc(var(--spacing) * 20) !important;
  }
  .h-24 {
    height: calc(var(--spacing) * 24) !important;
  }
  .h-56 {
    height: calc(var(--spacing) * 56) !important;
  }
  .h-96 {
    height: calc(var(--spacing) * 96) !important;
  }
  .h-\\[27rem\\] {
    height: 27rem !important;
  }
  .h-\\[440px\\] {
    height: 440px !important;
  }
  .h-\\[calc\\(100\\%-1px\\)\\] {
    height: calc(100% - 1px) !important;
  }
  .h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\] {
    height: var(--radix-navigation-menu-viewport-height) !important;
  }
  .h-\\[var\\(--radix-select-trigger-height\\)\\] {
    height: var(--radix-select-trigger-height) !important;
  }
  .h-auto {
    height: auto !important;
  }
  .h-dvh {
    height: 100dvh !important;
  }
  .h-fit {
    height: fit-content !important;
  }
  .h-full {
    height: 100% !important;
  }
  .h-px {
    height: 1px !important;
  }
  .h-screen {
    height: 100vh !important;
  }
  .h-svh {
    height: 100svh !important;
  }
  .max-h-\\(--radix-dropdown-menu-content-available-height\\) {
    max-height: var(--radix-dropdown-menu-content-available-height) !important;
  }
  .max-h-\\(--radix-select-content-available-height\\) {
    max-height: var(--radix-select-content-available-height) !important;
  }
  .max-h-60 {
    max-height: calc(var(--spacing) * 60) !important;
  }
  .max-h-64 {
    max-height: calc(var(--spacing) * 64) !important;
  }
  .max-h-72 {
    max-height: calc(var(--spacing) * 72) !important;
  }
  .max-h-80 {
    max-height: calc(var(--spacing) * 80) !important;
  }
  .max-h-\\[60vh\\] {
    max-height: 60vh !important;
  }
  .max-h-\\[65vh\\] {
    max-height: 65vh !important;
  }
  .max-h-\\[80vh\\] {
    max-height: 80vh !important;
  }
  .max-h-\\[90vh\\] {
    max-height: 90vh !important;
  }
  .max-h-\\[300px\\] {
    max-height: 300px !important;
  }
  .max-h-dvh {
    max-height: 100dvh !important;
  }
  .min-h-0 {
    min-height: calc(var(--spacing) * 0) !important;
  }
  .min-h-4 {
    min-height: calc(var(--spacing) * 4) !important;
  }
  .min-h-8 {
    min-height: calc(var(--spacing) * 8) !important;
  }
  .min-h-9 {
    min-height: calc(var(--spacing) * 9) !important;
  }
  .min-h-16 {
    min-height: calc(var(--spacing) * 16) !important;
  }
  .min-h-20 {
    min-height: calc(var(--spacing) * 20) !important;
  }
  .min-h-32 {
    min-height: calc(var(--spacing) * 32) !important;
  }
  .min-h-40 {
    min-height: calc(var(--spacing) * 40) !important;
  }
  .min-h-80 {
    min-height: calc(var(--spacing) * 80) !important;
  }
  .min-h-96 {
    min-height: calc(var(--spacing) * 96) !important;
  }
  .min-h-screen {
    min-height: 100vh !important;
  }
  .min-h-svh {
    min-height: 100svh !important;
  }
  .w-\\(--cell-size\\) {
    width: var(--cell-size) !important;
  }
  .w-\\(--radix-dropdown-menu-trigger-width\\) {
    width: var(--radix-dropdown-menu-trigger-width) !important;
  }
  .w-\\(--radix-popover-trigger-width\\) {
    width: var(--radix-popover-trigger-width) !important;
  }
  .w-\\(--sidebar-width\\) {
    width: var(--sidebar-width) !important;
  }
  .w-0 {
    width: calc(var(--spacing) * 0) !important;
  }
  .w-2 {
    width: calc(var(--spacing) * 2) !important;
  }
  .w-3\\/4 {
    width: calc(3 / 4 * 100%) !important;
  }
  .w-4 {
    width: calc(var(--spacing) * 4) !important;
  }
  .w-5 {
    width: calc(var(--spacing) * 5) !important;
  }
  .w-6 {
    width: calc(var(--spacing) * 6) !important;
  }
  .w-7 {
    width: calc(var(--spacing) * 7) !important;
  }
  .w-10 {
    width: calc(var(--spacing) * 10) !important;
  }
  .w-12 {
    width: calc(var(--spacing) * 12) !important;
  }
  .w-24 {
    width: calc(var(--spacing) * 24) !important;
  }
  .w-28 {
    width: calc(var(--spacing) * 28) !important;
  }
  .w-32 {
    width: calc(var(--spacing) * 32) !important;
  }
  .w-36 {
    width: calc(var(--spacing) * 36) !important;
  }
  .w-40 {
    width: calc(var(--spacing) * 40) !important;
  }
  .w-44 {
    width: calc(var(--spacing) * 44) !important;
  }
  .w-48 {
    width: calc(var(--spacing) * 48) !important;
  }
  .w-52 {
    width: calc(var(--spacing) * 52) !important;
  }
  .w-56 {
    width: calc(var(--spacing) * 56) !important;
  }
  .w-64 {
    width: calc(var(--spacing) * 64) !important;
  }
  .w-72 {
    width: calc(var(--spacing) * 72) !important;
  }
  .w-\\[4\\.75rem\\] {
    width: 4.75rem !important;
  }
  .w-\\[300px\\] {
    width: 300px !important;
  }
  .w-\\[min\\(1120px\\,calc\\(100\\%-3rem\\)\\)\\] {
    width: min(1120px, calc(100% - 3rem)) !important;
  }
  .w-auto {
    width: auto !important;
  }
  .w-fit {
    width: fit-content !important;
  }
  .w-full {
    width: 100% !important;
  }
  .w-max {
    width: max-content !important;
  }
  .w-px {
    width: 1px !important;
  }
  .w-screen {
    width: 100vw !important;
  }
  .max-w-\\(--skeleton-width\\) {
    max-width: var(--skeleton-width) !important;
  }
  .max-w-2xl {
    max-width: var(--container-2xl) !important;
  }
  .max-w-3xl {
    max-width: var(--container-3xl) !important;
  }
  .max-w-4xl {
    max-width: var(--container-4xl) !important;
  }
  .max-w-6xl {
    max-width: var(--container-6xl) !important;
  }
  .max-w-24 {
    max-width: calc(var(--spacing) * 24) !important;
  }
  .max-w-32 {
    max-width: calc(var(--spacing) * 32) !important;
  }
  .max-w-40 {
    max-width: calc(var(--spacing) * 40) !important;
  }
  .max-w-44 {
    max-width: calc(var(--spacing) * 44) !important;
  }
  .max-w-48 {
    max-width: calc(var(--spacing) * 48) !important;
  }
  .max-w-56 {
    max-width: calc(var(--spacing) * 56) !important;
  }
  .max-w-64 {
    max-width: calc(var(--spacing) * 64) !important;
  }
  .max-w-72 {
    max-width: calc(var(--spacing) * 72) !important;
  }
  .max-w-80 {
    max-width: calc(var(--spacing) * 80) !important;
  }
  .max-w-\\[66ch\\] {
    max-width: 66ch !important;
  }
  .max-w-\\[80\\%\\] {
    max-width: 80% !important;
  }
  .max-w-\\[calc\\(100\\%-2rem\\)\\] {
    max-width: calc(100% - 2rem) !important;
  }
  .max-w-full {
    max-width: 100% !important;
  }
  .max-w-lg {
    max-width: var(--container-lg) !important;
  }
  .max-w-max {
    max-width: max-content !important;
  }
  .max-w-md {
    max-width: var(--container-md) !important;
  }
  .max-w-none {
    max-width: none !important;
  }
  .max-w-xl {
    max-width: var(--container-xl) !important;
  }
  .max-w-xs {
    max-width: var(--container-xs) !important;
  }
  .min-w-\\(--cell-size\\) {
    min-width: var(--cell-size) !important;
  }
  .min-w-0 {
    min-width: calc(var(--spacing) * 0) !important;
  }
  .min-w-5 {
    min-width: calc(var(--spacing) * 5) !important;
  }
  .min-w-8 {
    min-width: calc(var(--spacing) * 8) !important;
  }
  .min-w-20 {
    min-width: calc(var(--spacing) * 20) !important;
  }
  .min-w-24 {
    min-width: calc(var(--spacing) * 24) !important;
  }
  .min-w-28 {
    min-width: calc(var(--spacing) * 28) !important;
  }
  .min-w-32 {
    min-width: calc(var(--spacing) * 32) !important;
  }
  .min-w-36 {
    min-width: calc(var(--spacing) * 36) !important;
  }
  .min-w-40 {
    min-width: calc(var(--spacing) * 40) !important;
  }
  .min-w-44 {
    min-width: calc(var(--spacing) * 44) !important;
  }
  .min-w-48 {
    min-width: calc(var(--spacing) * 48) !important;
  }
  .min-w-52 {
    min-width: calc(var(--spacing) * 52) !important;
  }
  .min-w-56 {
    min-width: calc(var(--spacing) * 56) !important;
  }
  .min-w-60 {
    min-width: calc(var(--spacing) * 60) !important;
  }
  .min-w-64 {
    min-width: calc(var(--spacing) * 64) !important;
  }
  .min-w-72 {
    min-width: calc(var(--spacing) * 72) !important;
  }
  .min-w-\\[8rem\\] {
    min-width: 8rem !important;
  }
  .min-w-\\[12rem\\] {
    min-width: 12rem !important;
  }
  .min-w-\\[16rem\\] {
    min-width: 16rem !important;
  }
  .min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
    min-width: var(--radix-select-trigger-width) !important;
  }
  .flex-1 {
    flex: 1 !important;
  }
  .flex-none {
    flex: none !important;
  }
  .shrink-0 {
    flex-shrink: 0 !important;
  }
  .grow-0 {
    flex-grow: 0 !important;
  }
  .basis-full {
    flex-basis: 100% !important;
  }
  .caption-bottom {
    caption-side: bottom !important;
  }
  .border-collapse {
    border-collapse: collapse !important;
  }
  .origin-\\(--radix-dropdown-menu-content-transform-origin\\) {
    transform-origin: var(--radix-dropdown-menu-content-transform-origin) !important;
  }
  .origin-\\(--radix-popover-content-transform-origin\\) {
    transform-origin: var(--radix-popover-content-transform-origin) !important;
  }
  .origin-\\(--radix-select-content-transform-origin\\) {
    transform-origin: var(--radix-select-content-transform-origin) !important;
  }
  .origin-\\(--radix-tooltip-content-transform-origin\\) {
    transform-origin: var(--radix-tooltip-content-transform-origin) !important;
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1) !important;
    translate: var(--tw-translate-x) var(--tw-translate-y) !important;
  }
  .-translate-x-px {
    --tw-translate-x: -1px !important;
    translate: var(--tw-translate-x) var(--tw-translate-y) !important;
  }
  .translate-x-\\[-50\\%\\] {
    --tw-translate-x: -50% !important;
    translate: var(--tw-translate-x) var(--tw-translate-y) !important;
  }
  .translate-x-px {
    --tw-translate-x: 1px !important;
    translate: var(--tw-translate-x) var(--tw-translate-y) !important;
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1) !important;
    translate: var(--tw-translate-x) var(--tw-translate-y) !important;
  }
  .translate-y-\\[-50\\%\\] {
    --tw-translate-y: -50% !important;
    translate: var(--tw-translate-x) var(--tw-translate-y) !important;
  }
  .translate-y-\\[calc\\(-50\\%_-_2px\\)\\] {
    --tw-translate-y: calc(-50% - 2px) !important;
    translate: var(--tw-translate-x) var(--tw-translate-y) !important;
  }
  .rotate-45 {
    rotate: 45deg !important;
  }
  .rotate-90 {
    rotate: 90deg !important;
  }
  .rotate-180 {
    rotate: 180deg !important;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,) !important;
  }
  .animate-in {
    animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none) !important;
  }
  .animate-pulse {
    animation: var(--animate-pulse) !important;
  }
  .animate-spin {
    animation: var(--animate-spin) !important;
  }
  .cursor-default {
    cursor: default !important;
  }
  .cursor-help {
    cursor: help !important;
  }
  .cursor-not-allowed {
    cursor: not-allowed !important;
  }
  .cursor-pointer {
    cursor: pointer !important;
  }
  .cursor-text {
    cursor: text !important;
  }
  .resize-none {
    resize: none !important;
  }
  .resize-y {
    resize: vertical !important;
  }
  .scroll-my-1 {
    scroll-margin-block: calc(var(--spacing) * 1) !important;
  }
  .scroll-py-1 {
    scroll-padding-block: calc(var(--spacing) * 1) !important;
  }
  .list-disc {
    list-style-type: disc !important;
  }
  .list-none {
    list-style-type: none !important;
  }
  .auto-rows-min {
    grid-auto-rows: min-content !important;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
  .grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }
  .grid-cols-\\[0_1fr\\] {
    grid-template-columns: 0 1fr !important;
  }
  .grid-cols-\\[96px_1fr\\] {
    grid-template-columns: 96px 1fr !important;
  }
  .grid-cols-\\[auto_1fr_1fr\\] {
    grid-template-columns: auto 1fr 1fr !important;
  }
  .grid-rows-\\[auto_auto\\] {
    grid-template-rows: auto auto !important;
  }
  .grid-rows-\\[auto_minmax\\(0\\,1fr\\)\\] {
    grid-template-rows: auto minmax(0,1fr) !important;
  }
  .grid-rows-subgrid {
    grid-template-rows: subgrid !important;
  }
  .flex-col {
    flex-direction: column !important;
  }
  .flex-col-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-row {
    flex-direction: row !important;
  }
  .flex-wrap {
    flex-wrap: wrap !important;
  }
  .place-content-center {
    place-content: center !important;
  }
  .content-center {
    align-content: center !important;
  }
  .items-baseline {
    align-items: baseline !important;
  }
  .items-center {
    align-items: center !important;
  }
  .items-end {
    align-items: flex-end !important;
  }
  .items-start {
    align-items: flex-start !important;
  }
  .items-stretch {
    align-items: stretch !important;
  }
  .justify-between {
    justify-content: space-between !important;
  }
  .justify-center {
    justify-content: center !important;
  }
  .justify-end {
    justify-content: flex-end !important;
  }
  .justify-start {
    justify-content: flex-start !important;
  }
  .justify-items-center {
    justify-items: center !important;
  }
  .justify-items-start {
    justify-items: start !important;
  }
  .gap-0 {
    gap: calc(var(--spacing) * 0) !important;
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5) !important;
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1) !important;
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5) !important;
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2) !important;
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5) !important;
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3) !important;
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4) !important;
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5) !important;
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6) !important;
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8) !important;
  }
  .gap-10 {
    gap: calc(var(--spacing) * 10) !important;
  }
  .gap-12 {
    gap: calc(var(--spacing) * 12) !important;
  }
  .space-y-0\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0 !important;
      margin-block-start: calc(calc(var(--spacing) * 0.5) * var(--tw-space-y-reverse)) !important;
      margin-block-end: calc(calc(var(--spacing) * 0.5) * calc(1 - var(--tw-space-y-reverse))) !important;
    }
  }
  .space-y-1 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0 !important;
      margin-block-start: calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse)) !important;
      margin-block-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse))) !important;
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0 !important;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse)) !important;
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse))) !important;
    }
  }
  .space-y-3 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0 !important;
      margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse)) !important;
      margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse))) !important;
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0 !important;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse)) !important;
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse))) !important;
    }
  }
  .space-y-5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0 !important;
      margin-block-start: calc(calc(var(--spacing) * 5) * var(--tw-space-y-reverse)) !important;
      margin-block-end: calc(calc(var(--spacing) * 5) * calc(1 - var(--tw-space-y-reverse))) !important;
    }
  }
  .space-y-6 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0 !important;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse)) !important;
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse))) !important;
    }
  }
  .space-y-8 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0 !important;
      margin-block-start: calc(calc(var(--spacing) * 8) * var(--tw-space-y-reverse)) !important;
      margin-block-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-y-reverse))) !important;
    }
  }
  .gap-x-2 {
    column-gap: calc(var(--spacing) * 2) !important;
  }
  .gap-x-3 {
    column-gap: calc(var(--spacing) * 3) !important;
  }
  .gap-x-8 {
    column-gap: calc(var(--spacing) * 8) !important;
  }
  .-space-x-2 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0 !important;
      margin-inline-start: calc(calc(var(--spacing) * -2) * var(--tw-space-x-reverse)) !important;
      margin-inline-end: calc(calc(var(--spacing) * -2) * calc(1 - var(--tw-space-x-reverse))) !important;
    }
  }
  .gap-y-0\\.5 {
    row-gap: calc(var(--spacing) * 0.5) !important;
  }
  .gap-y-1 {
    row-gap: calc(var(--spacing) * 1) !important;
  }
  .gap-y-2 {
    row-gap: calc(var(--spacing) * 2) !important;
  }
  .gap-y-3 {
    row-gap: calc(var(--spacing) * 3) !important;
  }
  .gap-y-4 {
    row-gap: calc(var(--spacing) * 4) !important;
  }
  .divide-y {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0 !important;
      border-bottom-style: var(--tw-border-style) !important;
      border-top-style: var(--tw-border-style) !important;
      border-top-width: calc(1px * var(--tw-divide-y-reverse)) !important;
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse))) !important;
    }
  }
  .divide-border {
    :where(& > :not(:last-child)) {
      border-color: var(--border) !important;
    }
  }
  .self-center {
    align-self: center !important;
  }
  .self-end {
    align-self: flex-end !important;
  }
  .self-start {
    align-self: flex-start !important;
  }
  .justify-self-end {
    justify-self: flex-end !important;
  }
  .truncate {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }
  .overflow-auto {
    overflow: auto !important;
  }
  .overflow-hidden {
    overflow: hidden !important;
  }
  .overflow-x-auto {
    overflow-x: auto !important;
  }
  .overflow-x-hidden {
    overflow-x: hidden !important;
  }
  .overflow-y-auto {
    overflow-y: auto !important;
  }
  .overflow-y-scroll {
    overflow-y: scroll !important;
  }
  .rounded-2xl {
    border-radius: 0.75rem !important;
  }
  .rounded-\\[2px\\] {
    border-radius: 2px !important;
  }
  .rounded-\\[4px\\] {
    border-radius: 4px !important;
  }
  .rounded-\\[calc\\(var\\(--radius\\)-5px\\)\\] {
    border-radius: calc(var(--radius) - 5px) !important;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px) !important;
  }
  .rounded-lg {
    border-radius: 0.375rem !important;
  }
  .rounded-md {
    border-radius: 0.25rem !important;
  }
  .rounded-none {
    border-radius: 0 !important;
  }
  .rounded-sm {
    border-radius: 0.1875rem !important;
  }
  .rounded-xl {
    border-radius: 0.5rem !important;
  }
  .rounded-xs {
    border-radius: 0.125rem !important;
  }
  .rounded-t-xl {
    border-top-left-radius: 0.5rem !important;
    border-top-right-radius: 0.5rem !important;
  }
  .rounded-l-md {
    border-top-left-radius: 0.25rem !important;
    border-bottom-left-radius: 0.25rem !important;
  }
  .rounded-l-none {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
  .rounded-tl-sm {
    border-top-left-radius: 0.1875rem !important;
  }
  .rounded-r-md {
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
  }
  .border {
    border-style: var(--tw-border-style) !important;
    border-width: 1px !important;
  }
  .border-0 {
    border-style: var(--tw-border-style) !important;
    border-width: 0px !important;
  }
  .border-4 {
    border-style: var(--tw-border-style) !important;
    border-width: 4px !important;
  }
  .border-t {
    border-top-style: var(--tw-border-style) !important;
    border-top-width: 1px !important;
  }
  .border-r {
    border-right-style: var(--tw-border-style) !important;
    border-right-width: 1px !important;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style) !important;
    border-bottom-width: 1px !important;
  }
  .border-b-0 {
    border-bottom-style: var(--tw-border-style) !important;
    border-bottom-width: 0px !important;
  }
  .border-l {
    border-left-style: var(--tw-border-style) !important;
    border-left-width: 1px !important;
  }
  .border-dashed {
    --tw-border-style: dashed !important;
    border-style: dashed !important;
  }
  .border-none {
    --tw-border-style: none !important;
    border-style: none !important;
  }
  .border-border {
    border-color: var(--border) !important;
  }
  .border-danger-200 {
    border-color: var(--red-200) !important;
  }
  .border-danger-300 {
    border-color: var(--red-300) !important;
  }
  .border-danger-500 {
    border-color: var(--red-500) !important;
  }
  .border-destructive {
    border-color: var(--destructive) !important;
  }
  .border-foreground\\/80 {
    border-color: var(--foreground) !important;
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--foreground) 80%, transparent) !important;
    }
  }
  .border-info-200 {
    border-color: var(--blue-200) !important;
  }
  .border-info-300 {
    border-color: var(--blue-300) !important;
  }
  .border-info-500 {
    border-color: var(--blue-500) !important;
  }
  .border-input {
    border-color: var(--input) !important;
  }
  .border-neutral-alpha-200 {
    border-color: var(--neutral-alpha-200) !important;
  }
  .border-neutral-alpha-300 {
    border-color: var(--neutral-alpha-300) !important;
  }
  .border-primary {
    border-color: var(--primary) !important;
  }
  .border-primary-300 {
    border-color: var(--blue-300) !important;
  }
  .border-sidebar-border {
    border-color: var(--sidebar-border) !important;
  }
  .border-success-200 {
    border-color: var(--green-200) !important;
  }
  .border-success-300 {
    border-color: var(--green-300) !important;
  }
  .border-success-500 {
    border-color: var(--green-500) !important;
  }
  .border-transparent {
    border-color: transparent !important;
  }
  .border-warning-200 {
    border-color: var(--warning-200) !important;
  }
  .border-warning-300 {
    border-color: var(--warning-300) !important;
  }
  .border-warning-500 {
    border-color: var(--warning-500) !important;
  }
  .border-b-border {
    border-bottom-color: var(--border) !important;
  }
  .bg-accent {
    background-color: var(--accent) !important;
  }
  .bg-aqua-100 {
    background-color: var(--aqua-100) !important;
  }
  .bg-background {
    background-color: var(--background) !important;
  }
  .bg-background\\/70 {
    background-color: var(--background) !important;
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--background) 70%, transparent) !important;
    }
  }
  .bg-black\\/50 {
    background-color: var(--black) !important;
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--black) 50%, transparent) !important;
    }
  }
  .bg-black\\/60 {
    background-color: var(--black) !important;
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--black) 60%, transparent) !important;
    }
  }
  .bg-blue-50 {
    background-color: var(--blue-50) !important;
  }
  .bg-blue-100 {
    background-color: var(--blue-100) !important;
  }
  .bg-border {
    background-color: var(--border) !important;
  }
  .bg-brown-100 {
    background-color: var(--brown-100) !important;
  }
  .bg-card {
    background-color: var(--card) !important;
  }
  .bg-danger-50 {
    background-color: var(--red-50) !important;
  }
  .bg-danger-100 {
    background-color: var(--red-100) !important;
  }
  .bg-danger-200 {
    background-color: var(--red-200) !important;
  }
  .bg-danger-600 {
    background-color: var(--red-600) !important;
  }
  .bg-destructive {
    background-color: var(--destructive) !important;
  }
  .bg-green-100 {
    background-color: var(--green-100) !important;
  }
  .bg-green-600 {
    background-color: var(--green-600) !important;
  }
  .bg-info-50 {
    background-color: var(--blue-50) !important;
  }
  .bg-info-100 {
    background-color: var(--blue-100) !important;
  }
  .bg-info-200 {
    background-color: var(--blue-200) !important;
  }
  .bg-ivory-100 {
    background-color: var(--ivory-100) !important;
  }
  .bg-ivory-600 {
    background-color: var(--ivory-600) !important;
  }
  .bg-muted {
    background-color: var(--muted) !important;
  }
  .bg-muted\\/20 {
    background-color: var(--muted) !important;
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--muted) 20%, transparent) !important;
    }
  }
  .bg-muted\\/30 {
    background-color: var(--muted) !important;
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--muted) 30%, transparent) !important;
    }
  }
  .bg-muted\\/40 {
    background-color: var(--muted) !important;
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--muted) 40%, transparent) !important;
    }
  }
  .bg-muted\\/50 {
    background-color: var(--muted) !important;
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--muted) 50%, transparent) !important;
    }
  }
  .bg-neutral-100 {
    background-color: var(--neutral-100) !important;
  }
  .bg-neutral-900 {
    background-color: var(--neutral-900) !important;
  }
  .bg-neutral-alpha-50 {
    background-color: var(--neutral-alpha-50) !important;
  }
  .bg-neutral-alpha-100 {
    background-color: var(--neutral-alpha-100) !important;
  }
  .bg-neutral-alpha-200 {
    background-color: var(--neutral-alpha-200) !important;
  }
  .bg-orange-100 {
    background-color: var(--orange-100) !important;
  }
  .bg-popover {
    background-color: var(--popover) !important;
  }
  .bg-primary {
    background-color: var(--primary) !important;
  }
  .bg-primary-100 {
    background-color: var(--blue-100) !important;
  }
  .bg-primary\\/10 {
    background-color: var(--primary) !important;
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--primary) 10%, transparent) !important;
    }
  }
  .bg-red-100 {
    background-color: var(--red-100) !important;
  }
  .bg-red-600 {
    background-color: var(--red-600) !important;
  }
  .bg-secondary {
    background-color: var(--secondary) !important;
  }
  .bg-sidebar {
    background-color: var(--sidebar) !important;
  }
  .bg-sidebar-border {
    background-color: var(--sidebar-border) !important;
  }
  .bg-success-50 {
    background-color: var(--green-50) !important;
  }
  .bg-success-100 {
    background-color: var(--green-100) !important;
  }
  .bg-success-200 {
    background-color: var(--green-200) !important;
  }
  .bg-success-600 {
    background-color: var(--green-600) !important;
  }
  .bg-transparent {
    background-color: transparent !important;
  }
  .bg-warning-50 {
    background-color: var(--warning-50) !important;
  }
  .bg-warning-100 {
    background-color: var(--warning-100) !important;
  }
  .bg-warning-200 {
    background-color: var(--warning-200) !important;
  }
  .bg-warning-300 {
    background-color: var(--warning-300) !important;
  }
  .bg-white {
    background-color: var(--white) !important;
  }
  .bg-cover {
    background-size: cover !important;
  }
  .bg-center {
    background-position: center !important;
  }
  .bg-no-repeat {
    background-repeat: no-repeat !important;
  }
  .fill-current {
    fill: currentcolor !important;
  }
  .fill-neutral-900 {
    fill: var(--neutral-900) !important;
  }
  .fill-primary {
    fill: var(--primary) !important;
  }
  .object-contain {
    object-fit: contain !important;
  }
  .object-cover {
    object-fit: cover !important;
  }
  .p-0 {
    padding: calc(var(--spacing) * 0) !important;
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5) !important;
  }
  .p-1 {
    padding: calc(var(--spacing) * 1) !important;
  }
  .p-2 {
    padding: calc(var(--spacing) * 2) !important;
  }
  .p-2\\.5 {
    padding: calc(var(--spacing) * 2.5) !important;
  }
  .p-3 {
    padding: calc(var(--spacing) * 3) !important;
  }
  .p-4 {
    padding: calc(var(--spacing) * 4) !important;
  }
  .p-5 {
    padding: calc(var(--spacing) * 5) !important;
  }
  .p-6 {
    padding: calc(var(--spacing) * 6) !important;
  }
  .p-8 {
    padding: calc(var(--spacing) * 8) !important;
  }
  .p-10 {
    padding: calc(var(--spacing) * 10) !important;
  }
  .p-16 {
    padding: calc(var(--spacing) * 16) !important;
  }
  .p-\\[3px\\] {
    padding: 3px !important;
  }
  .px-\\(--cell-size\\) {
    padding-inline: var(--cell-size) !important;
  }
  .px-0 {
    padding-inline: calc(var(--spacing) * 0) !important;
  }
  .px-1 {
    padding-inline: calc(var(--spacing) * 1) !important;
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5) !important;
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2) !important;
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5) !important;
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3) !important;
  }
  .px-3\\.5 {
    padding-inline: calc(var(--spacing) * 3.5) !important;
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4) !important;
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6) !important;
  }
  .px-10 {
    padding-inline: calc(var(--spacing) * 10) !important;
  }
  .py-0 {
    padding-block: calc(var(--spacing) * 0) !important;
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5) !important;
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1) !important;
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5) !important;
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2) !important;
  }
  .py-2\\.5 {
    padding-block: calc(var(--spacing) * 2.5) !important;
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3) !important;
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4) !important;
  }
  .py-5 {
    padding-block: calc(var(--spacing) * 5) !important;
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6) !important;
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8) !important;
  }
  .py-10 {
    padding-block: calc(var(--spacing) * 10) !important;
  }
  .py-12 {
    padding-block: calc(var(--spacing) * 12) !important;
  }
  .py-16 {
    padding-block: calc(var(--spacing) * 16) !important;
  }
  .py-20 {
    padding-block: calc(var(--spacing) * 20) !important;
  }
  .py-24 {
    padding-block: calc(var(--spacing) * 24) !important;
  }
  .pt-1 {
    padding-top: calc(var(--spacing) * 1) !important;
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2) !important;
  }
  .pt-3 {
    padding-top: calc(var(--spacing) * 3) !important;
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4) !important;
  }
  .pr-1 {
    padding-right: calc(var(--spacing) * 1) !important;
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2) !important;
  }
  .pr-2\\.5 {
    padding-right: calc(var(--spacing) * 2.5) !important;
  }
  .pr-3 {
    padding-right: calc(var(--spacing) * 3) !important;
  }
  .pr-4 {
    padding-right: calc(var(--spacing) * 4) !important;
  }
  .pr-8 {
    padding-right: calc(var(--spacing) * 8) !important;
  }
  .pr-12 {
    padding-right: calc(var(--spacing) * 12) !important;
  }
  .pb-0 {
    padding-bottom: calc(var(--spacing) * 0) !important;
  }
  .pb-1 {
    padding-bottom: calc(var(--spacing) * 1) !important;
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2) !important;
  }
  .pb-3 {
    padding-bottom: calc(var(--spacing) * 3) !important;
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4) !important;
  }
  .pb-10 {
    padding-bottom: calc(var(--spacing) * 10) !important;
  }
  .pl-2 {
    padding-left: calc(var(--spacing) * 2) !important;
  }
  .pl-2\\.5 {
    padding-left: calc(var(--spacing) * 2.5) !important;
  }
  .pl-3 {
    padding-left: calc(var(--spacing) * 3) !important;
  }
  .pl-4 {
    padding-left: calc(var(--spacing) * 4) !important;
  }
  .pl-8 {
    padding-left: calc(var(--spacing) * 8) !important;
  }
  .pl-9 {
    padding-left: calc(var(--spacing) * 9) !important;
  }
  .pl-12 {
    padding-left: calc(var(--spacing) * 12) !important;
  }
  .pl-17 {
    padding-left: calc(var(--spacing) * 17) !important;
  }
  .text-center {
    text-align: center !important;
  }
  .text-left {
    text-align: left !important;
  }
  .text-right {
    text-align: right !important;
  }
  .align-middle {
    vertical-align: middle !important;
  }
  .align-top {
    vertical-align: top !important;
  }
  .text-2xl {
    font-size: var(--text-2xl) !important;
    line-height: var(--tw-leading, var(--text-2xl--line-height)) !important;
  }
  .text-3xl {
    font-size: var(--text-3xl) !important;
    line-height: var(--tw-leading, var(--text-3xl--line-height)) !important;
  }
  .text-4xl {
    font-size: var(--text-4xl) !important;
    line-height: var(--tw-leading, var(--text-4xl--line-height)) !important;
  }
  .text-base {
    font-size: var(--text-base) !important;
    line-height: var(--tw-leading, var(--text-base--line-height)) !important;
  }
  .text-lg {
    font-size: var(--text-lg) !important;
    line-height: var(--tw-leading, var(--text-lg--line-height)) !important;
  }
  .text-sm {
    font-size: var(--text-sm) !important;
    line-height: var(--tw-leading, var(--text-sm--line-height)) !important;
  }
  .text-xl {
    font-size: var(--text-xl) !important;
    line-height: var(--tw-leading, var(--text-xl--line-height)) !important;
  }
  .text-xs {
    font-size: var(--text-xs) !important;
    line-height: var(--tw-leading, var(--text-xs--line-height)) !important;
  }
  .text-\\[0\\.8rem\\] {
    font-size: 0.8rem !important;
  }
  .leading-5 {
    --tw-leading: calc(var(--spacing) * 5) !important;
    line-height: calc(var(--spacing) * 5) !important;
  }
  .leading-6 {
    --tw-leading: calc(var(--spacing) * 6) !important;
    line-height: calc(var(--spacing) * 6) !important;
  }
  .leading-none {
    --tw-leading: 1 !important;
    line-height: 1 !important;
  }
  .leading-normal {
    --tw-leading: var(--leading-normal) !important;
    line-height: var(--leading-normal) !important;
  }
  .leading-relaxed {
    --tw-leading: var(--leading-relaxed) !important;
    line-height: var(--leading-relaxed) !important;
  }
  .leading-snug {
    --tw-leading: var(--leading-snug) !important;
    line-height: var(--leading-snug) !important;
  }
  .leading-tight {
    --tw-leading: var(--leading-tight) !important;
    line-height: var(--leading-tight) !important;
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold) !important;
    font-weight: var(--font-weight-bold) !important;
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium) !important;
    font-weight: var(--font-weight-medium) !important;
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal) !important;
    font-weight: var(--font-weight-normal) !important;
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold) !important;
    font-weight: var(--font-weight-semibold) !important;
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide) !important;
    letter-spacing: var(--tracking-wide) !important;
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider) !important;
    letter-spacing: var(--tracking-wider) !important;
  }
  .tracking-widest {
    --tw-tracking: var(--tracking-widest) !important;
    letter-spacing: var(--tracking-widest) !important;
  }
  .text-balance {
    text-wrap: balance !important;
  }
  .break-words {
    overflow-wrap: break-word !important;
  }
  .wrap-break-word {
    overflow-wrap: break-word !important;
  }
  .break-all {
    word-break: break-all !important;
  }
  .\\!whitespace-normal {
    white-space: normal !important;
  }
  .whitespace-normal {
    white-space: normal !important;
  }
  .whitespace-nowrap {
    white-space: nowrap !important;
  }
  .whitespace-pre-line {
    white-space: pre-line !important;
  }
  .whitespace-pre-wrap {
    white-space: pre-wrap !important;
  }
  .text-accent-foreground {
    color: var(--accent-foreground) !important;
  }
  .text-aqua-600 {
    color: var(--aqua-600) !important;
  }
  .text-black {
    color: var(--black) !important;
  }
  .text-blue-600 {
    color: var(--blue-600) !important;
  }
  .text-blue-700 {
    color: var(--blue-700) !important;
  }
  .text-blue-800 {
    color: var(--blue-800) !important;
  }
  .text-brown-600 {
    color: var(--brown-600) !important;
  }
  .text-card-foreground {
    color: var(--card-foreground) !important;
  }
  .text-current {
    color: currentcolor !important;
  }
  .text-danger-500 {
    color: var(--red-500) !important;
  }
  .text-danger-600 {
    color: var(--red-600) !important;
  }
  .text-danger-800 {
    color: var(--red-800) !important;
  }
  .text-destructive {
    color: var(--destructive) !important;
  }
  .text-foreground {
    color: var(--foreground) !important;
  }
  .text-green-600 {
    color: var(--green-600) !important;
  }
  .text-info-500 {
    color: var(--blue-500) !important;
  }
  .text-info-700 {
    color: var(--blue-700) !important;
  }
  .text-info-800 {
    color: var(--blue-800) !important;
  }
  .text-ivory-600 {
    color: var(--ivory-600) !important;
  }
  .text-muted-foreground {
    color: var(--muted-foreground) !important;
  }
  .text-muted-foreground\\/80 {
    color: var(--muted-foreground) !important;
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--muted-foreground) 80%, transparent) !important;
    }
  }
  .text-neutral-500 {
    color: var(--neutral-500) !important;
  }
  .text-neutral-600 {
    color: var(--neutral-600) !important;
  }
  .text-neutral-700 {
    color: var(--neutral-700) !important;
  }
  .text-neutral-alpha-300 {
    color: var(--neutral-alpha-300) !important;
  }
  .text-neutral-alpha-600 {
    color: var(--neutral-alpha-600) !important;
  }
  .text-neutral-alpha-700 {
    color: var(--neutral-alpha-700) !important;
  }
  .text-neutral-alpha-800 {
    color: var(--neutral-alpha-800) !important;
  }
  .text-orange-600 {
    color: var(--orange-600) !important;
  }
  .text-popover-foreground {
    color: var(--popover-foreground) !important;
  }
  .text-primary {
    color: var(--primary) !important;
  }
  .text-primary-600 {
    color: var(--blue-600) !important;
  }
  .text-primary-700 {
    color: var(--blue-700) !important;
  }
  .text-primary-foreground {
    color: var(--primary-foreground) !important;
  }
  .text-red-600 {
    color: var(--red-600) !important;
  }
  .text-sidebar-foreground {
    color: var(--sidebar-foreground) !important;
  }
  .text-sidebar-foreground\\/70 {
    color: var(--sidebar-foreground) !important;
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--sidebar-foreground) 70%, transparent) !important;
    }
  }
  .text-success-500 {
    color: var(--green-500) !important;
  }
  .text-success-600 {
    color: var(--green-600) !important;
  }
  .text-success-700 {
    color: var(--green-700) !important;
  }
  .text-success-800 {
    color: var(--green-800) !important;
  }
  .text-warning-500 {
    color: var(--warning-500) !important;
  }
  .text-warning-600 {
    color: var(--warning-600) !important;
  }
  .text-warning-700 {
    color: var(--warning-700) !important;
  }
  .text-warning-800 {
    color: var(--warning-800) !important;
  }
  .text-white {
    color: var(--white) !important;
  }
  .capitalize {
    text-transform: capitalize !important;
  }
  .uppercase {
    text-transform: uppercase !important;
  }
  .tabular-nums {
    --tw-numeric-spacing: tabular-nums !important;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,) !important;
  }
  .underline {
    text-decoration-line: underline !important;
  }
  .decoration-dotted {
    text-decoration-style: dotted !important;
  }
  .underline-offset-2 {
    text-underline-offset: 2px !important;
  }
  .underline-offset-4 {
    text-underline-offset: 4px !important;
  }
  .opacity-0 {
    opacity: 0% !important;
  }
  .opacity-50 {
    opacity: 50% !important;
  }
  .opacity-60 {
    opacity: 60% !important;
  }
  .opacity-70 {
    opacity: 70% !important;
  }
  .opacity-100 {
    opacity: 100% !important;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-border\\)\\)\\] {
    --tw-shadow: 0 0 0 1px var(--tw-shadow-color, hsl(var(--sidebar-border))) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1)) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1)) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .shadow-none {
    --tw-shadow: 0 0 #0000 !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .ring-0 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .ring-2 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .ring-background {
    --tw-ring-color: var(--background) !important;
  }
  .ring-destructive\\/20 {
    --tw-ring-color: var(--destructive) !important;
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--destructive) 20%, transparent) !important;
    }
  }
  .ring-primary-200 {
    --tw-ring-color: var(--blue-200) !important;
  }
  .ring-sidebar-ring {
    --tw-ring-color: var(--sidebar-ring) !important;
  }
  .ring-offset-2 {
    --tw-ring-offset-width: 2px !important;
    --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  }
  .ring-offset-background {
    --tw-ring-offset-color: var(--background) !important;
  }
  .outline-hidden {
    --tw-outline-style: none !important;
    outline-style: none !important;
    @media (forced-colors: active) {
      outline: 2px solid transparent !important;
      outline-offset: 2px !important;
    }
  }
  .outline {
    outline-style: var(--tw-outline-style) !important;
    outline-width: 1px !important;
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,) !important;
  }
  .backdrop-blur-\\[1px\\] {
    --tw-backdrop-blur: blur(1px) !important;
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,) !important;
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,) !important;
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-\\[box-shadow\\,transform\\] {
    transition-property: box-shadow,transform !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-\\[color\\,box-shadow\\] {
    transition-property: color,box-shadow !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-\\[left\\,right\\,width\\] {
    transition-property: left,right,width !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-\\[margin\\,opacity\\] {
    transition-property: margin,opacity !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-\\[translate\\,box-shadow\\,border-color\\] {
    transition-property: translate,box-shadow,border-color !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-\\[width\\,height\\,padding\\,background-color\\] {
    transition-property: width,height,padding,background-color !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-\\[width\\,height\\,padding\\] {
    transition-property: width,height,padding !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-\\[width\\] {
    transition-property: width !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-all {
    transition-property: all !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-opacity {
    transition-property: opacity !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-shadow {
    transition-property: box-shadow !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition-none {
    transition-property: none !important;
  }
  .duration-100 {
    --tw-duration: 100ms !important;
    transition-duration: 100ms !important;
  }
  .duration-200 {
    --tw-duration: 200ms !important;
    transition-duration: 200ms !important;
  }
  .duration-300 {
    --tw-duration: 300ms !important;
    transition-duration: 300ms !important;
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out) !important;
    transition-timing-function: var(--ease-in-out) !important;
  }
  .ease-linear {
    --tw-ease: linear !important;
    transition-timing-function: linear !important;
  }
  .ease-out {
    --tw-ease: var(--ease-out) !important;
    transition-timing-function: var(--ease-out) !important;
  }
  .fade-in-0 {
    --tw-enter-opacity: calc(0/100) !important;
    --tw-enter-opacity: 0 !important;
  }
  .outline-none {
    --tw-outline-style: none !important;
    outline-style: none !important;
  }
  .select-none {
    -webkit-user-select: none !important;
    user-select: none !important;
  }
  .zoom-in-95 {
    --tw-enter-scale: calc(95*1%) !important;
    --tw-enter-scale: .95 !important;
  }
  .\\[--cell-size\\:--spacing\\(8\\)\\] {
    --cell-size: calc(var(--spacing) * 8) !important;
  }
  .running {
    animation-play-state: running !important;
  }
  .group-focus-within\\/menu-item\\:opacity-100 {
    &:is(:where(.group\\/menu-item):focus-within *) {
      opacity: 100% !important;
    }
  }
  .group-hover\\:scale-\\[1\\.03\\] {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        scale: 1.03 !important;
      }
    }
  }
  .group-hover\\/menu-item\\:opacity-100 {
    &:is(:where(.group\\/menu-item):hover *) {
      @media (hover: hover) {
        opacity: 100% !important;
      }
    }
  }
  .group-hover\\/user-menu\\:scale-105 {
    &:is(:where(.group\\/user-menu):hover *) {
      @media (hover: hover) {
        --tw-scale-x: 105% !important;
        --tw-scale-y: 105% !important;
        --tw-scale-z: 105% !important;
        scale: var(--tw-scale-x) var(--tw-scale-y) !important;
      }
    }
  }
  .group-hover\\/user-menu\\:ring-2 {
    &:is(:where(.group\\/user-menu):hover *) {
      @media (hover: hover) {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
      }
    }
  }
  .group-focus-visible\\/user-menu\\:ring-2 {
    &:is(:where(.group\\/user-menu):focus-visible *) {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .group-has-data-\\[sidebar\\=menu-action\\]\\/menu-item\\:pr-8 {
    &:is(:where(.group\\/menu-item):has(*[data-sidebar="menu-action"]) *) {
      padding-right: calc(var(--spacing) * 8) !important;
    }
  }
  .group-has-data-\\[size\\=lg\\]\\/avatar-group\\:size-10 {
    &:is(:where(.group\\/avatar-group):has(*[data-size="lg"]) *) {
      width: calc(var(--spacing) * 10) !important;
      height: calc(var(--spacing) * 10) !important;
    }
  }
  .group-has-data-\\[size\\=sm\\]\\/avatar-group\\:size-6 {
    &:is(:where(.group\\/avatar-group):has(*[data-size="sm"]) *) {
      width: calc(var(--spacing) * 6) !important;
      height: calc(var(--spacing) * 6) !important;
    }
  }
  .group-has-\\[\\[data-orientation\\=horizontal\\]\\]\\/field\\:text-balance {
    &:is(:where(.group\\/field):has(*:is([data-orientation=horizontal])) *) {
      text-wrap: balance !important;
    }
  }
  .group-has-\\[\\[data-slot\\=item-description\\]\\]\\/item\\:translate-y-0\\.5 {
    &:is(:where(.group\\/item):has(*:is([data-slot=item-description])) *) {
      --tw-translate-y: calc(var(--spacing) * 0.5) !important;
      translate: var(--tw-translate-x) var(--tw-translate-y) !important;
    }
  }
  .group-has-\\[\\[data-slot\\=item-description\\]\\]\\/item\\:self-start {
    &:is(:where(.group\\/item):has(*:is([data-slot=item-description])) *) {
      align-self: flex-start !important;
    }
  }
  .group-has-\\[\\>input\\]\\/input-group\\:pt-2\\.5 {
    &:is(:where(.group\\/input-group):has(>input) *) {
      padding-top: calc(var(--spacing) * 2.5) !important;
    }
  }
  .group-has-\\[\\>input\\]\\/input-group\\:pb-2\\.5 {
    &:is(:where(.group\\/input-group):has(>input) *) {
      padding-bottom: calc(var(--spacing) * 2.5) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:-mt-8 {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      margin-top: calc(var(--spacing) * -8) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:hidden {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      display: none !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:size-8\\! {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      width: calc(var(--spacing) * 8) !important;
      height: calc(var(--spacing) * 8) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:size-10 {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      width: calc(var(--spacing) * 10) !important;
      height: calc(var(--spacing) * 10) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:size-10\\! {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      width: calc(var(--spacing) * 10) !important;
      height: calc(var(--spacing) * 10) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:w-\\(--sidebar-width-icon\\) {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      width: var(--sidebar-width-icon) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)\\+\\(--spacing\\(4\\)\\)\\)\\] {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      width: calc(var(--sidebar-width-icon) + (calc(var(--spacing) * 4))) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:w-\\[calc\\(var\\(--sidebar-width-icon\\)\\+\\(--spacing\\(4\\)\\)\\+2px\\)\\] {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      width: calc(var(--sidebar-width-icon) + (calc(var(--spacing) * 4)) + 2px) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:items-center {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      align-items: center !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:items-start {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      align-items: flex-start !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:justify-center {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      justify-content: center !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:overflow-hidden {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      overflow: hidden !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:overflow-visible {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      overflow: visible !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:rounded-full {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      border-radius: calc(infinity * 1px) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:border-0 {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      border-style: var(--tw-border-style) !important;
      border-width: 0px !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:bg-transparent\\! {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      background-color: transparent !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:p-0\\! {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      padding: calc(var(--spacing) * 0) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:p-2\\! {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      padding: calc(var(--spacing) * 2) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:p-2\\.5\\! {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      padding: calc(var(--spacing) * 2.5) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:px-2 {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      padding-inline: calc(var(--spacing) * 2) !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:opacity-0 {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      opacity: 0% !important;
    }
  }
  .group-data-\\[collapsible\\=offcanvas\\]\\:right-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\] {
    &:is(:where(.group)[data-collapsible="offcanvas"] *) {
      right: calc(var(--sidebar-width) * -1) !important;
    }
  }
  .group-data-\\[collapsible\\=offcanvas\\]\\:left-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\] {
    &:is(:where(.group)[data-collapsible="offcanvas"] *) {
      left: calc(var(--sidebar-width) * -1) !important;
    }
  }
  .group-data-\\[collapsible\\=offcanvas\\]\\:w-0 {
    &:is(:where(.group)[data-collapsible="offcanvas"] *) {
      width: calc(var(--spacing) * 0) !important;
    }
  }
  .group-data-\\[collapsible\\=offcanvas\\]\\:translate-x-0 {
    &:is(:where(.group)[data-collapsible="offcanvas"] *) {
      --tw-translate-x: calc(var(--spacing) * 0) !important;
      translate: var(--tw-translate-x) var(--tw-translate-y) !important;
    }
  }
  .group-data-\\[disabled\\=true\\]\\:pointer-events-none {
    &:is(:where(.group)[data-disabled="true"] *) {
      pointer-events: none !important;
    }
  }
  .group-data-\\[disabled\\=true\\]\\:opacity-50 {
    &:is(:where(.group)[data-disabled="true"] *) {
      opacity: 50% !important;
    }
  }
  .group-data-\\[disabled\\=true\\]\\/field\\:opacity-50 {
    &:is(:where(.group\\/field)[data-disabled="true"] *) {
      opacity: 50% !important;
    }
  }
  .group-data-\\[disabled\\=true\\]\\/input-group\\:opacity-50 {
    &:is(:where(.group\\/input-group)[data-disabled="true"] *) {
      opacity: 50% !important;
    }
  }
  .group-data-\\[focused\\=true\\]\\/day\\:relative {
    &:is(:where(.group\\/day)[data-focused="true"] *) {
      position: relative !important;
    }
  }
  .group-data-\\[focused\\=true\\]\\/day\\:z-10 {
    &:is(:where(.group\\/day)[data-focused="true"] *) {
      z-index: 10 !important;
    }
  }
  .group-data-\\[focused\\=true\\]\\/day\\:border-ring {
    &:is(:where(.group\\/day)[data-focused="true"] *) {
      border-color: var(--ring) !important;
    }
  }
  .group-data-\\[focused\\=true\\]\\/day\\:ring-\\[3px\\] {
    &:is(:where(.group\\/day)[data-focused="true"] *) {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .group-data-\\[focused\\=true\\]\\/day\\:ring-ring\\/50 {
    &:is(:where(.group\\/day)[data-focused="true"] *) {
      --tw-ring-color: var(--ring) !important;
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--ring) 50%, transparent) !important;
      }
    }
  }
  .group-data-\\[orientation\\=horizontal\\]\\/tabs\\:h-9 {
    &:is(:where(.group\\/tabs)[data-orientation="horizontal"] *) {
      height: calc(var(--spacing) * 9) !important;
    }
  }
  .group-data-\\[orientation\\=horizontal\\]\\/tabs\\:h-auto {
    &:is(:where(.group\\/tabs)[data-orientation="horizontal"] *) {
      height: auto !important;
    }
  }
  .group-data-\\[orientation\\=vertical\\]\\/tabs\\:h-fit {
    &:is(:where(.group\\/tabs)[data-orientation="vertical"] *) {
      height: fit-content !important;
    }
  }
  .group-data-\\[orientation\\=vertical\\]\\/tabs\\:w-full {
    &:is(:where(.group\\/tabs)[data-orientation="vertical"] *) {
      width: 100% !important;
    }
  }
  .group-data-\\[orientation\\=vertical\\]\\/tabs\\:flex-col {
    &:is(:where(.group\\/tabs)[data-orientation="vertical"] *) {
      flex-direction: column !important;
    }
  }
  .group-data-\\[orientation\\=vertical\\]\\/tabs\\:justify-start {
    &:is(:where(.group\\/tabs)[data-orientation="vertical"] *) {
      justify-content: flex-start !important;
    }
  }
  .group-data-\\[side\\=left\\]\\:-right-4 {
    &:is(:where(.group)[data-side="left"] *) {
      right: calc(var(--spacing) * -4) !important;
    }
  }
  .group-data-\\[side\\=left\\]\\:border-r {
    &:is(:where(.group)[data-side="left"] *) {
      border-right-style: var(--tw-border-style) !important;
      border-right-width: 1px !important;
    }
  }
  .group-data-\\[side\\=right\\]\\:left-0 {
    &:is(:where(.group)[data-side="right"] *) {
      left: calc(var(--spacing) * 0) !important;
    }
  }
  .group-data-\\[side\\=right\\]\\:rotate-180 {
    &:is(:where(.group)[data-side="right"] *) {
      rotate: 180deg !important;
    }
  }
  .group-data-\\[side\\=right\\]\\:border-l {
    &:is(:where(.group)[data-side="right"] *) {
      border-left-style: var(--tw-border-style) !important;
      border-left-width: 1px !important;
    }
  }
  .group-data-\\[size\\=default\\]\\/avatar\\:size-2\\.5 {
    &:is(:where(.group\\/avatar)[data-size="default"] *) {
      width: calc(var(--spacing) * 2.5) !important;
      height: calc(var(--spacing) * 2.5) !important;
    }
  }
  .group-data-\\[size\\=default\\]\\/switch\\:size-4 {
    &:is(:where(.group\\/switch)[data-size="default"] *) {
      width: calc(var(--spacing) * 4) !important;
      height: calc(var(--spacing) * 4) !important;
    }
  }
  .group-data-\\[size\\=lg\\]\\/avatar\\:size-3 {
    &:is(:where(.group\\/avatar)[data-size="lg"] *) {
      width: calc(var(--spacing) * 3) !important;
      height: calc(var(--spacing) * 3) !important;
    }
  }
  .group-data-\\[size\\=lg\\]\\/avatar\\:text-base {
    &:is(:where(.group\\/avatar)[data-size="lg"] *) {
      font-size: var(--text-base) !important;
      line-height: var(--tw-leading, var(--text-base--line-height)) !important;
    }
  }
  .group-data-\\[size\\=sm\\]\\/avatar\\:size-2 {
    &:is(:where(.group\\/avatar)[data-size="sm"] *) {
      width: calc(var(--spacing) * 2) !important;
      height: calc(var(--spacing) * 2) !important;
    }
  }
  .group-data-\\[size\\=sm\\]\\/avatar\\:text-xs {
    &:is(:where(.group\\/avatar)[data-size="sm"] *) {
      font-size: var(--text-xs) !important;
      line-height: var(--tw-leading, var(--text-xs--line-height)) !important;
    }
  }
  .group-data-\\[size\\=sm\\]\\/switch\\:size-3 {
    &:is(:where(.group\\/switch)[data-size="sm"] *) {
      width: calc(var(--spacing) * 3) !important;
      height: calc(var(--spacing) * 3) !important;
    }
  }
  .group-data-\\[state\\=open\\]\\:rotate-180 {
    &:is(:where(.group)[data-state="open"] *) {
      rotate: 180deg !important;
    }
  }
  .group-data-\\[state\\=open\\]\\/collapsible\\:rotate-90 {
    &:is(:where(.group\\/collapsible)[data-state="open"] *) {
      rotate: 90deg !important;
    }
  }
  .group-data-\\[state\\=open\\]\\/user-menu\\:ring-2 {
    &:is(:where(.group\\/user-menu)[data-state="open"] *) {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .group-data-\\[variant\\=floating\\]\\:rounded-lg {
    &:is(:where(.group)[data-variant="floating"] *) {
      border-radius: 0.375rem !important;
    }
  }
  .group-data-\\[variant\\=floating\\]\\:border {
    &:is(:where(.group)[data-variant="floating"] *) {
      border-style: var(--tw-border-style) !important;
      border-width: 1px !important;
    }
  }
  .group-data-\\[variant\\=floating\\]\\:border-sidebar-border {
    &:is(:where(.group)[data-variant="floating"] *) {
      border-color: var(--sidebar-border) !important;
    }
  }
  .group-data-\\[variant\\=floating\\]\\:shadow-sm {
    &:is(:where(.group)[data-variant="floating"] *) {
      --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .group-data-\\[variant\\=line\\]\\/tabs-list\\:bg-transparent {
    &:is(:where(.group\\/tabs-list)[data-variant="line"] *) {
      background-color: transparent !important;
    }
  }
  .group-data-\\[variant\\=outline\\]\\/field-group\\:-mb-2 {
    &:is(:where(.group\\/field-group)[data-variant="outline"] *) {
      margin-bottom: calc(var(--spacing) * -2) !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:top-0 {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      top: calc(var(--spacing) * 0) !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:top-full {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      top: 100% !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:left-full {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      left: 100% !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:mt-0 {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      margin-top: calc(var(--spacing) * 0) !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:mt-1\\.5 {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      margin-top: calc(var(--spacing) * 1.5) !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:ml-3 {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      margin-left: calc(var(--spacing) * 3) !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:overflow-hidden {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      overflow: hidden !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:rounded-md {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      border-radius: 0.25rem !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:border {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      border-style: var(--tw-border-style) !important;
      border-width: 1px !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:bg-popover {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      background-color: var(--popover) !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:text-popover-foreground {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      color: var(--popover-foreground) !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:shadow {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:shadow-lg {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1)) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:duration-200 {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      --tw-duration: 200ms !important;
      transition-duration: 200ms !important;
    }
  }
  .peer-hover\\/menu-button\\:text-sidebar-accent-foreground {
    &:is(:where(.peer\\/menu-button):hover ~ *) {
      @media (hover: hover) {
        color: var(--sidebar-accent-foreground) !important;
      }
    }
  }
  .peer-disabled\\:cursor-not-allowed {
    &:is(:where(.peer):disabled ~ *) {
      cursor: not-allowed !important;
    }
  }
  .peer-disabled\\:opacity-50 {
    &:is(:where(.peer):disabled ~ *) {
      opacity: 50% !important;
    }
  }
  .peer-data-\\[active\\=true\\]\\/menu-button\\:text-sidebar-accent-foreground {
    &:is(:where(.peer\\/menu-button)[data-active="true"] ~ *) {
      color: var(--sidebar-accent-foreground) !important;
    }
  }
  .peer-data-\\[size\\=default\\]\\/menu-button\\:top-1\\.5 {
    &:is(:where(.peer\\/menu-button)[data-size="default"] ~ *) {
      top: calc(var(--spacing) * 1.5) !important;
    }
  }
  .peer-data-\\[size\\=lg\\]\\/menu-button\\:top-2\\.5 {
    &:is(:where(.peer\\/menu-button)[data-size="lg"] ~ *) {
      top: calc(var(--spacing) * 2.5) !important;
    }
  }
  .peer-data-\\[size\\=sm\\]\\/menu-button\\:top-1 {
    &:is(:where(.peer\\/menu-button)[data-size="sm"] ~ *) {
      top: calc(var(--spacing) * 1) !important;
    }
  }
  .selection\\:bg-primary {
    & *::selection {
      background-color: var(--primary) !important;
    }
    &::selection {
      background-color: var(--primary) !important;
    }
  }
  .selection\\:text-primary-foreground {
    & *::selection {
      color: var(--primary-foreground) !important;
    }
    &::selection {
      color: var(--primary-foreground) !important;
    }
  }
  .file\\:-ms-2 {
    &::file-selector-button {
      margin-inline-start: calc(var(--spacing) * -2) !important;
    }
  }
  .file\\:inline-flex {
    &::file-selector-button {
      display: inline-flex !important;
    }
  }
  .file\\:h-6\\.5 {
    &::file-selector-button {
      height: calc(var(--spacing) * 6.5) !important;
    }
  }
  .file\\:cursor-pointer {
    &::file-selector-button {
      cursor: pointer !important;
    }
  }
  .file\\:rounded-sm {
    &::file-selector-button {
      border-radius: 0.1875rem !important;
    }
  }
  .file\\:border-0 {
    &::file-selector-button {
      border-style: var(--tw-border-style) !important;
      border-width: 0px !important;
    }
  }
  .file\\:bg-transparent {
    &::file-selector-button {
      background-color: transparent !important;
    }
  }
  .file\\:px-2 {
    &::file-selector-button {
      padding-inline: calc(var(--spacing) * 2) !important;
    }
  }
  .file\\:text-sm {
    &::file-selector-button {
      font-size: var(--text-sm) !important;
      line-height: var(--tw-leading, var(--text-sm--line-height)) !important;
    }
  }
  .file\\:font-semibold {
    &::file-selector-button {
      --tw-font-weight: var(--font-weight-semibold) !important;
      font-weight: var(--font-weight-semibold) !important;
    }
  }
  .file\\:text-primary-600 {
    &::file-selector-button {
      color: var(--blue-600) !important;
    }
  }
  .placeholder\\:text-muted-foreground {
    &::placeholder {
      color: var(--muted-foreground) !important;
    }
  }
  .after\\:absolute {
    &::after {
      content: var(--tw-content);
      position: absolute !important;
    }
  }
  .after\\:-inset-2 {
    &::after {
      content: var(--tw-content);
      inset: calc(var(--spacing) * -2) !important;
    }
  }
  .after\\:inset-0 {
    &::after {
      content: var(--tw-content);
      inset: calc(var(--spacing) * 0) !important;
    }
  }
  .after\\:inset-y-0 {
    &::after {
      content: var(--tw-content);
      inset-block: calc(var(--spacing) * 0) !important;
    }
  }
  .after\\:left-1\\/2 {
    &::after {
      content: var(--tw-content);
      left: calc(1 / 2 * 100%) !important;
    }
  }
  .after\\:z-10 {
    &::after {
      content: var(--tw-content);
      z-index: 10 !important;
    }
  }
  .after\\:w-\\[2px\\] {
    &::after {
      content: var(--tw-content);
      width: 2px !important;
    }
  }
  .after\\:bg-primary-600 {
    &::after {
      content: var(--tw-content);
      background-color: var(--blue-600) !important;
    }
  }
  .after\\:opacity-0 {
    &::after {
      content: var(--tw-content);
      opacity: 0% !important;
    }
  }
  .after\\:transition-opacity {
    &::after {
      content: var(--tw-content);
      transition-property: opacity !important;
      transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
      transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
    }
  }
  .group-data-\\[collapsible\\=offcanvas\\]\\:after\\:left-full {
    &:is(:where(.group)[data-collapsible="offcanvas"] *) {
      &::after {
        content: var(--tw-content);
        left: 100% !important;
      }
    }
  }
  .group-data-\\[orientation\\=horizontal\\]\\/tabs\\:after\\:inset-x-0 {
    &:is(:where(.group\\/tabs)[data-orientation="horizontal"] *) {
      &::after {
        content: var(--tw-content);
        inset-inline: calc(var(--spacing) * 0) !important;
      }
    }
  }
  .group-data-\\[orientation\\=horizontal\\]\\/tabs\\:after\\:bottom-\\[-1px\\] {
    &:is(:where(.group\\/tabs)[data-orientation="horizontal"] *) {
      &::after {
        content: var(--tw-content);
        bottom: -1px !important;
      }
    }
  }
  .group-data-\\[orientation\\=horizontal\\]\\/tabs\\:after\\:bottom-\\[-5px\\] {
    &:is(:where(.group\\/tabs)[data-orientation="horizontal"] *) {
      &::after {
        content: var(--tw-content);
        bottom: -5px !important;
      }
    }
  }
  .group-data-\\[orientation\\=horizontal\\]\\/tabs\\:after\\:h-0\\.5 {
    &:is(:where(.group\\/tabs)[data-orientation="horizontal"] *) {
      &::after {
        content: var(--tw-content);
        height: calc(var(--spacing) * 0.5) !important;
      }
    }
  }
  .group-data-\\[orientation\\=vertical\\]\\/tabs\\:after\\:inset-y-0 {
    &:is(:where(.group\\/tabs)[data-orientation="vertical"] *) {
      &::after {
        content: var(--tw-content);
        inset-block: calc(var(--spacing) * 0) !important;
      }
    }
  }
  .group-data-\\[orientation\\=vertical\\]\\/tabs\\:after\\:-right-1 {
    &:is(:where(.group\\/tabs)[data-orientation="vertical"] *) {
      &::after {
        content: var(--tw-content);
        right: calc(var(--spacing) * -1) !important;
      }
    }
  }
  .group-data-\\[orientation\\=vertical\\]\\/tabs\\:after\\:w-0\\.5 {
    &:is(:where(.group\\/tabs)[data-orientation="vertical"] *) {
      &::after {
        content: var(--tw-content);
        width: calc(var(--spacing) * 0.5) !important;
      }
    }
  }
  .last\\:mt-0 {
    &:last-child {
      margin-top: calc(var(--spacing) * 0) !important;
    }
  }
  .last\\:pb-0 {
    &:last-child {
      padding-bottom: calc(var(--spacing) * 0) !important;
    }
  }
  .focus-within\\:border-ring {
    &:focus-within {
      border-color: var(--ring) !important;
    }
  }
  .focus-within\\:ring-\\[3px\\] {
    &:focus-within {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .focus-within\\:ring-ring\\/50 {
    &:focus-within {
      --tw-ring-color: var(--ring) !important;
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--ring) 50%, transparent) !important;
      }
    }
  }
  .hover\\:-translate-y-0\\.5 {
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * -0.5) !important;
        translate: var(--tw-translate-x) var(--tw-translate-y) !important;
      }
    }
  }
  .hover\\:border-primary-300 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--blue-300) !important;
      }
    }
  }
  .hover\\:bg-accent {
    &:hover {
      @media (hover: hover) {
        background-color: var(--accent) !important;
      }
    }
  }
  .hover\\:bg-black\\/70 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--black) !important;
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--black) 70%, transparent) !important;
        }
      }
    }
  }
  .hover\\:bg-black\\/80 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--black) !important;
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--black) 80%, transparent) !important;
        }
      }
    }
  }
  .hover\\:bg-danger-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--red-100) !important;
      }
    }
  }
  .hover\\:bg-danger-700 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--red-700) !important;
      }
    }
  }
  .hover\\:bg-muted\\/50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--muted) !important;
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--muted) 50%, transparent) !important;
        }
      }
    }
  }
  .hover\\:bg-neutral-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--neutral-100) !important;
      }
    }
  }
  .hover\\:bg-neutral-alpha-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--neutral-alpha-100) !important;
      }
    }
  }
  .hover\\:bg-neutral-alpha-300 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--neutral-alpha-300) !important;
      }
    }
  }
  .hover\\:bg-primary-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--blue-100) !important;
      }
    }
  }
  .hover\\:bg-primary-700 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--blue-700) !important;
      }
    }
  }
  .hover\\:bg-sidebar-accent {
    &:hover {
      @media (hover: hover) {
        background-color: var(--sidebar-accent) !important;
      }
    }
  }
  .hover\\:bg-success-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--green-100) !important;
      }
    }
  }
  .hover\\:bg-success-700 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--green-700) !important;
      }
    }
  }
  .hover\\:bg-transparent {
    &:hover {
      @media (hover: hover) {
        background-color: transparent !important;
      }
    }
  }
  .hover\\:bg-warning-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--warning-100) !important;
      }
    }
  }
  .hover\\:text-accent-foreground {
    &:hover {
      @media (hover: hover) {
        color: var(--accent-foreground) !important;
      }
    }
  }
  .hover\\:text-danger-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--red-700) !important;
      }
    }
  }
  .hover\\:text-foreground {
    &:hover {
      @media (hover: hover) {
        color: var(--foreground) !important;
      }
    }
  }
  .hover\\:text-neutral-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--neutral-700) !important;
      }
    }
  }
  .hover\\:text-neutral-alpha-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--neutral-alpha-700) !important;
      }
    }
  }
  .hover\\:text-primary {
    &:hover {
      @media (hover: hover) {
        color: var(--primary) !important;
      }
    }
  }
  .hover\\:text-primary-600 {
    &:hover {
      @media (hover: hover) {
        color: var(--blue-600) !important;
      }
    }
  }
  .hover\\:text-primary-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--blue-700) !important;
      }
    }
  }
  .hover\\:text-sidebar-accent-foreground {
    &:hover {
      @media (hover: hover) {
        color: var(--sidebar-accent-foreground) !important;
      }
    }
  }
  .hover\\:text-success-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--green-700) !important;
      }
    }
  }
  .hover\\:text-white {
    &:hover {
      @media (hover: hover) {
        color: var(--white) !important;
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline !important;
      }
    }
  }
  .hover\\:opacity-100 {
    &:hover {
      @media (hover: hover) {
        opacity: 100% !important;
      }
    }
  }
  .hover\\:shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-accent\\)\\)\\] {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 0 0 1px var(--tw-shadow-color, hsl(var(--sidebar-accent))) !important;
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
      }
    }
  }
  .hover\\:shadow-md {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1)) !important;
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
      }
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:hover\\:bg-transparent\\! {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      &:hover {
        @media (hover: hover) {
          background-color: transparent !important;
        }
      }
    }
  }
  .hover\\:group-data-\\[collapsible\\=offcanvas\\]\\:bg-sidebar {
    &:hover {
      @media (hover: hover) {
        &:is(:where(.group)[data-collapsible="offcanvas"] *) {
          background-color: var(--sidebar) !important;
        }
      }
    }
  }
  .file\\:hover\\:bg-primary-100 {
    &::file-selector-button {
      &:hover {
        @media (hover: hover) {
          background-color: var(--blue-100) !important;
        }
      }
    }
  }
  .file\\:hover\\:text-primary-700 {
    &::file-selector-button {
      &:hover {
        @media (hover: hover) {
          color: var(--blue-700) !important;
        }
      }
    }
  }
  .hover\\:after\\:bg-sidebar-border {
    &:hover {
      @media (hover: hover) {
        &::after {
          content: var(--tw-content);
          background-color: var(--sidebar-border) !important;
        }
      }
    }
  }
  .focus\\:bg-accent {
    &:focus {
      background-color: var(--accent) !important;
    }
  }
  .focus\\:bg-neutral-alpha-200 {
    &:focus {
      background-color: var(--neutral-alpha-200) !important;
    }
  }
  .focus\\:bg-primary-100 {
    &:focus {
      background-color: var(--blue-100) !important;
    }
  }
  .focus\\:text-accent-foreground {
    &:focus {
      color: var(--accent-foreground) !important;
    }
  }
  .focus\\:text-neutral-alpha-700 {
    &:focus {
      color: var(--neutral-alpha-700) !important;
    }
  }
  .focus\\:text-primary-700 {
    &:focus {
      color: var(--blue-700) !important;
    }
  }
  .focus\\:ring-2 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .focus\\:ring-ring {
    &:focus {
      --tw-ring-color: var(--ring) !important;
    }
  }
  .focus\\:ring-offset-2 {
    &:focus {
      --tw-ring-offset-width: 2px !important;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    }
  }
  .focus\\:outline-hidden {
    &:focus {
      --tw-outline-style: none !important;
      outline-style: none !important;
      @media (forced-colors: active) {
        outline: 2px solid transparent !important;
        outline-offset: 2px !important;
      }
    }
  }
  .focus-visible\\:border-ring {
    &:focus-visible {
      border-color: var(--ring) !important;
    }
  }
  .focus-visible\\:ring-0 {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .focus-visible\\:ring-2 {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .focus-visible\\:ring-\\[3px\\] {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .focus-visible\\:ring-ring {
    &:focus-visible {
      --tw-ring-color: var(--ring) !important;
    }
  }
  .focus-visible\\:ring-ring\\/50 {
    &:focus-visible {
      --tw-ring-color: var(--ring) !important;
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--ring) 50%, transparent) !important;
      }
    }
  }
  .focus-visible\\:ring-offset-2 {
    &:focus-visible {
      --tw-ring-offset-width: 2px !important;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    }
  }
  .focus-visible\\:outline-1 {
    &:focus-visible {
      outline-style: var(--tw-outline-style) !important;
      outline-width: 1px !important;
    }
  }
  .focus-visible\\:outline-2 {
    &:focus-visible {
      outline-style: var(--tw-outline-style) !important;
      outline-width: 2px !important;
    }
  }
  .focus-visible\\:outline-offset-2 {
    &:focus-visible {
      outline-offset: 2px !important;
    }
  }
  .focus-visible\\:outline-ring {
    &:focus-visible {
      outline-color: var(--ring) !important;
    }
  }
  .focus-visible\\:outline-none {
    &:focus-visible {
      --tw-outline-style: none !important;
      outline-style: none !important;
    }
  }
  .active\\:bg-danger-200 {
    &:active {
      background-color: var(--red-200) !important;
    }
  }
  .active\\:bg-danger-800 {
    &:active {
      background-color: var(--red-800) !important;
    }
  }
  .active\\:bg-neutral-200 {
    &:active {
      background-color: var(--neutral-200) !important;
    }
  }
  .active\\:bg-neutral-alpha-200 {
    &:active {
      background-color: var(--neutral-alpha-200) !important;
    }
  }
  .active\\:bg-primary-200 {
    &:active {
      background-color: var(--blue-200) !important;
    }
  }
  .active\\:bg-primary-800 {
    &:active {
      background-color: var(--blue-800) !important;
    }
  }
  .active\\:bg-sidebar-accent {
    &:active {
      background-color: var(--sidebar-accent) !important;
    }
  }
  .active\\:bg-success-200 {
    &:active {
      background-color: var(--green-200) !important;
    }
  }
  .active\\:bg-success-800 {
    &:active {
      background-color: var(--green-800) !important;
    }
  }
  .active\\:text-danger-700 {
    &:active {
      color: var(--red-700) !important;
    }
  }
  .active\\:text-neutral-700 {
    &:active {
      color: var(--neutral-700) !important;
    }
  }
  .active\\:text-primary-700 {
    &:active {
      color: var(--blue-700) !important;
    }
  }
  .active\\:text-primary-800 {
    &:active {
      color: var(--blue-800) !important;
    }
  }
  .active\\:text-sidebar-accent-foreground {
    &:active {
      color: var(--sidebar-accent-foreground) !important;
    }
  }
  .active\\:text-success-700 {
    &:active {
      color: var(--green-700) !important;
    }
  }
  .file\\:active\\:bg-primary-200 {
    &::file-selector-button {
      &:active {
        background-color: var(--blue-200) !important;
      }
    }
  }
  .file\\:active\\:text-primary-700 {
    &::file-selector-button {
      &:active {
        color: var(--blue-700) !important;
      }
    }
  }
  .disabled\\:pointer-events-none {
    &:disabled {
      pointer-events: none !important;
    }
  }
  .disabled\\:hidden {
    &:disabled {
      display: none !important;
    }
  }
  .disabled\\:cursor-not-allowed {
    &:disabled {
      cursor: not-allowed !important;
    }
  }
  .disabled\\:opacity-50 {
    &:disabled {
      opacity: 50% !important;
    }
  }
  .disabled\\:opacity-60 {
    &:disabled {
      opacity: 60% !important;
    }
  }
  .disabled\\:hover\\:bg-transparent {
    &:disabled {
      &:hover {
        @media (hover: hover) {
          background-color: transparent !important;
        }
      }
    }
  }
  .in-data-\\[side\\=left\\]\\:cursor-w-resize {
    :where(*[data-side="left"]) & {
      cursor: w-resize !important;
    }
  }
  .in-data-\\[side\\=right\\]\\:cursor-e-resize {
    :where(*[data-side="right"]) & {
      cursor: e-resize !important;
    }
  }
  .has-focus\\:border-ring {
    &:has(*:focus) {
      border-color: var(--ring) !important;
    }
  }
  .has-focus\\:ring-\\[3px\\] {
    &:has(*:focus) {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .has-focus\\:ring-ring\\/50 {
    &:has(*:focus) {
      --tw-ring-color: var(--ring) !important;
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--ring) 50%, transparent) !important;
      }
    }
  }
  .has-data-\\[slot\\=card-action\\]\\:grid-cols-\\[1fr_auto\\] {
    &:has(*[data-slot="card-action"]) {
      grid-template-columns: 1fr auto !important;
    }
  }
  .has-data-\\[state\\=checked\\]\\:border-primary {
    &:has(*[data-state="checked"]) {
      border-color: var(--primary) !important;
    }
  }
  .has-data-\\[state\\=checked\\]\\:bg-primary\\/5 {
    &:has(*[data-state="checked"]) {
      background-color: var(--primary) !important;
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--primary) 5%, transparent) !important;
      }
    }
  }
  .has-data-\\[variant\\=inset\\]\\:bg-sidebar {
    &:has(*[data-variant="inset"]) {
      background-color: var(--sidebar) !important;
    }
  }
  .has-\\[\\:focus-visible\\]\\:ring-2 {
    &:has(*:is(:focus-visible)) {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .has-\\[\\:focus-visible\\]\\:ring-ring {
    &:has(*:is(:focus-visible)) {
      --tw-ring-color: var(--ring) !important;
    }
  }
  .has-\\[\\[data-slot\\=input-group-control\\]\\:focus-visible\\]\\:border-ring {
    &:has(*:is([data-slot=input-group-control]:focus-visible)) {
      border-color: var(--ring) !important;
    }
  }
  .has-\\[\\[data-slot\\=input-group-control\\]\\:focus-visible\\]\\:ring-\\[3px\\] {
    &:has(*:is([data-slot=input-group-control]:focus-visible)) {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
  .has-\\[\\[data-slot\\=input-group-control\\]\\:focus-visible\\]\\:ring-ring\\/50 {
    &:has(*:is([data-slot=input-group-control]:focus-visible)) {
      --tw-ring-color: var(--ring) !important;
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--ring) 50%, transparent) !important;
      }
    }
  }
  .has-\\[\\[data-slot\\]\\[aria-invalid\\=true\\]\\]\\:border-destructive {
    &:has(*:is([data-slot][aria-invalid=true])) {
      border-color: var(--destructive) !important;
    }
  }
  .has-\\[\\[data-slot\\]\\[aria-invalid\\=true\\]\\]\\:ring-destructive\\/20 {
    &:has(*:is([data-slot][aria-invalid=true])) {
      --tw-ring-color: var(--destructive) !important;
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--destructive) 20%, transparent) !important;
      }
    }
  }
  .has-\\[\\>\\[data-align\\=block-end\\]\\]\\:h-auto {
    &:has(>[data-align=block-end]) {
      height: auto !important;
    }
  }
  .has-\\[\\>\\[data-align\\=block-end\\]\\]\\:flex-col {
    &:has(>[data-align=block-end]) {
      flex-direction: column !important;
    }
  }
  .has-\\[\\>\\[data-align\\=block-start\\]\\]\\:h-auto {
    &:has(>[data-align=block-start]) {
      height: auto !important;
    }
  }
  .has-\\[\\>\\[data-align\\=block-start\\]\\]\\:flex-col {
    &:has(>[data-align=block-start]) {
      flex-direction: column !important;
    }
  }
  .has-\\[\\>\\[data-slot\\=checkbox-group\\]\\]\\:gap-3 {
    &:has(>[data-slot=checkbox-group]) {
      gap: calc(var(--spacing) * 3) !important;
    }
  }
  .has-\\[\\>\\[data-slot\\=field-content\\]\\]\\:items-start {
    &:has(>[data-slot=field-content]) {
      align-items: flex-start !important;
    }
  }
  .has-\\[\\>\\[data-slot\\=field\\]\\]\\:w-full {
    &:has(>[data-slot=field]) {
      width: 100% !important;
    }
  }
  .has-\\[\\>\\[data-slot\\=field\\]\\]\\:flex-col {
    &:has(>[data-slot=field]) {
      flex-direction: column !important;
    }
  }
  .has-\\[\\>\\[data-slot\\=field\\]\\]\\:rounded-md {
    &:has(>[data-slot=field]) {
      border-radius: 0.25rem !important;
    }
  }
  .has-\\[\\>\\[data-slot\\=field\\]\\]\\:border {
    &:has(>[data-slot=field]) {
      border-style: var(--tw-border-style) !important;
      border-width: 1px !important;
    }
  }
  .has-\\[\\>\\[data-slot\\=field\\]\\]\\:border-border {
    &:has(>[data-slot=field]) {
      border-color: var(--border) !important;
    }
  }
  .has-\\[\\>\\[data-slot\\=radio-group\\]\\]\\:gap-3 {
    &:has(>[data-slot=radio-group]) {
      gap: calc(var(--spacing) * 3) !important;
    }
  }
  .has-\\[\\>button\\]\\:mr-\\[-0\\.45rem\\] {
    &:has(>button) {
      margin-right: -0.45rem !important;
    }
  }
  .has-\\[\\>button\\]\\:ml-\\[-0\\.45rem\\] {
    &:has(>button) {
      margin-left: -0.45rem !important;
    }
  }
  .has-\\[\\>kbd\\]\\:mr-\\[-0\\.35rem\\] {
    &:has(>kbd) {
      margin-right: -0.35rem !important;
    }
  }
  .has-\\[\\>kbd\\]\\:ml-\\[-0\\.35rem\\] {
    &:has(>kbd) {
      margin-left: -0.35rem !important;
    }
  }
  .has-\\[\\>svg\\]\\:grid-cols-\\[calc\\(var\\(--spacing\\)\\*4\\)_1fr\\] {
    &:has(>svg) {
      grid-template-columns: calc(var(--spacing) * 4) 1fr !important;
    }
  }
  .has-\\[\\>svg\\]\\:gap-x-3 {
    &:has(>svg) {
      column-gap: calc(var(--spacing) * 3) !important;
    }
  }
  .has-\\[\\>svg\\]\\:p-0 {
    &:has(>svg) {
      padding: calc(var(--spacing) * 0) !important;
    }
  }
  .has-\\[\\>svg\\]\\:px-1\\.5 {
    &:has(>svg) {
      padding-inline: calc(var(--spacing) * 1.5) !important;
    }
  }
  .has-\\[\\>svg\\]\\:px-2 {
    &:has(>svg) {
      padding-inline: calc(var(--spacing) * 2) !important;
    }
  }
  .has-\\[\\>svg\\]\\:px-2\\.5 {
    &:has(>svg) {
      padding-inline: calc(var(--spacing) * 2.5) !important;
    }
  }
  .has-\\[\\>svg\\]\\:px-3 {
    &:has(>svg) {
      padding-inline: calc(var(--spacing) * 3) !important;
    }
  }
  .has-\\[\\>svg\\]\\:px-4 {
    &:has(>svg) {
      padding-inline: calc(var(--spacing) * 4) !important;
    }
  }
  .has-\\[\\>textarea\\]\\:h-auto {
    &:has(>textarea) {
      height: auto !important;
    }
  }
  .aria-disabled\\:pointer-events-none {
    &[aria-disabled="true"] {
      pointer-events: none !important;
    }
  }
  .aria-disabled\\:opacity-50 {
    &[aria-disabled="true"] {
      opacity: 50% !important;
    }
  }
  .aria-invalid\\:border-destructive {
    &[aria-invalid="true"] {
      border-color: var(--destructive) !important;
    }
  }
  .aria-invalid\\:ring-destructive\\/20 {
    &[aria-invalid="true"] {
      --tw-ring-color: var(--destructive) !important;
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--destructive) 20%, transparent) !important;
      }
    }
  }
  .aria-selected\\:text-muted-foreground {
    &[aria-selected="true"] {
      color: var(--muted-foreground) !important;
    }
  }
  .data-\\[active\\]\\:font-semibold {
    &[data-active] {
      --tw-font-weight: var(--font-weight-semibold) !important;
      font-weight: var(--font-weight-semibold) !important;
    }
  }
  .data-\\[active\\]\\:text-primary-600 {
    &[data-active] {
      color: var(--blue-600) !important;
    }
  }
  .data-\\[active\\]\\:hover\\:bg-primary-100 {
    &[data-active] {
      &:hover {
        @media (hover: hover) {
          background-color: var(--blue-100) !important;
        }
      }
    }
  }
  .data-\\[active\\]\\:hover\\:text-primary-700 {
    &[data-active] {
      &:hover {
        @media (hover: hover) {
          color: var(--blue-700) !important;
        }
      }
    }
  }
  .data-\\[active\\=true\\]\\:bg-primary-100 {
    &[data-active="true"] {
      background-color: var(--blue-100) !important;
    }
  }
  .data-\\[active\\=true\\]\\:bg-sidebar-accent {
    &[data-active="true"] {
      background-color: var(--sidebar-accent) !important;
    }
  }
  .data-\\[active\\=true\\]\\:font-medium {
    &[data-active="true"] {
      --tw-font-weight: var(--font-weight-medium) !important;
      font-weight: var(--font-weight-medium) !important;
    }
  }
  .data-\\[active\\=true\\]\\:font-semibold {
    &[data-active="true"] {
      --tw-font-weight: var(--font-weight-semibold) !important;
      font-weight: var(--font-weight-semibold) !important;
    }
  }
  .data-\\[active\\=true\\]\\:text-primary-700 {
    &[data-active="true"] {
      color: var(--blue-700) !important;
    }
  }
  .data-\\[active\\=true\\]\\:text-sidebar-accent-foreground {
    &[data-active="true"] {
      color: var(--sidebar-accent-foreground) !important;
    }
  }
  .data-\\[disabled\\]\\:pointer-events-none {
    &[data-disabled] {
      pointer-events: none !important;
    }
  }
  .data-\\[disabled\\]\\:opacity-50 {
    &[data-disabled] {
      opacity: 50% !important;
    }
  }
  .data-\\[disabled\\=true\\]\\:pointer-events-none {
    &[data-disabled="true"] {
      pointer-events: none !important;
    }
  }
  .data-\\[disabled\\=true\\]\\:opacity-50 {
    &[data-disabled="true"] {
      opacity: 50% !important;
    }
  }
  .data-\\[inset\\]\\:pl-8 {
    &[data-inset] {
      padding-left: calc(var(--spacing) * 8) !important;
    }
  }
  .data-\\[invalid\\=true\\]\\:text-destructive {
    &[data-invalid="true"] {
      color: var(--destructive) !important;
    }
  }
  .data-\\[motion\\=from-end\\]\\:slide-in-from-right-52 {
    &[data-motion="from-end"] {
      --tw-enter-translate-x: calc(52*var(--spacing)) !important;
    }
  }
  .data-\\[motion\\=from-start\\]\\:slide-in-from-left-52 {
    &[data-motion="from-start"] {
      --tw-enter-translate-x: calc(52*var(--spacing)*-1) !important;
    }
  }
  .data-\\[motion\\=to-end\\]\\:slide-out-to-right-52 {
    &[data-motion="to-end"] {
      --tw-exit-translate-x: calc(52*var(--spacing)) !important;
    }
  }
  .data-\\[motion\\=to-start\\]\\:slide-out-to-left-52 {
    &[data-motion="to-start"] {
      --tw-exit-translate-x: calc(52*var(--spacing)*-1) !important;
    }
  }
  .data-\\[motion\\^\\=from-\\]\\:animate-in {
    &[data-motion^="from-"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none) !important;
    }
  }
  .data-\\[motion\\^\\=from-\\]\\:fade-in {
    &[data-motion^="from-"] {
      --tw-enter-opacity: 0 !important;
    }
  }
  .data-\\[motion\\^\\=to-\\]\\:animate-out {
    &[data-motion^="to-"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none) !important;
    }
  }
  .data-\\[motion\\^\\=to-\\]\\:fade-out {
    &[data-motion^="to-"] {
      --tw-exit-opacity: 0 !important;
    }
  }
  .data-\\[orientation\\=horizontal\\]\\:h-px {
    &[data-orientation="horizontal"] {
      height: 1px !important;
    }
  }
  .data-\\[orientation\\=horizontal\\]\\:w-full {
    &[data-orientation="horizontal"] {
      width: 100% !important;
    }
  }
  .data-\\[orientation\\=horizontal\\]\\:flex-col {
    &[data-orientation="horizontal"] {
      flex-direction: column !important;
    }
  }
  .data-\\[orientation\\=vertical\\]\\:h-full {
    &[data-orientation="vertical"] {
      height: 100% !important;
    }
  }
  .data-\\[orientation\\=vertical\\]\\:w-px {
    &[data-orientation="vertical"] {
      width: 1px !important;
    }
  }
  .data-\\[placeholder\\]\\:text-muted-foreground {
    &[data-placeholder] {
      color: var(--muted-foreground) !important;
    }
  }
  .data-\\[range-end\\=true\\]\\:rounded-md {
    &[data-range-end="true"] {
      border-radius: 0.25rem !important;
    }
  }
  .data-\\[range-end\\=true\\]\\:rounded-r-md {
    &[data-range-end="true"] {
      border-top-right-radius: 0.25rem !important;
      border-bottom-right-radius: 0.25rem !important;
    }
  }
  .data-\\[range-end\\=true\\]\\:bg-primary {
    &[data-range-end="true"] {
      background-color: var(--primary) !important;
    }
  }
  .data-\\[range-end\\=true\\]\\:text-primary-foreground {
    &[data-range-end="true"] {
      color: var(--primary-foreground) !important;
    }
  }
  .data-\\[range-middle\\=true\\]\\:rounded-none {
    &[data-range-middle="true"] {
      border-radius: 0 !important;
    }
  }
  .data-\\[range-middle\\=true\\]\\:bg-accent {
    &[data-range-middle="true"] {
      background-color: var(--accent) !important;
    }
  }
  .data-\\[range-middle\\=true\\]\\:text-accent-foreground {
    &[data-range-middle="true"] {
      color: var(--accent-foreground) !important;
    }
  }
  .data-\\[range-start\\=true\\]\\:rounded-md {
    &[data-range-start="true"] {
      border-radius: 0.25rem !important;
    }
  }
  .data-\\[range-start\\=true\\]\\:rounded-l-md {
    &[data-range-start="true"] {
      border-top-left-radius: 0.25rem !important;
      border-bottom-left-radius: 0.25rem !important;
    }
  }
  .data-\\[range-start\\=true\\]\\:bg-primary {
    &[data-range-start="true"] {
      background-color: var(--primary) !important;
    }
  }
  .data-\\[range-start\\=true\\]\\:text-primary-foreground {
    &[data-range-start="true"] {
      color: var(--primary-foreground) !important;
    }
  }
  .data-\\[selected-single\\=true\\]\\:bg-primary {
    &[data-selected-single="true"] {
      background-color: var(--primary) !important;
    }
  }
  .data-\\[selected-single\\=true\\]\\:text-primary-foreground {
    &[data-selected-single="true"] {
      color: var(--primary-foreground) !important;
    }
  }
  .data-\\[selected\\=true\\]\\:rounded-none {
    &[data-selected="true"] {
      border-radius: 0 !important;
    }
  }
  .data-\\[selected\\=true\\]\\:bg-accent {
    &[data-selected="true"] {
      background-color: var(--accent) !important;
    }
  }
  .data-\\[selected\\=true\\]\\:text-accent-foreground {
    &[data-selected="true"] {
      color: var(--accent-foreground) !important;
    }
  }
  .data-\\[side\\=bottom\\]\\:translate-y-1 {
    &[data-side="bottom"] {
      --tw-translate-y: calc(var(--spacing) * 1) !important;
      translate: var(--tw-translate-x) var(--tw-translate-y) !important;
    }
  }
  .data-\\[side\\=bottom\\]\\:slide-in-from-top-2 {
    &[data-side="bottom"] {
      --tw-enter-translate-y: calc(2*var(--spacing)*-1) !important;
    }
  }
  .data-\\[side\\=left\\]\\:-translate-x-1 {
    &[data-side="left"] {
      --tw-translate-x: calc(var(--spacing) * -1) !important;
      translate: var(--tw-translate-x) var(--tw-translate-y) !important;
    }
  }
  .data-\\[side\\=left\\]\\:slide-in-from-right-2 {
    &[data-side="left"] {
      --tw-enter-translate-x: calc(2*var(--spacing)) !important;
    }
  }
  .data-\\[side\\=right\\]\\:translate-x-1 {
    &[data-side="right"] {
      --tw-translate-x: calc(var(--spacing) * 1) !important;
      translate: var(--tw-translate-x) var(--tw-translate-y) !important;
    }
  }
  .data-\\[side\\=right\\]\\:slide-in-from-left-2 {
    &[data-side="right"] {
      --tw-enter-translate-x: calc(2*var(--spacing)*-1) !important;
    }
  }
  .data-\\[side\\=top\\]\\:-translate-y-1 {
    &[data-side="top"] {
      --tw-translate-y: calc(var(--spacing) * -1) !important;
      translate: var(--tw-translate-x) var(--tw-translate-y) !important;
    }
  }
  .data-\\[side\\=top\\]\\:slide-in-from-bottom-2 {
    &[data-side="top"] {
      --tw-enter-translate-y: calc(2*var(--spacing)) !important;
    }
  }
  .data-\\[size\\=default\\]\\:h-9 {
    &[data-size="default"] {
      height: calc(var(--spacing) * 9) !important;
    }
  }
  .data-\\[size\\=default\\]\\:h-\\[1\\.15rem\\] {
    &[data-size="default"] {
      height: 1.15rem !important;
    }
  }
  .data-\\[size\\=default\\]\\:w-8 {
    &[data-size="default"] {
      width: calc(var(--spacing) * 8) !important;
    }
  }
  .data-\\[size\\=lg\\]\\:size-10 {
    &[data-size="lg"] {
      width: calc(var(--spacing) * 10) !important;
      height: calc(var(--spacing) * 10) !important;
    }
  }
  .data-\\[size\\=sm\\]\\:size-6 {
    &[data-size="sm"] {
      width: calc(var(--spacing) * 6) !important;
      height: calc(var(--spacing) * 6) !important;
    }
  }
  .data-\\[size\\=sm\\]\\:h-3\\.5 {
    &[data-size="sm"] {
      height: calc(var(--spacing) * 3.5) !important;
    }
  }
  .data-\\[size\\=sm\\]\\:h-8 {
    &[data-size="sm"] {
      height: calc(var(--spacing) * 8) !important;
    }
  }
  .data-\\[size\\=sm\\]\\:w-6 {
    &[data-size="sm"] {
      width: calc(var(--spacing) * 6) !important;
    }
  }
  .\\*\\:data-\\[slot\\=alert-description\\]\\:text-foreground {
    :is(& > *) {
      &[data-slot="alert-description"] {
        color: var(--foreground) !important;
      }
    }
  }
  .\\*\\:data-\\[slot\\=avatar\\]\\:ring-2 {
    :is(& > *) {
      &[data-slot="avatar"] {
        --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
      }
    }
  }
  .\\*\\:data-\\[slot\\=avatar\\]\\:ring-background {
    :is(& > *) {
      &[data-slot="avatar"] {
        --tw-ring-color: var(--background) !important;
      }
    }
  }
  .data-\\[slot\\=checkbox-group\\]\\:gap-3 {
    &[data-slot="checkbox-group"] {
      gap: calc(var(--spacing) * 3) !important;
    }
  }
  .\\*\\*\\:data-\\[slot\\=command-input-wrapper\\]\\:h-12 {
    :is(& *) {
      &[data-slot="command-input-wrapper"] {
        height: calc(var(--spacing) * 12) !important;
      }
    }
  }
  .\\*\\*\\:data-\\[slot\\=navigation-menu-link\\]\\:focus\\:ring-0 {
    :is(& *) {
      &[data-slot="navigation-menu-link"] {
        &:focus {
          --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
          box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
        }
      }
    }
  }
  .\\*\\*\\:data-\\[slot\\=navigation-menu-link\\]\\:focus\\:outline-none {
    :is(& *) {
      &[data-slot="navigation-menu-link"] {
        &:focus {
          --tw-outline-style: none !important;
          outline-style: none !important;
        }
      }
    }
  }
  .\\*\\:data-\\[slot\\=select-value\\]\\:line-clamp-1 {
    :is(& > *) {
      &[data-slot="select-value"] {
        overflow: hidden !important;
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 1 !important;
      }
    }
  }
  .\\*\\:data-\\[slot\\=select-value\\]\\:flex {
    :is(& > *) {
      &[data-slot="select-value"] {
        display: flex !important;
      }
    }
  }
  .\\*\\:data-\\[slot\\=select-value\\]\\:items-center {
    :is(& > *) {
      &[data-slot="select-value"] {
        align-items: center !important;
      }
    }
  }
  .\\*\\:data-\\[slot\\=select-value\\]\\:gap-2 {
    :is(& > *) {
      &[data-slot="select-value"] {
        gap: calc(var(--spacing) * 2) !important;
      }
    }
  }
  .data-\\[state\\=active\\]\\:flex {
    &[data-state="active"] {
      display: flex !important;
    }
  }
  .data-\\[state\\=active\\]\\:bg-background {
    &[data-state="active"] {
      background-color: var(--background) !important;
    }
  }
  .data-\\[state\\=active\\]\\:text-green-600 {
    &[data-state="active"] {
      color: var(--green-600) !important;
    }
  }
  .data-\\[state\\=active\\]\\:text-primary-600 {
    &[data-state="active"] {
      color: var(--blue-600) !important;
    }
  }
  .data-\\[state\\=active\\]\\:text-red-600 {
    &[data-state="active"] {
      color: var(--red-600) !important;
    }
  }
  .group-data-\\[variant\\=default\\]\\/tabs-list\\:data-\\[state\\=active\\]\\:shadow-sm {
    &:is(:where(.group\\/tabs-list)[data-variant="default"] *) {
      &[data-state="active"] {
        --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)) !important;
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
      }
    }
  }
  .group-data-\\[variant\\=line\\]\\/tabs-list\\:data-\\[state\\=active\\]\\:bg-transparent {
    &:is(:where(.group\\/tabs-list)[data-variant="line"] *) {
      &[data-state="active"] {
        background-color: transparent !important;
      }
    }
  }
  .group-data-\\[variant\\=line\\]\\/tabs-list\\:data-\\[state\\=active\\]\\:shadow-none {
    &:is(:where(.group\\/tabs-list)[data-variant="line"] *) {
      &[data-state="active"] {
        --tw-shadow: 0 0 #0000 !important;
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
      }
    }
  }
  .group-data-\\[variant\\=line\\]\\/tabs-list\\:data-\\[state\\=active\\]\\:after\\:opacity-100 {
    &:is(:where(.group\\/tabs-list)[data-variant="line"] *) {
      &[data-state="active"] {
        &::after {
          content: var(--tw-content);
          opacity: 100% !important;
        }
      }
    }
  }
  .data-\\[state\\=checked\\]\\:translate-x-\\[calc\\(100\\%-2px\\)\\] {
    &[data-state="checked"] {
      --tw-translate-x: calc(100% - 2px) !important;
      translate: var(--tw-translate-x) var(--tw-translate-y) !important;
    }
  }
  .data-\\[state\\=checked\\]\\:border-primary {
    &[data-state="checked"] {
      border-color: var(--primary) !important;
    }
  }
  .data-\\[state\\=checked\\]\\:bg-primary {
    &[data-state="checked"] {
      background-color: var(--primary) !important;
    }
  }
  .data-\\[state\\=checked\\]\\:bg-primary-50 {
    &[data-state="checked"] {
      background-color: var(--blue-50) !important;
    }
  }
  .data-\\[state\\=checked\\]\\:font-medium {
    &[data-state="checked"] {
      --tw-font-weight: var(--font-weight-medium) !important;
      font-weight: var(--font-weight-medium) !important;
    }
  }
  .data-\\[state\\=checked\\]\\:text-primary-700 {
    &[data-state="checked"] {
      color: var(--blue-700) !important;
    }
  }
  .data-\\[state\\=checked\\]\\:text-primary-foreground {
    &[data-state="checked"] {
      color: var(--primary-foreground) !important;
    }
  }
  .data-\\[state\\=closed\\]\\:animate-collapsible-up {
    &[data-state="closed"] {
      animation: collapsible-up var(--tw-animation-duration,var(--tw-duration,.2s))var(--tw-ease,ease-out)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none) !important;
    }
  }
  .data-\\[state\\=closed\\]\\:animate-out {
    &[data-state="closed"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none) !important;
    }
  }
  .data-\\[state\\=closed\\]\\:duration-300 {
    &[data-state="closed"] {
      --tw-duration: 300ms !important;
      transition-duration: 300ms !important;
    }
  }
  .data-\\[state\\=closed\\]\\:fade-out-0 {
    &[data-state="closed"] {
      --tw-exit-opacity: calc(0/100) !important;
      --tw-exit-opacity: 0 !important;
    }
  }
  .data-\\[state\\=closed\\]\\:fill-mode-forwards {
    &[data-state="closed"] {
      animation-fill-mode: forwards !important;
      --tw-animation-fill-mode: forwards !important;
    }
  }
  .data-\\[state\\=closed\\]\\:zoom-out-95 {
    &[data-state="closed"] {
      --tw-exit-scale: calc(95*1%) !important;
      --tw-exit-scale: .95 !important;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-bottom {
    &[data-state="closed"] {
      --tw-exit-translate-y: 100% !important;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-left {
    &[data-state="closed"] {
      --tw-exit-translate-x: -100% !important;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-right {
    &[data-state="closed"] {
      --tw-exit-translate-x: 100% !important;
    }
  }
  .data-\\[state\\=closed\\]\\:slide-out-to-top {
    &[data-state="closed"] {
      --tw-exit-translate-y: -100% !important;
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=closed\\]\\:animate-out {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      &[data-state="closed"] {
        animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none) !important;
      }
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=closed\\]\\:fade-out-0 {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      &[data-state="closed"] {
        --tw-exit-opacity: calc(0/100) !important;
        --tw-exit-opacity: 0 !important;
      }
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=closed\\]\\:zoom-out-95 {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      &[data-state="closed"] {
        --tw-exit-scale: calc(95*1%) !important;
        --tw-exit-scale: .95 !important;
      }
    }
  }
  .data-\\[state\\=hidden\\]\\:animate-out {
    &[data-state="hidden"] {
      animation: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none) !important;
    }
  }
  .data-\\[state\\=hidden\\]\\:fade-out {
    &[data-state="hidden"] {
      --tw-exit-opacity: 0 !important;
    }
  }
  .data-\\[state\\=open\\]\\:animate-collapsible-down {
    &[data-state="open"] {
      animation: collapsible-down var(--tw-animation-duration,var(--tw-duration,.2s))var(--tw-ease,ease-out)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none) !important;
    }
  }
  .data-\\[state\\=open\\]\\:animate-in {
    &[data-state="open"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none) !important;
    }
  }
  .data-\\[state\\=open\\]\\:bg-accent {
    &[data-state="open"] {
      background-color: var(--accent) !important;
    }
  }
  .data-\\[state\\=open\\]\\:bg-neutral-alpha-200 {
    &[data-state="open"] {
      background-color: var(--neutral-alpha-200) !important;
    }
  }
  .data-\\[state\\=open\\]\\:bg-primary-100 {
    &[data-state="open"] {
      background-color: var(--blue-100) !important;
    }
  }
  .data-\\[state\\=open\\]\\:bg-secondary {
    &[data-state="open"] {
      background-color: var(--secondary) !important;
    }
  }
  .data-\\[state\\=open\\]\\:bg-sidebar-accent {
    &[data-state="open"] {
      background-color: var(--sidebar-accent) !important;
    }
  }
  .data-\\[state\\=open\\]\\:text-accent-foreground {
    &[data-state="open"] {
      color: var(--accent-foreground) !important;
    }
  }
  .data-\\[state\\=open\\]\\:text-muted-foreground {
    &[data-state="open"] {
      color: var(--muted-foreground) !important;
    }
  }
  .data-\\[state\\=open\\]\\:text-neutral-alpha-700 {
    &[data-state="open"] {
      color: var(--neutral-alpha-700) !important;
    }
  }
  .data-\\[state\\=open\\]\\:opacity-100 {
    &[data-state="open"] {
      opacity: 100% !important;
    }
  }
  .data-\\[state\\=open\\]\\:duration-500 {
    &[data-state="open"] {
      --tw-duration: 500ms !important;
      transition-duration: 500ms !important;
    }
  }
  .data-\\[state\\=open\\]\\:fade-in-0 {
    &[data-state="open"] {
      --tw-enter-opacity: calc(0/100) !important;
      --tw-enter-opacity: 0 !important;
    }
  }
  .data-\\[state\\=open\\]\\:zoom-in-90 {
    &[data-state="open"] {
      --tw-enter-scale: calc(90*1%) !important;
      --tw-enter-scale: .9 !important;
    }
  }
  .data-\\[state\\=open\\]\\:zoom-in-95 {
    &[data-state="open"] {
      --tw-enter-scale: calc(95*1%) !important;
      --tw-enter-scale: .95 !important;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-bottom {
    &[data-state="open"] {
      --tw-enter-translate-y: 100% !important;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-left {
    &[data-state="open"] {
      --tw-enter-translate-x: -100% !important;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-right {
    &[data-state="open"] {
      --tw-enter-translate-x: 100% !important;
    }
  }
  .data-\\[state\\=open\\]\\:slide-in-from-top {
    &[data-state="open"] {
      --tw-enter-translate-y: -100% !important;
    }
  }
  .group-data-\\[collapsible\\=icon\\]\\:data-\\[state\\=open\\]\\:bg-transparent\\! {
    &:is(:where(.group)[data-collapsible="icon"] *) {
      &[data-state="open"] {
        background-color: transparent !important;
      }
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=open\\]\\:animate-in {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      &[data-state="open"] {
        animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none) !important;
      }
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=open\\]\\:fade-in-0 {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      &[data-state="open"] {
        --tw-enter-opacity: calc(0/100) !important;
        --tw-enter-opacity: 0 !important;
      }
    }
  }
  .group-data-\\[viewport\\=false\\]\\/navigation-menu\\:data-\\[state\\=open\\]\\:zoom-in-95 {
    &:is(:where(.group\\/navigation-menu)[data-viewport="false"] *) {
      &[data-state="open"] {
        --tw-enter-scale: calc(95*1%) !important;
        --tw-enter-scale: .95 !important;
      }
    }
  }
  .data-\\[state\\=open\\]\\:hover\\:bg-neutral-alpha-100 {
    &[data-state="open"] {
      &:hover {
        @media (hover: hover) {
          background-color: var(--neutral-alpha-100) !important;
        }
      }
    }
  }
  .data-\\[state\\=open\\]\\:hover\\:bg-sidebar-accent {
    &[data-state="open"] {
      &:hover {
        @media (hover: hover) {
          background-color: var(--sidebar-accent) !important;
        }
      }
    }
  }
  .data-\\[state\\=open\\]\\:hover\\:text-sidebar-accent-foreground {
    &[data-state="open"] {
      &:hover {
        @media (hover: hover) {
          color: var(--sidebar-accent-foreground) !important;
        }
      }
    }
  }
  .data-\\[state\\=open\\]\\:focus\\:bg-neutral-alpha-200 {
    &[data-state="open"] {
      &:focus {
        background-color: var(--neutral-alpha-200) !important;
      }
    }
  }
  .data-\\[state\\=selected\\]\\:bg-muted {
    &[data-state="selected"] {
      background-color: var(--muted) !important;
    }
  }
  .data-\\[state\\=unchecked\\]\\:translate-x-0 {
    &[data-state="unchecked"] {
      --tw-translate-x: calc(var(--spacing) * 0) !important;
      translate: var(--tw-translate-x) var(--tw-translate-y) !important;
    }
  }
  .data-\\[state\\=unchecked\\]\\:bg-input {
    &[data-state="unchecked"] {
      background-color: var(--input) !important;
    }
  }
  .data-\\[state\\=visible\\]\\:animate-in {
    &[data-state="visible"] {
      animation: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none) !important;
    }
  }
  .data-\\[state\\=visible\\]\\:fade-in {
    &[data-state="visible"] {
      --tw-enter-opacity: 0 !important;
    }
  }
  .data-\\[variant\\=destructive\\]\\:text-destructive {
    &[data-variant="destructive"] {
      color: var(--destructive) !important;
    }
  }
  .data-\\[variant\\=destructive\\]\\:focus\\:bg-destructive\\/10 {
    &[data-variant="destructive"] {
      &:focus {
        background-color: var(--destructive) !important;
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--destructive) 10%, transparent) !important;
        }
      }
    }
  }
  .data-\\[variant\\=destructive\\]\\:focus\\:text-destructive {
    &[data-variant="destructive"] {
      &:focus {
        color: var(--destructive) !important;
      }
    }
  }
  .data-\\[variant\\=label\\]\\:text-sm {
    &[data-variant="label"] {
      font-size: var(--text-sm) !important;
      line-height: var(--tw-leading, var(--text-sm--line-height)) !important;
    }
  }
  .data-\\[variant\\=legend\\]\\:text-base {
    &[data-variant="legend"] {
      font-size: var(--text-base) !important;
      line-height: var(--tw-leading, var(--text-base--line-height)) !important;
    }
  }
  .data-\\[variant\\=line\\]\\:rounded-none {
    &[data-variant="line"] {
      border-radius: 0 !important;
    }
  }
  .nth-last-2\\:-mt-1 {
    &:nth-last-child(2) {
      margin-top: calc(var(--spacing) * -1) !important;
    }
  }
  .motion-reduce\\:transition-none {
    @media (prefers-reduced-motion: reduce) {
      transition-property: none !important;
    }
  }
  .motion-reduce\\:group-hover\\:scale-100 {
    @media (prefers-reduced-motion: reduce) {
      &:is(:where(.group):hover *) {
        @media (hover: hover) {
          --tw-scale-x: 100% !important;
          --tw-scale-y: 100% !important;
          --tw-scale-z: 100% !important;
          scale: var(--tw-scale-x) var(--tw-scale-y) !important;
        }
      }
    }
  }
  .motion-reduce\\:group-hover\\/user-menu\\:scale-100 {
    @media (prefers-reduced-motion: reduce) {
      &:is(:where(.group\\/user-menu):hover *) {
        @media (hover: hover) {
          --tw-scale-x: 100% !important;
          --tw-scale-y: 100% !important;
          --tw-scale-z: 100% !important;
          scale: var(--tw-scale-x) var(--tw-scale-y) !important;
        }
      }
    }
  }
  .motion-reduce\\:hover\\:translate-y-0 {
    @media (prefers-reduced-motion: reduce) {
      &:hover {
        @media (hover: hover) {
          --tw-translate-y: calc(var(--spacing) * 0) !important;
          translate: var(--tw-translate-x) var(--tw-translate-y) !important;
        }
      }
    }
  }
  .max-\\[1100px\\]\\:grid-cols-2 {
    @media (width < 1100px) {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
  }
  .max-\\[980px\\]\\:grid-cols-2 {
    @media (width < 980px) {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
  }
  .max-\\[720px\\]\\:min-h-112 {
    @media (width < 720px) {
      min-height: calc(var(--spacing) * 112) !important;
    }
  }
  .max-\\[720px\\]\\:grid-cols-1 {
    @media (width < 720px) {
      grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
    }
  }
  .max-\\[720px\\]\\:py-12 {
    @media (width < 720px) {
      padding-block: calc(var(--spacing) * 12) !important;
    }
  }
  .max-sm\\:hidden {
    @media (width < 40rem) {
      display: none !important;
    }
  }
  .sm\\:ml-auto {
    @media (width >= 40rem) {
      margin-left: auto !important;
    }
  }
  .sm\\:flex {
    @media (width >= 40rem) {
      display: flex !important;
    }
  }
  .sm\\:h-auto {
    @media (width >= 40rem) {
      height: auto !important;
    }
  }
  .sm\\:max-h-\\[90vh\\] {
    @media (width >= 40rem) {
      max-height: 90vh !important;
    }
  }
  .sm\\:min-h-96 {
    @media (width >= 40rem) {
      min-height: calc(var(--spacing) * 96) !important;
    }
  }
  .sm\\:w-48 {
    @media (width >= 40rem) {
      width: calc(var(--spacing) * 48) !important;
    }
  }
  .sm\\:w-56 {
    @media (width >= 40rem) {
      width: calc(var(--spacing) * 56) !important;
    }
  }
  .sm\\:w-64 {
    @media (width >= 40rem) {
      width: calc(var(--spacing) * 64) !important;
    }
  }
  .sm\\:w-80 {
    @media (width >= 40rem) {
      width: calc(var(--spacing) * 80) !important;
    }
  }
  .sm\\:w-\\[28rem\\] {
    @media (width >= 40rem) {
      width: 28rem !important;
    }
  }
  .sm\\:w-auto {
    @media (width >= 40rem) {
      width: auto !important;
    }
  }
  .sm\\:w-full {
    @media (width >= 40rem) {
      width: 100% !important;
    }
  }
  .sm\\:max-w-2xl {
    @media (width >= 40rem) {
      max-width: var(--container-2xl) !important;
    }
  }
  .sm\\:max-w-3xl {
    @media (width >= 40rem) {
      max-width: var(--container-3xl) !important;
    }
  }
  .sm\\:max-w-4xl {
    @media (width >= 40rem) {
      max-width: var(--container-4xl) !important;
    }
  }
  .sm\\:max-w-56 {
    @media (width >= 40rem) {
      max-width: calc(var(--spacing) * 56) !important;
    }
  }
  .sm\\:max-w-lg {
    @media (width >= 40rem) {
      max-width: var(--container-lg) !important;
    }
  }
  .sm\\:max-w-md {
    @media (width >= 40rem) {
      max-width: var(--container-md) !important;
    }
  }
  .sm\\:max-w-sm {
    @media (width >= 40rem) {
      max-width: var(--container-sm) !important;
    }
  }
  .sm\\:max-w-xl {
    @media (width >= 40rem) {
      max-width: var(--container-xl) !important;
    }
  }
  .sm\\:flex-none {
    @media (width >= 40rem) {
      flex: none !important;
    }
  }
  .sm\\:shrink-0 {
    @media (width >= 40rem) {
      flex-shrink: 0 !important;
    }
  }
  .sm\\:grid-cols-2 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
  }
  .sm\\:grid-cols-3 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
  }
  .sm\\:flex-col {
    @media (width >= 40rem) {
      flex-direction: column !important;
    }
  }
  .sm\\:flex-row {
    @media (width >= 40rem) {
      flex-direction: row !important;
    }
  }
  .sm\\:flex-wrap {
    @media (width >= 40rem) {
      flex-wrap: wrap !important;
    }
  }
  .sm\\:items-center {
    @media (width >= 40rem) {
      align-items: center !important;
    }
  }
  .sm\\:items-end {
    @media (width >= 40rem) {
      align-items: flex-end !important;
    }
  }
  .sm\\:items-start {
    @media (width >= 40rem) {
      align-items: flex-start !important;
    }
  }
  .sm\\:justify-between {
    @media (width >= 40rem) {
      justify-content: space-between !important;
    }
  }
  .sm\\:justify-center {
    @media (width >= 40rem) {
      justify-content: center !important;
    }
  }
  .sm\\:justify-end {
    @media (width >= 40rem) {
      justify-content: flex-end !important;
    }
  }
  .sm\\:gap-2\\.5 {
    @media (width >= 40rem) {
      gap: calc(var(--spacing) * 2.5) !important;
    }
  }
  .sm\\:gap-4 {
    @media (width >= 40rem) {
      gap: calc(var(--spacing) * 4) !important;
    }
  }
  .sm\\:gap-x-6 {
    @media (width >= 40rem) {
      column-gap: calc(var(--spacing) * 6) !important;
    }
  }
  .sm\\:divide-x {
    @media (width >= 40rem) {
      :where(& > :not(:last-child)) {
        --tw-divide-x-reverse: 0 !important;
        border-inline-style: var(--tw-border-style) !important;
        border-inline-start-width: calc(1px * var(--tw-divide-x-reverse)) !important;
        border-inline-end-width: calc(1px * calc(1 - var(--tw-divide-x-reverse))) !important;
      }
    }
  }
  .sm\\:divide-y-0 {
    @media (width >= 40rem) {
      :where(& > :not(:last-child)) {
        --tw-divide-y-reverse: 0 !important;
        border-bottom-style: var(--tw-border-style) !important;
        border-top-style: var(--tw-border-style) !important;
        border-top-width: calc(0px * var(--tw-divide-y-reverse)) !important;
        border-bottom-width: calc(0px * calc(1 - var(--tw-divide-y-reverse))) !important;
      }
    }
  }
  .sm\\:rounded-lg {
    @media (width >= 40rem) {
      border-radius: 0.375rem !important;
    }
  }
  .sm\\:border {
    @media (width >= 40rem) {
      border-style: var(--tw-border-style) !important;
      border-width: 1px !important;
    }
  }
  .sm\\:px-8 {
    @media (width >= 40rem) {
      padding-inline: calc(var(--spacing) * 8) !important;
    }
  }
  .sm\\:py-6 {
    @media (width >= 40rem) {
      padding-block: calc(var(--spacing) * 6) !important;
    }
  }
  .sm\\:text-center {
    @media (width >= 40rem) {
      text-align: center !important;
    }
  }
  .sm\\:text-left {
    @media (width >= 40rem) {
      text-align: left !important;
    }
  }
  .md\\:absolute {
    @media (width >= 48rem) {
      position: absolute !important;
    }
  }
  .md\\:block {
    @media (width >= 48rem) {
      display: block !important;
    }
  }
  .md\\:flex {
    @media (width >= 48rem) {
      display: flex !important;
    }
  }
  .md\\:hidden {
    @media (width >= 48rem) {
      display: none !important;
    }
  }
  .md\\:table-cell {
    @media (width >= 48rem) {
      display: table-cell !important;
    }
  }
  .md\\:w-1\\/2 {
    @media (width >= 48rem) {
      width: calc(1 / 2 * 100%) !important;
    }
  }
  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\] {
    @media (width >= 48rem) {
      width: var(--radix-navigation-menu-viewport-width) !important;
    }
  }
  .md\\:w-auto {
    @media (width >= 48rem) {
      width: auto !important;
    }
  }
  .md\\:w-full {
    @media (width >= 48rem) {
      width: 100% !important;
    }
  }
  .md\\:max-w-5xl {
    @media (width >= 48rem) {
      max-width: var(--container-5xl) !important;
    }
  }
  .md\\:shrink {
    @media (width >= 48rem) {
      flex-shrink: 1 !important;
    }
  }
  .md\\:grid-cols-2 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
  }
  .md\\:grid-cols-3 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
  }
  .md\\:grid-cols-\\[minmax\\(0\\,17rem\\)_minmax\\(0\\,1fr\\)\\] {
    @media (width >= 48rem) {
      grid-template-columns: minmax(0,17rem) minmax(0,1fr) !important;
    }
  }
  .md\\:grid-cols-\\[minmax\\(0\\,18rem\\)_1fr\\] {
    @media (width >= 48rem) {
      grid-template-columns: minmax(0,18rem) 1fr !important;
    }
  }
  .md\\:grid-rows-\\[minmax\\(0\\,1fr\\)\\] {
    @media (width >= 48rem) {
      grid-template-rows: minmax(0,1fr) !important;
    }
  }
  .md\\:flex-col {
    @media (width >= 48rem) {
      flex-direction: column !important;
    }
  }
  .md\\:flex-row {
    @media (width >= 48rem) {
      flex-direction: row !important;
    }
  }
  .md\\:items-center {
    @media (width >= 48rem) {
      align-items: center !important;
    }
  }
  .md\\:items-end {
    @media (width >= 48rem) {
      align-items: flex-end !important;
    }
  }
  .md\\:justify-between {
    @media (width >= 48rem) {
      justify-content: space-between !important;
    }
  }
  .md\\:gap-0 {
    @media (width >= 48rem) {
      gap: calc(var(--spacing) * 0) !important;
    }
  }
  .md\\:gap-2 {
    @media (width >= 48rem) {
      gap: calc(var(--spacing) * 2) !important;
    }
  }
  .md\\:gap-5 {
    @media (width >= 48rem) {
      gap: calc(var(--spacing) * 5) !important;
    }
  }
  .md\\:gap-12 {
    @media (width >= 48rem) {
      gap: calc(var(--spacing) * 12) !important;
    }
  }
  .md\\:overflow-visible {
    @media (width >= 48rem) {
      overflow: visible !important;
    }
  }
  .md\\:rounded-none {
    @media (width >= 48rem) {
      border-radius: 0 !important;
    }
  }
  .md\\:border-0 {
    @media (width >= 48rem) {
      border-style: var(--tw-border-style) !important;
      border-width: 0px !important;
    }
  }
  .md\\:border-r {
    @media (width >= 48rem) {
      border-right-style: var(--tw-border-style) !important;
      border-right-width: 1px !important;
    }
  }
  .md\\:border-b-0 {
    @media (width >= 48rem) {
      border-bottom-style: var(--tw-border-style) !important;
      border-bottom-width: 0px !important;
    }
  }
  .md\\:border-l-2 {
    @media (width >= 48rem) {
      border-left-style: var(--tw-border-style) !important;
      border-left-width: 2px !important;
    }
  }
  .md\\:border-l-border {
    @media (width >= 48rem) {
      border-left-color: var(--border) !important;
    }
  }
  .md\\:border-l-primary {
    @media (width >= 48rem) {
      border-left-color: var(--primary) !important;
    }
  }
  .md\\:px-10 {
    @media (width >= 48rem) {
      padding-inline: calc(var(--spacing) * 10) !important;
    }
  }
  .md\\:py-8 {
    @media (width >= 48rem) {
      padding-block: calc(var(--spacing) * 8) !important;
    }
  }
  .md\\:text-5xl {
    @media (width >= 48rem) {
      font-size: var(--text-5xl) !important;
      line-height: var(--tw-leading, var(--text-5xl--line-height)) !important;
    }
  }
  .md\\:text-sm {
    @media (width >= 48rem) {
      font-size: var(--text-sm) !important;
      line-height: var(--tw-leading, var(--text-sm--line-height)) !important;
    }
  }
  .md\\:opacity-0 {
    @media (width >= 48rem) {
      opacity: 0% !important;
    }
  }
  .md\\:peer-data-\\[variant\\=inset\\]\\:m-2 {
    @media (width >= 48rem) {
      &:is(:where(.peer)[data-variant="inset"] ~ *) {
        margin: calc(var(--spacing) * 2) !important;
      }
    }
  }
  .md\\:peer-data-\\[variant\\=inset\\]\\:ml-0 {
    @media (width >= 48rem) {
      &:is(:where(.peer)[data-variant="inset"] ~ *) {
        margin-left: calc(var(--spacing) * 0) !important;
      }
    }
  }
  .md\\:peer-data-\\[variant\\=inset\\]\\:rounded-xl {
    @media (width >= 48rem) {
      &:is(:where(.peer)[data-variant="inset"] ~ *) {
        border-radius: 0.5rem !important;
      }
    }
  }
  .md\\:peer-data-\\[variant\\=inset\\]\\:shadow-sm {
    @media (width >= 48rem) {
      &:is(:where(.peer)[data-variant="inset"] ~ *) {
        --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)) !important;
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
      }
    }
  }
  .md\\:peer-data-\\[variant\\=inset\\]\\:peer-data-\\[state\\=collapsed\\]\\:ml-2 {
    @media (width >= 48rem) {
      &:is(:where(.peer)[data-variant="inset"] ~ *) {
        &:is(:where(.peer)[data-state="collapsed"] ~ *) {
          margin-left: calc(var(--spacing) * 2) !important;
        }
      }
    }
  }
  .md\\:after\\:hidden {
    @media (width >= 48rem) {
      &::after {
        content: var(--tw-content);
        display: none !important;
      }
    }
  }
  .lg\\:col-span-2 {
    @media (width >= 64rem) {
      grid-column: span 2 / span 2 !important;
    }
  }
  .lg\\:mx-auto {
    @media (width >= 64rem) {
      margin-inline: auto !important;
    }
  }
  .lg\\:w-64 {
    @media (width >= 64rem) {
      width: calc(var(--spacing) * 64) !important;
    }
  }
  .lg\\:w-fit {
    @media (width >= 64rem) {
      width: fit-content !important;
    }
  }
  .lg\\:grid-cols-2 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
  }
  .lg\\:grid-cols-3 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
  }
  .lg\\:grid-cols-4 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
  }
  .lg\\:grid-cols-5 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    }
  }
  .lg\\:grid-cols-\\[minmax\\(0\\,1fr\\)_320px\\] {
    @media (width >= 64rem) {
      grid-template-columns: minmax(0,1fr) 320px !important;
    }
  }
  .lg\\:flex-row {
    @media (width >= 64rem) {
      flex-direction: row !important;
    }
  }
  .lg\\:gap-12 {
    @media (width >= 64rem) {
      gap: calc(var(--spacing) * 12) !important;
    }
  }
  .lg\\:border-t-0 {
    @media (width >= 64rem) {
      border-top-style: var(--tw-border-style) !important;
      border-top-width: 0px !important;
    }
  }
  .lg\\:border-l {
    @media (width >= 64rem) {
      border-left-style: var(--tw-border-style) !important;
      border-left-width: 1px !important;
    }
  }
  .xl\\:grid-cols-2 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
  }
  .xl\\:grid-cols-4 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
  }
  .\\@md\\/field-group\\:flex-row {
    @container field-group (width >= 28rem) {
      flex-direction: row !important;
    }
  }
  .\\@md\\/field-group\\:items-center {
    @container field-group (width >= 28rem) {
      align-items: center !important;
    }
  }
  .\\@md\\/field-group\\:has-\\[\\>\\[data-slot\\=field-content\\]\\]\\:items-start {
    @container field-group (width >= 28rem) {
      &:has(>[data-slot=field-content]) {
        align-items: flex-start !important;
      }
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 {
    & [cmdk-group-heading] {
      padding-inline: calc(var(--spacing) * 2) !important;
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 {
    & [cmdk-group-heading] {
      padding-block: calc(var(--spacing) * 1.5) !important;
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs {
    & [cmdk-group-heading] {
      font-size: var(--text-xs) !important;
      line-height: var(--tw-leading, var(--text-xs--line-height)) !important;
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium {
    & [cmdk-group-heading] {
      --tw-font-weight: var(--font-weight-medium) !important;
      font-weight: var(--font-weight-medium) !important;
    }
  }
  .\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground {
    & [cmdk-group-heading] {
      color: var(--muted-foreground) !important;
    }
  }
  .\\[\\&_\\[cmdk-group\\]\\]\\:px-2 {
    & [cmdk-group] {
      padding-inline: calc(var(--spacing) * 2) !important;
    }
  }
  .\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 {
    & [cmdk-group]:not([hidden]) ~[cmdk-group] {
      padding-top: calc(var(--spacing) * 0) !important;
    }
  }
  .\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 {
    & [cmdk-input-wrapper] svg {
      height: calc(var(--spacing) * 5) !important;
    }
  }
  .\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 {
    & [cmdk-input-wrapper] svg {
      width: calc(var(--spacing) * 5) !important;
    }
  }
  .\\[\\&_\\[cmdk-input\\]\\]\\:h-12 {
    & [cmdk-input] {
      height: calc(var(--spacing) * 12) !important;
    }
  }
  .\\[\\&_\\[cmdk-item\\]\\]\\:px-2 {
    & [cmdk-item] {
      padding-inline: calc(var(--spacing) * 2) !important;
    }
  }
  .\\[\\&_\\[cmdk-item\\]\\]\\:py-3 {
    & [cmdk-item] {
      padding-block: calc(var(--spacing) * 3) !important;
    }
  }
  .\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 {
    & [cmdk-item] svg {
      height: calc(var(--spacing) * 5) !important;
    }
  }
  .\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 {
    & [cmdk-item] svg {
      width: calc(var(--spacing) * 5) !important;
    }
  }
  .\\[\\&_\\[data-slot\\=carousel-content\\]\\]\\:h-full {
    & [data-slot=carousel-content] {
      height: 100% !important;
    }
  }
  .\\[\\&_a\\]\\:text-primary {
    & a {
      color: var(--primary) !important;
    }
  }
  .\\[\\&_a\\]\\:underline {
    & a {
      text-decoration-line: underline !important;
    }
  }
  .\\[\\&_h1\\]\\:mb-2 {
    & h1 {
      margin-bottom: calc(var(--spacing) * 2) !important;
    }
  }
  .\\[\\&_h1\\]\\:text-lg {
    & h1 {
      font-size: var(--text-lg) !important;
      line-height: var(--tw-leading, var(--text-lg--line-height)) !important;
    }
  }
  .\\[\\&_h1\\]\\:font-semibold {
    & h1 {
      --tw-font-weight: var(--font-weight-semibold) !important;
      font-weight: var(--font-weight-semibold) !important;
    }
  }
  .\\[\\&_h2\\]\\:mb-2 {
    & h2 {
      margin-bottom: calc(var(--spacing) * 2) !important;
    }
  }
  .\\[\\&_h2\\]\\:font-semibold {
    & h2 {
      --tw-font-weight: var(--font-weight-semibold) !important;
      font-weight: var(--font-weight-semibold) !important;
    }
  }
  .\\[\\&_img\\]\\:size-full {
    & img {
      width: 100% !important;
      height: 100% !important;
    }
  }
  .\\[\\&_img\\]\\:object-cover {
    & img {
      object-fit: cover !important;
    }
  }
  .\\[\\&_li\\]\\:mb-1 {
    & li {
      margin-bottom: calc(var(--spacing) * 1) !important;
    }
  }
  .\\[\\&_ol\\]\\:mb-3 {
    & ol {
      margin-bottom: calc(var(--spacing) * 3) !important;
    }
  }
  .\\[\\&_ol\\]\\:list-decimal {
    & ol {
      list-style-type: decimal !important;
    }
  }
  .\\[\\&_ol\\]\\:pl-6 {
    & ol {
      padding-left: calc(var(--spacing) * 6) !important;
    }
  }
  .\\[\\&_p\\]\\:mb-3 {
    & p {
      margin-bottom: calc(var(--spacing) * 3) !important;
    }
  }
  .\\[\\&_p\\]\\:leading-relaxed {
    & p {
      --tw-leading: var(--leading-relaxed) !important;
      line-height: var(--leading-relaxed) !important;
    }
  }
  .\\[\\&_svg\\]\\:pointer-events-none {
    & svg {
      pointer-events: none !important;
    }
  }
  .\\[\\&_svg\\]\\:shrink-0 {
    & svg {
      flex-shrink: 0 !important;
    }
  }
  .\\[\\&_svg\\:not\\(\\[class\\*\\=\\'size-\\'\\]\\)\\]\\:size-3 {
    & svg:not([class*='size-']) {
      width: calc(var(--spacing) * 3) !important;
      height: calc(var(--spacing) * 3) !important;
    }
  }
  .\\[\\&_svg\\:not\\(\\[class\\*\\=\\'size-\\'\\]\\)\\]\\:size-4 {
    & svg:not([class*='size-']) {
      width: calc(var(--spacing) * 4) !important;
      height: calc(var(--spacing) * 4) !important;
    }
  }
  .\\[\\&_svg\\:not\\(\\[class\\*\\=\\'text-\\'\\]\\)\\]\\:text-muted-foreground {
    & svg:not([class*='text-']) {
      color: var(--muted-foreground) !important;
    }
  }
  .\\[\\&_tr\\]\\:border-b {
    & tr {
      border-bottom-style: var(--tw-border-style) !important;
      border-bottom-width: 1px !important;
    }
  }
  .\\[\\&_tr\\:last-child\\]\\:border-0 {
    & tr:last-child {
      border-style: var(--tw-border-style) !important;
      border-width: 0px !important;
    }
  }
  .\\[\\&_ul\\]\\:mb-3 {
    & ul {
      margin-bottom: calc(var(--spacing) * 3) !important;
    }
  }
  .\\[\\&_ul\\]\\:list-disc {
    & ul {
      list-style-type: disc !important;
    }
  }
  .\\[\\&_ul\\]\\:pl-6 {
    & ul {
      padding-left: calc(var(--spacing) * 6) !important;
    }
  }
  .\\[\\&\\+\\[data-slot\\=item-content\\]\\]\\:flex-none {
    &+[data-slot=item-content] {
      flex: none !important;
    }
  }
  .\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:hidden {
    &::-webkit-calendar-picker-indicator {
      display: none !important;
    }
  }
  .\\[\\&\\:\\:-webkit-search-cancel-button\\]\\:hidden {
    &::-webkit-search-cancel-button {
      display: none !important;
    }
  }
  .\\[\\&\\:\\:-webkit-search-decoration\\]\\:hidden {
    &::-webkit-search-decoration {
      display: none !important;
    }
  }
  .\\[\\&\\:first-child\\[data-selected\\=true\\]_button\\]\\:rounded-l-md {
    &:first-child[data-selected=true] button {
      border-top-left-radius: 0.25rem !important;
      border-bottom-left-radius: 0.25rem !important;
    }
  }
  .\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0 {
    &:has([role=checkbox]) {
      padding-right: calc(var(--spacing) * 0) !important;
    }
  }
  .\\[\\.border-b\\]\\:pb-3 {
    &:is(.border-b) {
      padding-bottom: calc(var(--spacing) * 3) !important;
    }
  }
  .\\[\\.border-b\\]\\:pb-6 {
    &:is(.border-b) {
      padding-bottom: calc(var(--spacing) * 6) !important;
    }
  }
  .\\[\\.border-t\\]\\:pt-3 {
    &:is(.border-t) {
      padding-top: calc(var(--spacing) * 3) !important;
    }
  }
  .\\[\\.border-t\\]\\:pt-6 {
    &:is(.border-t) {
      padding-top: calc(var(--spacing) * 6) !important;
    }
  }
  .rtl\\:\\*\\*\\:\\[\\.rdp-button\\\\_next\\>svg\\]\\:rotate-180 {
    &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      :is(& *) {
        &:is(.rdp-button_next>svg) {
          rotate: 180deg !important;
        }
      }
    }
  }
  .rtl\\:\\*\\*\\:\\[\\.rdp-button\\\\_previous\\>svg\\]\\:rotate-180 {
    &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
      :is(& *) {
        &:is(.rdp-button_previous>svg) {
          rotate: 180deg !important;
        }
      }
    }
  }
  .\\[a\\]\\:transition-colors {
    &:is(a) {
      transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to !important;
      transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
      transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
    }
  }
  .\\[a\\]\\:hover\\:bg-accent\\/50 {
    &:is(a) {
      &:hover {
        @media (hover: hover) {
          background-color: var(--accent) !important;
          @supports (color: color-mix(in lab, red, red)) {
            background-color: color-mix(in oklab, var(--accent) 50%, transparent) !important;
          }
        }
      }
    }
  }
  .\\*\\:\\[span\\]\\:last\\:flex {
    :is(& > *) {
      &:is(span) {
        &:last-child {
          display: flex !important;
        }
      }
    }
  }
  .\\*\\:\\[span\\]\\:last\\:items-center {
    :is(& > *) {
      &:is(span) {
        &:last-child {
          align-items: center !important;
        }
      }
    }
  }
  .\\*\\:\\[span\\]\\:last\\:gap-2 {
    :is(& > *) {
      &:is(span) {
        &:last-child {
          gap: calc(var(--spacing) * 2) !important;
        }
      }
    }
  }
  .data-\\[variant\\=destructive\\]\\:\\*\\:\\[svg\\]\\:\\!text-destructive {
    &[data-variant="destructive"] {
      :is(& > *) {
        &:is(svg) {
          color: var(--destructive) !important;
        }
      }
    }
  }
  .\\[\\&\\:last-child\\[data-selected\\=true\\]_button\\]\\:rounded-r-md {
    &:last-child[data-selected=true] button {
      border-top-right-radius: 0.25rem !important;
      border-bottom-right-radius: 0.25rem !important;
    }
  }
  .\\[\\&\\:nth-child\\(2\\)\\[data-selected\\=true\\]_button\\]\\:rounded-l-md {
    &:nth-child(2)[data-selected=true] button {
      border-top-left-radius: 0.25rem !important;
      border-bottom-left-radius: 0.25rem !important;
    }
  }
  .\\[\\&\\>\\*\\]\\:w-full {
    &>* {
      width: 100% !important;
    }
  }
  .\\[\\&\\>\\*\\]\\:data-\\[slot\\=field\\]\\:p-4 {
    &>* {
      &[data-slot="field"] {
        padding: calc(var(--spacing) * 4) !important;
      }
    }
  }
  .\\@md\\/field-group\\:\\[\\&\\>\\*\\]\\:w-auto {
    @container field-group (width >= 28rem) {
      &>* {
        width: auto !important;
      }
    }
  }
  .\\[\\&\\>\\.sr-only\\]\\:w-auto {
    &>.sr-only {
      width: auto !important;
    }
  }
  .\\[\\&\\>\\[data-slot\\=field-group\\]\\]\\:gap-4 {
    &>[data-slot=field-group] {
      gap: calc(var(--spacing) * 4) !important;
    }
  }
  .\\[\\&\\>\\[data-slot\\=field-label\\]\\]\\:flex-auto {
    &>[data-slot=field-label] {
      flex: auto !important;
    }
  }
  .\\@md\\/field-group\\:\\[\\&\\>\\[data-slot\\=field-label\\]\\]\\:flex-auto {
    @container field-group (width >= 28rem) {
      &>[data-slot=field-label] {
        flex: auto !important;
      }
    }
  }
  .\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\] {
    &>[role=checkbox] {
      --tw-translate-y: 2px !important;
      translate: var(--tw-translate-x) var(--tw-translate-y) !important;
    }
  }
  .has-\\[\\>\\[data-slot\\=field-content\\]\\]\\:\\[\\&\\>\\[role\\=checkbox\\]\\,\\[role\\=radio\\]\\]\\:mt-px {
    &:has(>[data-slot=field-content]) {
      &>[role=checkbox],[role=radio] {
        margin-top: 1px !important;
      }
    }
  }
  .\\@md\\/field-group\\:has-\\[\\>\\[data-slot\\=field-content\\]\\]\\:\\[\\&\\>\\[role\\=checkbox\\]\\,\\[role\\=radio\\]\\]\\:mt-px {
    @container field-group (width >= 28rem) {
      &:has(>[data-slot=field-content]) {
        &>[role=checkbox],[role=radio] {
          margin-top: 1px !important;
        }
      }
    }
  }
  .\\[\\&\\>button\\]\\:hidden {
    &>button {
      display: none !important;
    }
  }
  .has-\\[\\>\\[data-align\\=block-end\\]\\]\\:\\[\\&\\>input\\]\\:pt-3 {
    &:has(>[data-align=block-end]) {
      &>input {
        padding-top: calc(var(--spacing) * 3) !important;
      }
    }
  }
  .has-\\[\\>\\[data-align\\=block-start\\]\\]\\:\\[\\&\\>input\\]\\:pb-3 {
    &:has(>[data-align=block-start]) {
      &>input {
        padding-bottom: calc(var(--spacing) * 3) !important;
      }
    }
  }
  .has-\\[\\>\\[data-align\\=inline-end\\]\\]\\:\\[\\&\\>input\\]\\:pr-2 {
    &:has(>[data-align=inline-end]) {
      &>input {
        padding-right: calc(var(--spacing) * 2) !important;
      }
    }
  }
  .has-\\[\\>\\[data-align\\=inline-start\\]\\]\\:\\[\\&\\>input\\]\\:pl-2 {
    &:has(>[data-align=inline-start]) {
      &>input {
        padding-left: calc(var(--spacing) * 2) !important;
      }
    }
  }
  .\\[\\&\\>kbd\\]\\:rounded-\\[calc\\(var\\(--radius\\)-5px\\)\\] {
    &>kbd {
      border-radius: calc(var(--radius) - 5px) !important;
    }
  }
  .\\[\\&\\>span\\]\\:text-xs {
    &>span {
      font-size: var(--text-xs) !important;
      line-height: var(--tw-leading, var(--text-xs--line-height)) !important;
    }
  }
  .\\[\\&\\>span\\]\\:opacity-70 {
    &>span {
      opacity: 70% !important;
    }
  }
  .\\[\\&\\>span\\:last-child\\]\\:truncate {
    &>span:last-child {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
    }
  }
  .\\[\\&\\>svg\\]\\:pointer-events-none {
    &>svg {
      pointer-events: none !important;
    }
  }
  .\\[\\&\\>svg\\]\\:size-3 {
    &>svg {
      width: calc(var(--spacing) * 3) !important;
      height: calc(var(--spacing) * 3) !important;
    }
  }
  .\\[\\&\\>svg\\]\\:size-3\\.5 {
    &>svg {
      width: calc(var(--spacing) * 3.5) !important;
      height: calc(var(--spacing) * 3.5) !important;
    }
  }
  .\\[\\&\\>svg\\]\\:size-4 {
    &>svg {
      width: calc(var(--spacing) * 4) !important;
      height: calc(var(--spacing) * 4) !important;
    }
  }
  .\\[\\&\\>svg\\]\\:size-5 {
    &>svg {
      width: calc(var(--spacing) * 5) !important;
      height: calc(var(--spacing) * 5) !important;
    }
  }
  .\\[\\&\\>svg\\]\\:size-\\[1\\.5em\\] {
    &>svg {
      width: 1.5em !important;
      height: 1.5em !important;
    }
  }
  .\\[\\&\\>svg\\]\\:shrink-0 {
    &>svg {
      flex-shrink: 0 !important;
    }
  }
  .\\[\\&\\>svg\\]\\:translate-y-0\\.5 {
    &>svg {
      --tw-translate-y: calc(var(--spacing) * 0.5) !important;
      translate: var(--tw-translate-x) var(--tw-translate-y) !important;
    }
  }
  .\\[\\&\\>svg\\]\\:text-current {
    &>svg {
      color: currentcolor !important;
    }
  }
  .\\[\\&\\>svg\\]\\:text-danger-500 {
    &>svg {
      color: var(--red-500) !important;
    }
  }
  .\\[\\&\\>svg\\]\\:text-info-500 {
    &>svg {
      color: var(--blue-500) !important;
    }
  }
  .\\[\\&\\>svg\\]\\:text-muted-foreground {
    &>svg {
      color: var(--muted-foreground) !important;
    }
  }
  .\\[\\&\\>svg\\]\\:text-neutral-500 {
    &>svg {
      color: var(--neutral-500) !important;
    }
  }
  .\\[\\&\\>svg\\]\\:text-sidebar-accent-foreground {
    &>svg {
      color: var(--sidebar-accent-foreground) !important;
    }
  }
  .\\[\\&\\>svg\\]\\:text-success-500 {
    &>svg {
      color: var(--green-500) !important;
    }
  }
  .\\[\\&\\>svg\\]\\:text-warning-500 {
    &>svg {
      color: var(--warning-500) !important;
    }
  }
  .group-has-data-\\[size\\=lg\\]\\/avatar-group\\:\\[\\&\\>svg\\]\\:size-5 {
    &:is(:where(.group\\/avatar-group):has(*[data-size="lg"]) *) {
      &>svg {
        width: calc(var(--spacing) * 5) !important;
        height: calc(var(--spacing) * 5) !important;
      }
    }
  }
  .group-has-data-\\[size\\=sm\\]\\/avatar-group\\:\\[\\&\\>svg\\]\\:size-3 {
    &:is(:where(.group\\/avatar-group):has(*[data-size="sm"]) *) {
      &>svg {
        width: calc(var(--spacing) * 3) !important;
        height: calc(var(--spacing) * 3) !important;
      }
    }
  }
  .group-data-\\[size\\=default\\]\\/avatar\\:\\[\\&\\>svg\\]\\:size-2 {
    &:is(:where(.group\\/avatar)[data-size="default"] *) {
      &>svg {
        width: calc(var(--spacing) * 2) !important;
        height: calc(var(--spacing) * 2) !important;
      }
    }
  }
  .group-data-\\[size\\=lg\\]\\/avatar\\:\\[\\&\\>svg\\]\\:size-2 {
    &:is(:where(.group\\/avatar)[data-size="lg"] *) {
      &>svg {
        width: calc(var(--spacing) * 2) !important;
        height: calc(var(--spacing) * 2) !important;
      }
    }
  }
  .group-data-\\[size\\=sm\\]\\/avatar\\:\\[\\&\\>svg\\]\\:hidden {
    &:is(:where(.group\\/avatar)[data-size="sm"] *) {
      &>svg {
        display: none !important;
      }
    }
  }
  .\\[\\&\\>svg\\:last-child\\]\\:hidden {
    &>svg:last-child {
      display: none !important;
    }
  }
  .\\[\\&\\>svg\\:not\\(\\[class\\*\\=\\'size-\\'\\]\\)\\]\\:size-3\\.5 {
    &>svg:not([class*='size-']) {
      width: calc(var(--spacing) * 3.5) !important;
      height: calc(var(--spacing) * 3.5) !important;
    }
  }
  .\\[\\&\\>svg\\:not\\(\\[class\\*\\=\\'size-\\'\\]\\)\\]\\:size-4 {
    &>svg:not([class*='size-']) {
      width: calc(var(--spacing) * 4) !important;
      height: calc(var(--spacing) * 4) !important;
    }
  }
  .\\[\\&\\>tr\\]\\:last\\:border-b-0 {
    &>tr {
      &:last-child {
        border-bottom-style: var(--tw-border-style) !important;
        border-bottom-width: 0px !important;
      }
    }
  }
  .\\[\\[data-side\\=left\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-right-2 {
    [data-side=left][data-collapsible=offcanvas] & {
      right: calc(var(--spacing) * -2) !important;
    }
  }
  .\\[\\[data-side\\=left\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-e-resize {
    [data-side=left][data-state=collapsed] & {
      cursor: e-resize !important;
    }
  }
  .\\[\\[data-side\\=right\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:-left-2 {
    [data-side=right][data-collapsible=offcanvas] & {
      left: calc(var(--spacing) * -2) !important;
    }
  }
  .\\[\\[data-side\\=right\\]\\[data-state\\=collapsed\\]_\\&\\]\\:cursor-w-resize {
    [data-side=right][data-state=collapsed] & {
      cursor: w-resize !important;
    }
  }
  .\\[\\[data-slot\\=card-content\\]_\\&\\]\\:bg-transparent {
    [data-slot=card-content] & {
      background-color: transparent !important;
    }
  }
  .\\[\\[data-slot\\=popover-content\\]_\\&\\]\\:bg-transparent {
    [data-slot=popover-content] & {
      background-color: transparent !important;
    }
  }
  .\\[\\[data-variant\\=legend\\]\\+\\&\\]\\:-mt-1\\.5 {
    [data-variant=legend]+& {
      margin-top: calc(var(--spacing) * -1.5) !important;
    }
  }
  .\\[a\\&\\]\\:hover\\:bg-accent {
    a& {
      &:hover {
        @media (hover: hover) {
          background-color: var(--accent) !important;
        }
      }
    }
  }
  .\\[a\\&\\]\\:hover\\:bg-danger-300 {
    a& {
      &:hover {
        @media (hover: hover) {
          background-color: var(--red-300) !important;
        }
      }
    }
  }
  .\\[a\\&\\]\\:hover\\:bg-info-300 {
    a& {
      &:hover {
        @media (hover: hover) {
          background-color: var(--blue-300) !important;
        }
      }
    }
  }
  .\\[a\\&\\]\\:hover\\:bg-neutral-alpha-100 {
    a& {
      &:hover {
        @media (hover: hover) {
          background-color: var(--neutral-alpha-100) !important;
        }
      }
    }
  }
  .\\[a\\&\\]\\:hover\\:bg-neutral-alpha-300 {
    a& {
      &:hover {
        @media (hover: hover) {
          background-color: var(--neutral-alpha-300) !important;
        }
      }
    }
  }
  .\\[a\\&\\]\\:hover\\:bg-success-300 {
    a& {
      &:hover {
        @media (hover: hover) {
          background-color: var(--green-300) !important;
        }
      }
    }
  }
  .\\[a\\&\\]\\:hover\\:bg-warning-300 {
    a& {
      &:hover {
        @media (hover: hover) {
          background-color: var(--warning-300) !important;
        }
      }
    }
  }
  .\\[a\\&\\]\\:hover\\:text-accent-foreground {
    a& {
      &:hover {
        @media (hover: hover) {
          color: var(--accent-foreground) !important;
        }
      }
    }
  }
  .\\[a\\&\\]\\:hover\\:underline {
    a& {
      &:hover {
        @media (hover: hover) {
          text-decoration-line: underline !important;
        }
      }
    }
  }
}
@property --tw-animation-delay {
  syntax: "*";
  inherits: false;
  initial-value: 0s;
}
@property --tw-animation-direction {
  syntax: "*";
  inherits: false;
  initial-value: normal;
}
@property --tw-animation-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-animation-fill-mode {
  syntax: "*";
  inherits: false;
  initial-value: none;
}
@property --tw-animation-iteration-count {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-blur {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-enter-opacity {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-rotate {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-enter-scale {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-enter-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-enter-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-blur {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-opacity {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-exit-rotate {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-scale {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-exit-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-exit-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
:root {
  --wfp-blue: #007dbc;
  --wfp-navy: #002f5a;
  --wfp-aqua: #008eb2;
  --wfp-darkgreen: #005d45;
  --wfp-green: #03924a;
  --wfp-ivory: #ece1b1;
  --wfp-earthybrown: #aa5628;
  --wfp-orange: #f0512d;
  --wfp-red: #e3002b;
  --wfp-purple: #ac1294;
  --wfp-burgundy: #950158;
  --neutral-alpha-50: #00000006;
  --neutral-alpha-100: #0000000f;
  --neutral-alpha-200: #0000001c;
  --neutral-alpha-300: #00000033;
  --neutral-alpha-400: #00000051;
  --neutral-alpha-500: #00000072;
  --neutral-alpha-600: #0000008d;
  --neutral-alpha-700: #000000ab;
  --neutral-alpha-800: #000000c5;
  --neutral-alpha-900: #000000d9;
  --neutral-alpha-950: #000000e9;
  --neutral-50: #f8f8f8;
  --neutral-100: #f1f1f1;
  --neutral-200: #e3e3e3;
  --neutral-300: #cccccc;
  --neutral-400: #aeaeae;
  --neutral-500: #8d8d8d;
  --neutral-600: #727272;
  --neutral-700: #545454;
  --neutral-800: #3a3a3a;
  --neutral-900: #262626;
  --neutral-950: #161616;
  --blue-50: #f4f9fc;
  --blue-100: #e9f2fa;
  --blue-200: #d3e6f5;
  --blue-300: #aed1ec;
  --blue-400: #7bb5df;
  --blue-500: #3f94cc;
  --blue-600: #0078b8;
  --blue-700: #005795;
  --blue-800: #003b6d;
  --blue-900: #00274e;
  --blue-950: #001632;
  --aqua-50: #f4f9fc;
  --aqua-100: #e5f3f8;
  --aqua-200: #cbe8f3;
  --aqua-300: #9ed4e9;
  --aqua-400: #65b9d8;
  --aqua-500: #2399bd;
  --aqua-600: #007c9e;
  --aqua-700: #005b78;
  --aqua-800: #003f55;
  --aqua-900: #002a3b;
  --aqua-950: #001925;
  --green-50: #f5faf6;
  --green-100: #e8f4eb;
  --green-200: #d2e9d7;
  --green-300: #abd6b5;
  --green-400: #7abe8a;
  --green-500: #38a05b;
  --green-600: #008442;
  --green-700: #006147;
  --green-800: #034332;
  --green-900: #022d21;
  --green-950: #011b12;
  --ivory-50: #fbf9ee;
  --ivory-100: #f6f0d9;
  --ivory-200: #ede3b7;
  --ivory-300: #d7cc9d;
  --ivory-400: #baaf81;
  --ivory-500: #988e60;
  --ivory-600: #7d7246;
  --ivory-700: #5f5429;
  --ivory-800: #443a0c;
  --ivory-900: #302600;
  --ivory-950: #1f1600;
  --brown-50: #fdf9f7;
  --brown-100: #faeee9;
  --brown-200: #f5ded3;
  --brown-300: #edc3af;
  --brown-400: #dfa082;
  --brown-500: #c97952;
  --brown-600: #af5b2e;
  --brown-700: #8b3e10;
  --brown-800: #652801;
  --brown-900: #461900;
  --brown-950: #2d0c00;
  --orange-50: #fff8f5;
  --orange-100: #ffeee8;
  --orange-200: #ffdcd0;
  --orange-300: #ffbda8;
  --orange-400: #ff9173;
  --orange-500: #f65834;
  --orange-600: #d23b16;
  --orange-700: #a22300;
  --orange-800: #751300;
  --orange-900: #520900;
  --orange-950: #340400;
  --red-50: #fff7f6;
  --red-100: #ffedeb;
  --red-200: #ffdad6;
  --red-300: #ffbbb5;
  --red-400: #ff8f89;
  --red-500: #ff4b4f;
  --red-600: #e4052c;
  --red-700: #ad000c;
  --red-800: #7c0001;
  --red-900: #560000;
  --red-950: #370000;
  --purple-50: #fdf8fb;
  --purple-100: #faeef7;
  --purple-200: #f6dcee;
  --purple-300: #ecbfe0;
  --purple-400: #de98ce;
  --purple-500: #cc6bb9;
  --purple-600: #ba40a5;
  --purple-700: #a50067;
  --purple-800: #760143;
  --purple-900: #52002d;
  --purple-950: #34001b;
  --black: #000;
  --white: #fff;
  --font-sans: Open Sans, Noto Sans Arabic, Noto Sans Bengali, Noto Sans JP, Noto Sans KR, Noto Sans SC,
    Noto Sans, ui-sans-serif, sans-serif, system-ui;
  --background: #fff;
  --foreground: #000000e9;
  --card: #fff;
  --card-foreground: #000000e9;
  --popover: #fff;
  --popover-foreground: #000000e9;
  --primary: #0078b8;
  --primary-foreground: #fff;
  --secondary: #e9f2fa;
  --secondary-foreground: #005795;
  --muted: #f8f8f8;
  --muted-foreground: #0000008d;
  --accent: #0000000f;
  --accent-foreground: #000000e9;
  --destructive: #e4052c;
  --border: #0000001c;
  --input: #8d8d8d;
  --ring: #0078b8;
  --chart-1: #7bb5df;
  --chart-2: #3f94cc;
  --chart-3: #0078b8;
  --chart-4: #005795;
  --chart-5: #003b6d;
  --sidebar: #f8f8f8;
  --sidebar-foreground: #000000e9;
  --sidebar-primary: #0078b8;
  --sidebar-primary-foreground: #fff;
  --sidebar-accent: #0000000f;
  --sidebar-accent-foreground: #000000e9;
  --sidebar-border: #0000001c;
  --sidebar-ring: #0078b8;
  --warning-50: #fff8e7;
  --warning-100: #fff0cf;
  --warning-200: #fee09c;
  --warning-300: #fcc524;
  --warning-400: #dea600;
  --warning-500: #ba8300;
  --warning-600: #9d6700;
  --warning-700: #7d4800;
  --warning-800: #602c00;
  --warning-900: #4a1500;
  --warning-950: #370100;
  --font-emoji: "Noto Color Emoji", sans-serif;
}
@layer base {
  * {
    border-color: var(--border);
    outline-color: var(--ring);
    @supports (color: color-mix(in lab, red, red)) {
      outline-color: color-mix(in oklab, var(--ring) 50%, transparent);
    }
  }
  body {
    background-color: var(--background);
    color: var(--foreground);
  }
  html {
    font-family: var(--font-sans);
  }
}
@layer components {
  [data-slot] {
    border-color: var(--border);
  }
  body {
    background-color: var(--muted);
  }
}
* {
  --tw-animation-fill-mode: forwards;
}
html [data-slot="dialog-overlay"][data-state="open"] {
  opacity: 1 !important;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-content {
  syntax: "*";
  initial-value: "";
  inherits: false;
}
@property --tw-divide-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes enter {
  from {
    opacity: var(--tw-enter-opacity,1);
    transform: translate3d(var(--tw-enter-translate-x,0),var(--tw-enter-translate-y,0),0)scale3d(var(--tw-enter-scale,1),var(--tw-enter-scale,1),var(--tw-enter-scale,1))rotate(var(--tw-enter-rotate,0));
    filter: blur(var(--tw-enter-blur,0));
  }
}
@keyframes exit {
  to {
    opacity: var(--tw-exit-opacity,1);
    transform: translate3d(var(--tw-exit-translate-x,0),var(--tw-exit-translate-y,0),0)scale3d(var(--tw-exit-scale,1),var(--tw-exit-scale,1),var(--tw-exit-scale,1))rotate(var(--tw-exit-rotate,0));
    filter: blur(var(--tw-exit-blur,0));
  }
}
@keyframes collapsible-down {
  from {
    height: 0;
  }
  to {
    height: var(--radix-collapsible-content-height,var(--bits-collapsible-content-height,var(--reka-collapsible-content-height,var(--kb-collapsible-content-height,auto))));
  }
}
@keyframes collapsible-up {
  from {
    height: var(--radix-collapsible-content-height,var(--bits-collapsible-content-height,var(--reka-collapsible-content-height,var(--kb-collapsible-content-height,auto))));
  }
  to {
    height: 0;
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-space-x-reverse: 0;
      --tw-divide-y-reverse: 0;
      --tw-border-style: solid;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-content: "";
      --tw-divide-x-reverse: 0;
      --tw-animation-delay: 0s;
      --tw-animation-direction: normal;
      --tw-animation-duration: initial;
      --tw-animation-fill-mode: none;
      --tw-animation-iteration-count: 1;
      --tw-enter-blur: 0;
      --tw-enter-opacity: 1;
      --tw-enter-rotate: 0;
      --tw-enter-scale: 1;
      --tw-enter-translate-x: 0;
      --tw-enter-translate-y: 0;
      --tw-exit-blur: 0;
      --tw-exit-opacity: 1;
      --tw-exit-rotate: 0;
      --tw-exit-scale: 1;
      --tw-exit-translate-x: 0;
      --tw-exit-translate-y: 0;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./src/assets/css/tailwind.css","webpack://./node_modules/tw-animate-css/dist/tw-animate.css"],"names":[],"mappings":"AAAA,iEAAA;AC86BE,iBAAmB;AC16BrB,qDAAsD;ADJtD,yCAAyC;AAEzC;EACE;ICsIA,6BAA8B;IDjI5B;8BAE0B;IA6T1B,kBAAkB;IAUlB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IAGtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,0BAA0B;IAa1B,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IAOvB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IAExB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;IA+CxB,sCAAsC;IACtC,2CAA2C;IAE3C,uCAAuC;IAEvC,+DAA+D;IAoD/D,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;IC/P3D,+BAAgC;ED7PjB;AADJ;AAmhBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA,sCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,qBAAmB;IAAnB,sBAAmB;IAAnB,qBAAmB;IAAnB,uBAAmB;IAAnB,2BAAmB;IAAnB,gCAAmB;IAAnB,8BAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;IAAnB;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,+BAAmB;IAAnB,uCAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,+BAAmB;IAAnB,uCAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,0EAAmB;EAAA;EAAnB;IAAA,mEAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,0DAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,gFAAmB;EAAA;EAAnB;IAAA,0EAAmB;EAAA;EAAnB;IAAA,yEAAmB;EAAA;EAAnB;IAAA,0EAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB,iEAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,iEAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,iEAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iEAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB,iEAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,iEAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,iEAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qHAAmB;EAAA;EAAnB;IAAA,0OAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,yDAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,2FAAmB;MAAnB,mGAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,yFAAmB;MAAnB,iGAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,yFAAmB;MAAnB,iGAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,yFAAmB;MAAnB,iGAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,yFAAmB;MAAnB,iGAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,yFAAmB;MAAnB,iGAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,yFAAmB;MAAnB,iGAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,yFAAmB;MAAnB,iGAAmB;IAAA;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,2FAAmB;MAAnB,mGAAmB;IAAA;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,sDAAmB;MAAnB,mDAAmB;MAAnB,mEAAmB;MAAnB,gFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,kCAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,uCAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,mDAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,qDAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,oDAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,+BAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB;MAAA,gFAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB;MAAA,oFAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB;MAAA,iFAAmB;IAAA;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,uEAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,uEAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,uEAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,wEAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,sEAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,sEAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,sEAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,sEAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,gDAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,gDAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,yBAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,8CAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,oDAAmB;IAAnB,+CAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,mDAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB;MAAA,iFAAmB;IAAA;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,4JAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,qIAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,oFAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,0IAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,wIAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,qIAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,mIAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,mIAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB;MAAA,oFAAmB;IAAA;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,uHAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,8BAAmB;IAAnB;MAAA,yCAAmB;MAAnB,8BAAmB;IAAA;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA,qMAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,mSAAmB;IAAnB,2RAAmB;EAAA;EAAnB;IAAA,oVAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,oDAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,8CAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,iEAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,qEAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,oDAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,kLAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,mEAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,yDAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,6CAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IE96B47N,0CAA6C;IAAE,gCAA+C;EF86BvgO;EAAnB;IAAA,mCAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IE96B+uO,wCAA0C;IAA0C,gCAA6C;EF86B71O;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IE96Bm9M,wCAA6B;EF86B79M;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6BAAmB;QAAnB,6BAAmB;QAAnB,6BAAmB;QAAnB,qDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mIAAmB;QAAnB,iJAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uDAAmB;MAAnB,iEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;MAAnB,iEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;MAAnB,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oDAAmB;MAAnB,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;MAAnB,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,wEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,sEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0IAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;MAAnB,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;IAAnB;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;IAAnB;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,sEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;MAAnB,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,uCAAmB;MAAnB,gGAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0BAAmB;QAAnB,qBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0BAAmB;QAAnB,iDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0BAAmB;QAAnB,uBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0BAAmB;QAAnB,uBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0BAAmB;QAAnB,6CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0BAAmB;QAAnB,gDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0BAAmB;QAAnB,2CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0BAAmB;QAAnB,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wDAAmB;QAAnB,iEAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;QAAnB;UAAA,+EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;QAAnB;UAAA,+EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;QAAnB;UAAA,+EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oFAAmB;QAAnB,iJAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wIAAmB;QAAnB,iJAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,wCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,2CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,4CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,iCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,0BAAmB;UAAnB,kDAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,uHAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,8BAAmB;MAAnB;QAAA,yCAAmB;QAAnB,8BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,uHAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;MAAnB,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;MAAnB,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,wCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB;QAAA,gFAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mIAAmB;MAAnB,iJAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;MAAnB;QAAA,6EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;MAAnB;QAAA,oFAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;MAAnB;QAAA,oFAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;MAAnB,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,4CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,iCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sDAAmB;MAAnB,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;MAAnB,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;ME96BmzT,0DAA6D;IF86B71T;EAAA;EAAnB;IAAA;ME96B87S,6DAAgE;IF86B3+S;EAAA;EAAnB;IAAA;ME96B+vZ,yDAA4D;IF86BxyZ;EAAA;EAAnB;IAAA;ME96Bi5Y,4DAA+D;IF86B77Y;EAAA;EAAnB;IAAA;MAAA,0OAAmB;IAAA;EAAA;EAAnB;IAAA;ME96Bk5N,gCAAqB;IF86Bp5N;EAAA;EAAnB;IAAA;MAAA,yOAAmB;IAAA;EAAA;EAAnB;IAAA;ME96B8iO,+BAAoB;IF86B/iO;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;MAAnB,iEAAmB;IAAA;EAAA;EAAnB;IAAA;ME96BiuR,4DAAgE;IF86B9wR;EAAA;EAAnB;IAAA;MAAA,sDAAmB;MAAnB,iEAAmB;IAAA;EAAA;EAAnB;IAAA;ME96BmzT,yDAA6D;IF86B71T;EAAA;EAAnB;IAAA;MAAA,qDAAmB;MAAnB,iEAAmB;IAAA;EAAA;EAAnB;IAAA;ME96B87S,4DAAgE;IF86B3+S;EAAA;EAAnB;IAAA;MAAA,sDAAmB;MAAnB,iEAAmB;IAAA;EAAA;EAAnB;IAAA;ME96BwlS,yDAA6D;IF86BloS;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mIAAmB;QAAnB,iJAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,6CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,mIAAmB;UAAnB,iJAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,mCAAmB;UAAnB,8BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;QAAnB,+BAAmB;QAAnB,uCAAmB;QAAnB,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qIAAmB;QAAnB,iJAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iCAAmB;QAAnB,iJAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,0BAAmB;UAAnB,wBAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;MAAnB,iEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sDAAmB;MAAnB,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sPAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yOAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;MAAnB,qCAAmB;IAAA;EAAA;EAAnB;IAAA;ME96BwlO,yCAA4C;MAAE,+BAA8C;IF86BjqO;EAAA;EAAnB;IAAA;ME96BmzM,wCAAmE;MAAE,6CAAwE;IF86B76M;EAAA;EAAnB;IAAA;ME96BukP,uCAAyC;MAAyC,+BAA4C;IF86BlrP;EAAA;EAAnB;IAAA;ME96Bs/X,sCAA2B;IF86B9/X;EAAA;EAAnB;IAAA;ME96Bs1Y,uCAA4B;IF86B/1Y;EAAA;EAAnB;IAAA;ME96BosZ,sCAA2B;IF86B5sZ;EAAA;EAAnB;IAAA;ME96BwoX,uCAA4B;IF86BjpX;EAAA;EAAnB;IAAA;MAAA;QAAA,yOAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QE96BwlO,yCAA4C;QAAE,+BAA8C;MF86BjqO;IAAA;EAAA;EAAnB;IAAA;MAAA;QE96BukP,uCAAyC;QAAyC,+BAA4C;MF86BlrP;IAAA;EAAA;EAAnB;IAAA;MAAA,yOAAmB;IAAA;EAAA;EAAnB;IAAA;ME96B8iO,+BAAoB;IF86B/iO;EAAA;EAAnB;IAAA;MAAA,wPAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0OAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;MAAnB,qCAAmB;IAAA;EAAA;EAAnB;IAAA;ME96B47N,0CAA6C;MAAE,gCAA+C;IF86BvgO;EAAA;EAAnB;IAAA;ME96B+uO,wCAA0C;MAA0C,+BAA6C;IF86B71O;EAAA;EAAnB;IAAA;ME96B+uO,wCAA0C;MAA0C,gCAA6C;IF86B71O;EAAA;EAAnB;IAAA;ME96B0hS,uCAA4B;IF86BniS;EAAA;EAAnB;IAAA;ME96Bi4S,wCAA6B;IF86B34S;EAAA;EAAnB;IAAA;ME96BsvT,uCAA4B;IF86B/vT;EAAA;EAAnB;IAAA;ME96BqqR,wCAA6B;IF86B/qR;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0OAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QE96B47N,0CAA6C;QAAE,gCAA+C;MF86BvgO;IAAA;EAAA;EAAnB;IAAA;MAAA;QE96B+uO,wCAA0C;QAA0C,gCAA6C;MF86B71O;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,qDAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,kDAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,kDAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;MAAnB,iEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0OAAmB;IAAA;EAAA;EAAnB;IAAA;ME96Bk5N,gCAAqB;IF86Bp5N;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+CAAmB;QAAnB;UAAA,qFAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,oCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,sEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;MAAnB,wEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,6BAAmB;UAAnB,6BAAmB;UAAnB,6BAAmB;UAAnB,qDAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,6BAAmB;UAAnB,6BAAmB;UAAnB,6BAAmB;UAAnB,qDAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,qDAAmB;UAAnB,iEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;QAAnB,sDAAmB;QAAnB,4EAAmB;QAAnB,oFAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;QAAnB,sDAAmB;QAAnB,mDAAmB;QAAnB,mEAAmB;QAAnB,gFAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;MAAnB,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sDAAmB;MAAnB,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oDAAmB;MAAnB,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;MAAnB,uEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,sEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qIAAmB;QAAnB,iJAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,gDAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0BAAmB;QAAnB,wBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;MAAnB,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oDAAmB;MAAnB,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,sEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sDAAmB;MAAnB,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,sEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;MAAnB,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wDAAmB;MAAnB,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;MAAnB,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sDAAmB;MAAnB,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,yBAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,yBAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,kLAAmB;MAAnB,gGAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,0CAAmB;UAAnB;YAAA,gFAAmB;UAAA;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,wBAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,8BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,wCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,oCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;MAAnB,iEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,0BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,kDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;MAAnB,sEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;MAAnB,kCAAmB;MAAnB,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;MAAnB,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uDAAmB;MAAnB,iEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;QAAnB,2CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;QAAnB,2CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;QAAnB,2CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;QAAnB,2CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;MAAnB,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sDAAmB;QAAnB,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,0CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,2CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,4CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,qDAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,qDAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,6CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,+CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,0CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,0CAAmB;QAAA;MAAA;IAAA;EAAA;AADJ;AE76BjB;EAA+B,WAAU;EAAC,eAAc;EAAC,iBAAgB;AAA3C;AAA4C;EAAmC,WAAU;EAAC,eAAc;EAAC,qBAAoB;AAA/C;AAAgD;EAAkC,WAAU;EAAC,eAAc;AAA1B;AAA2B;EAAmC,WAAU;EAAC,eAAc;EAAC,mBAAkB;AAA7C;AAA8C;EAAyC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA0B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA6B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA4B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA2B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAiC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAiC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAyB,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA4B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA2B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAA0B,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAgC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;AAA2C;EAAgC,WAAU;EAAC,eAAc;EAAC,gBAAe;AAA1C;ADoQlqC;EACE,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,wBAAyB;EACzB,oBAAqB;EACrB,oBAAqB;EACrB,0BAA2B;EAC3B,qBAAsB;EACtB,kBAAmB;EACnB,qBAAsB;EACtB,uBAAwB;EACxB,6BAA8B;EAC9B,8BAA+B;EAC/B,8BAA+B;EAC/B,8BAA+B;EAC/B,8BAA+B;EAC/B,8BAA+B;EAC/B,8BAA+B;EAC/B,8BAA+B;EAC/B,8BAA+B;EAC/B,8BAA+B;EAC/B,8BAA+B;EAC/B,qBAAsB;EACtB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,kBAAmB;EACnB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,kBAAmB;EACnB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,mBAAoB;EACpB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,mBAAoB;EACpB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,mBAAoB;EACpB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,oBAAqB;EACrB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,iBAAkB;EAClB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,oBAAqB;EACrB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,qBAAsB;EACtB,aAAc;EACd,aAAc;EACd;mDAEkD;EAClD,kBAAmB;EACnB,uBAAwB;EACxB,YAAa;EACb,4BAA6B;EAC7B,eAAgB;EAChB,+BAAgC;EAChC,kBAAmB;EACnB,0BAA2B;EAC3B,oBAAqB;EACrB,+BAAgC;EAChC,gBAAiB;EACjB,6BAA8B;EAC9B,mBAAoB;EACpB,8BAA+B;EAC/B,sBAAuB;EACvB,mBAAoB;EACpB,gBAAiB;EACjB,eAAgB;EAChB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;EACnB,+BAAgC;EAChC,0BAA2B;EAC3B,kCAAmC;EACnC,2BAA4B;EAC5B,sCAAuC;EACvC,2BAA4B;EAC5B,uBAAwB;EACxB,qBAAsB;EACtB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,sBAAuB;EACvB,4CAA6C;AAC9C;AAED;EACE;IACS,2BAAa;IAAC,0BAAe;IAAf;MAAA,gEAAe;IAAA;EACrC;EACD;IACS,mCAAa;IAAC,wBAAe;EACrC;EACD;IACS,6BAAS;EACjB;AACF;AAED;EAKE;IACS,2BAAa;EACrB;EAQD;IACS,8BAAQ;EAChB;AACF;AAED;EACE,kCAAmC;AACpC;AAWD;EACE,qBAAsB;AACvB;AD+cC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,iBAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AA3ejB;EACE;IACE,yBAAyB;EADxB;AADW;AAchB;EACE;IACE,YAAY;EADV;AADW;AEjdixF;EAAmB;IAAO,kCAAkC;IAAE,qMAAqM;IAAE,oCAAoC;EAAjR;AAAP;AAA4R;EAAkB;IAAK,iCAAiC;IAAE,+LAA+L;IAAE,mCAAmC;EAAzQ;AAAL;AAAsvD;EAA8B;IAAO,SAAS;EAAX;EAAc;IAAK,uKAAuK;EAAzK;AAAxB;AAAqM;EAA4B;IAAO,uKAAuK;EAAzK;EAA4K;IAAK,SAAS;EAAX;AAAtL;AF86BllK;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,uBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,qBAAmB;MAAnB,0BAAmB;MAAnB,4BAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,gBAAmB;MAAnB,wBAAmB;ME96BrB,wBAA8B;MAA4C,gCAAkC;MAAgD,gCAAiC;MAA2B,8BAAkC;MAA8C,iCAAwC;MAA2C,kBAAyB;MAA2C,qBAA4B;MAA2C,oBAA2B;MAA2C,mBAA0B;MAA2C,yBAAgC;MAA2C,yBAAgC;MAA2C,iBAAwB;MAA2C,oBAA2B;MAA2C,mBAA0B;MAA2C,kBAAyB;MAA2C,wBAA+B;MAA2C,wBAA+B;IF86B7oC;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 0);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","/*\n * Keep the legacy WFP theme above Tailwind's global reset but below the\n * utility-driven components we are migrating to.\n */\n@layer theme, base, legacy-wfp, components, utilities;\n\n@import \"tailwindcss\" important;\n@import \"tw-animate-css\";\n\n@custom-variant dark (&:is(.dark *));\n\n/*\n * WFP Design System theme for TailwindCSS v4.\n * Color tokens are direct hex values (no HSL wrappers).\n * @theme inline: emit design tokens as CSS custom properties and\n * reference the runtime vars defined in :root below.\n */\n@theme inline {\n  --color-stone-*: initial;\n  --color-zinc-*: initial;\n  --color-gray-*: initial;\n  --color-slate-*: initial;\n  --color-rose-*: initial;\n  --color-pink-*: initial;\n  --color-fuchsia-*: initial;\n  --color-sky-*: initial;\n  --color-cyan-*: initial;\n  --color-teal-*: initial;\n  --color-emerald-*: initial;\n  --color-lime-*: initial;\n  --color-yellow-*: initial;\n  --color-amber-*: initial;\n  --color-wfp-blue: var(--wfp-blue);\n  --color-wfp-navy: var(--wfp-navy);\n  --color-wfp-aqua: var(--wfp-aqua);\n  --color-wfp-darkgreen: var(--wfp-darkgreen);\n  --color-wfp-green: var(--wfp-green);\n  --color-wfp-ivory: var(--wfp-ivory);\n  --color-wfp-earthybrown: var(--wfp-earthybrown);\n  --color-wfp-orange: var(--wfp-orange);\n  --color-wfp-red: var(--wfp-red);\n  --color-wfp-purple: var(--wfp-purple);\n  --color-wfp-burgundy: var(--wfp-burgundy);\n  --color-primary-50: var(--blue-50);\n  --color-primary-100: var(--blue-100);\n  --color-primary-200: var(--blue-200);\n  --color-primary-300: var(--blue-300);\n  --color-primary-400: var(--blue-400);\n  --color-primary-500: var(--blue-500);\n  --color-primary-600: var(--blue-600);\n  --color-primary-700: var(--blue-700);\n  --color-primary-800: var(--blue-800);\n  --color-primary-900: var(--blue-900);\n  --color-primary-950: var(--blue-950);\n  --color-success-50: var(--green-50);\n  --color-success-100: var(--green-100);\n  --color-success-200: var(--green-200);\n  --color-success-300: var(--green-300);\n  --color-success-400: var(--green-400);\n  --color-success-500: var(--green-500);\n  --color-success-600: var(--green-600);\n  --color-success-700: var(--green-700);\n  --color-success-800: var(--green-800);\n  --color-success-900: var(--green-900);\n  --color-success-950: var(--green-950);\n  --color-warning-50: var(--warning-50);\n  --color-warning-100: var(--warning-100);\n  --color-warning-200: var(--warning-200);\n  --color-warning-300: var(--warning-300);\n  --color-warning-400: var(--warning-400);\n  --color-warning-500: var(--warning-500);\n  --color-warning-600: var(--warning-600);\n  --color-warning-700: var(--warning-700);\n  --color-warning-800: var(--warning-800);\n  --color-warning-900: var(--warning-900);\n  --color-warning-950: var(--warning-950);\n  --color-danger-50: var(--red-50);\n  --color-danger-100: var(--red-100);\n  --color-danger-200: var(--red-200);\n  --color-danger-300: var(--red-300);\n  --color-danger-400: var(--red-400);\n  --color-danger-500: var(--red-500);\n  --color-danger-600: var(--red-600);\n  --color-danger-700: var(--red-700);\n  --color-danger-800: var(--red-800);\n  --color-danger-900: var(--red-900);\n  --color-danger-950: var(--red-950);\n  --color-info-50: var(--blue-50);\n  --color-info-100: var(--blue-100);\n  --color-info-200: var(--blue-200);\n  --color-info-300: var(--blue-300);\n  --color-info-400: var(--blue-400);\n  --color-info-500: var(--blue-500);\n  --color-info-600: var(--blue-600);\n  --color-info-700: var(--blue-700);\n  --color-info-800: var(--blue-800);\n  --color-info-900: var(--blue-900);\n  --color-info-950: var(--blue-950);\n  --radius-xs: 0.125rem;\n  --radius-sm: 0.1875rem;\n  --radius-md: 0.25rem;\n  --radius-lg: 0.375rem;\n  --radius-xl: 0.5rem;\n  --radius-2xl: 0.75rem;\n  --radius-3xl: 1rem;\n  --radius-4xl: 1.5rem;\n  --color-sidebar-ring: var(--sidebar-ring);\n  --color-sidebar-border: var(--sidebar-border);\n  --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);\n  --color-sidebar-accent: var(--sidebar-accent);\n  --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);\n  --color-sidebar-primary: var(--sidebar-primary);\n  --color-sidebar-foreground: var(--sidebar-foreground);\n  --color-sidebar: var(--sidebar);\n  --color-chart-5: var(--chart-5);\n  --color-chart-4: var(--chart-4);\n  --color-chart-3: var(--chart-3);\n  --color-chart-2: var(--chart-2);\n  --color-chart-1: var(--chart-1);\n  --color-ring: var(--ring);\n  --color-input: var(--input);\n  --color-border: var(--border);\n  --color-destructive: var(--destructive);\n  --color-accent-foreground: var(--accent-foreground);\n  --color-accent: var(--accent);\n  --color-muted-foreground: var(--muted-foreground);\n  --color-muted: var(--muted);\n  --color-secondary-foreground: var(--secondary-foreground);\n  --color-secondary: var(--secondary);\n  --color-primary-foreground: var(--primary-foreground);\n  --color-primary: var(--primary);\n  --color-popover-foreground: var(--popover-foreground);\n  --color-popover: var(--popover);\n  --color-card-foreground: var(--card-foreground);\n  --color-card: var(--card);\n  --color-foreground: var(--foreground);\n  --color-background: var(--background);\n  --font-sans: var(--font-sans);\n  --color-white: var(--white);\n  --color-black: var(--black);\n  --color-purple-950: var(--purple-950);\n  --color-purple-900: var(--purple-900);\n  --color-purple-800: var(--purple-800);\n  --color-purple-700: var(--purple-700);\n  --color-purple-600: var(--purple-600);\n  --color-purple-500: var(--purple-500);\n  --color-purple-400: var(--purple-400);\n  --color-purple-300: var(--purple-300);\n  --color-purple-200: var(--purple-200);\n  --color-purple-100: var(--purple-100);\n  --color-purple-50: var(--purple-50);\n  --color-red-950: var(--red-950);\n  --color-red-900: var(--red-900);\n  --color-red-800: var(--red-800);\n  --color-red-700: var(--red-700);\n  --color-red-600: var(--red-600);\n  --color-red-500: var(--red-500);\n  --color-red-400: var(--red-400);\n  --color-red-300: var(--red-300);\n  --color-red-200: var(--red-200);\n  --color-red-100: var(--red-100);\n  --color-red-50: var(--red-50);\n  --color-orange-950: var(--orange-950);\n  --color-orange-900: var(--orange-900);\n  --color-orange-800: var(--orange-800);\n  --color-orange-700: var(--orange-700);\n  --color-orange-600: var(--orange-600);\n  --color-orange-500: var(--orange-500);\n  --color-orange-400: var(--orange-400);\n  --color-orange-300: var(--orange-300);\n  --color-orange-200: var(--orange-200);\n  --color-orange-100: var(--orange-100);\n  --color-orange-50: var(--orange-50);\n  --color-brown-950: var(--brown-950);\n  --color-brown-900: var(--brown-900);\n  --color-brown-800: var(--brown-800);\n  --color-brown-700: var(--brown-700);\n  --color-brown-600: var(--brown-600);\n  --color-brown-500: var(--brown-500);\n  --color-brown-400: var(--brown-400);\n  --color-brown-300: var(--brown-300);\n  --color-brown-200: var(--brown-200);\n  --color-brown-100: var(--brown-100);\n  --color-brown-50: var(--brown-50);\n  --color-ivory-950: var(--ivory-950);\n  --color-ivory-900: var(--ivory-900);\n  --color-ivory-800: var(--ivory-800);\n  --color-ivory-700: var(--ivory-700);\n  --color-ivory-600: var(--ivory-600);\n  --color-ivory-500: var(--ivory-500);\n  --color-ivory-400: var(--ivory-400);\n  --color-ivory-300: var(--ivory-300);\n  --color-ivory-200: var(--ivory-200);\n  --color-ivory-100: var(--ivory-100);\n  --color-ivory-50: var(--ivory-50);\n  --color-green-950: var(--green-950);\n  --color-green-900: var(--green-900);\n  --color-green-800: var(--green-800);\n  --color-green-700: var(--green-700);\n  --color-green-600: var(--green-600);\n  --color-green-500: var(--green-500);\n  --color-green-400: var(--green-400);\n  --color-green-300: var(--green-300);\n  --color-green-200: var(--green-200);\n  --color-green-100: var(--green-100);\n  --color-green-50: var(--green-50);\n  --color-aqua-950: var(--aqua-950);\n  --color-aqua-900: var(--aqua-900);\n  --color-aqua-800: var(--aqua-800);\n  --color-aqua-700: var(--aqua-700);\n  --color-aqua-600: var(--aqua-600);\n  --color-aqua-500: var(--aqua-500);\n  --color-aqua-400: var(--aqua-400);\n  --color-aqua-300: var(--aqua-300);\n  --color-aqua-200: var(--aqua-200);\n  --color-aqua-100: var(--aqua-100);\n  --color-aqua-50: var(--aqua-50);\n  --color-blue-950: var(--blue-950);\n  --color-blue-900: var(--blue-900);\n  --color-blue-800: var(--blue-800);\n  --color-blue-700: var(--blue-700);\n  --color-blue-600: var(--blue-600);\n  --color-blue-500: var(--blue-500);\n  --color-blue-400: var(--blue-400);\n  --color-blue-300: var(--blue-300);\n  --color-blue-200: var(--blue-200);\n  --color-blue-100: var(--blue-100);\n  --color-blue-50: var(--blue-50);\n  --color-neutral-950: var(--neutral-950);\n  --color-neutral-900: var(--neutral-900);\n  --color-neutral-800: var(--neutral-800);\n  --color-neutral-700: var(--neutral-700);\n  --color-neutral-600: var(--neutral-600);\n  --color-neutral-500: var(--neutral-500);\n  --color-neutral-400: var(--neutral-400);\n  --color-neutral-300: var(--neutral-300);\n  --color-neutral-200: var(--neutral-200);\n  --color-neutral-100: var(--neutral-100);\n  --color-neutral-50: var(--neutral-50);\n  --color-neutral-alpha-950: var(--neutral-alpha-950);\n  --color-neutral-alpha-900: var(--neutral-alpha-900);\n  --color-neutral-alpha-800: var(--neutral-alpha-800);\n  --color-neutral-alpha-700: var(--neutral-alpha-700);\n  --color-neutral-alpha-600: var(--neutral-alpha-600);\n  --color-neutral-alpha-500: var(--neutral-alpha-500);\n  --color-neutral-alpha-400: var(--neutral-alpha-400);\n  --color-neutral-alpha-300: var(--neutral-alpha-300);\n  --color-neutral-alpha-200: var(--neutral-alpha-200);\n  --color-neutral-alpha-100: var(--neutral-alpha-100);\n  --color-neutral-alpha-50: var(--neutral-alpha-50);\n  --color-indigo-*: initial;\n  --color-violet-*: initial;\n  --color-taupe-*: initial;\n  --color-mauve-*: initial;\n  --color-mist-*: initial;\n  --color-olive-*: initial;\n  --font-emoji: var(--font-emoji);\n}\n\n/* WFP Design System — light theme runtime values */\n:root {\n  --wfp-blue: #007dbc;\n  --wfp-navy: #002f5a;\n  --wfp-aqua: #008eb2;\n  --wfp-darkgreen: #005d45;\n  --wfp-green: #03924a;\n  --wfp-ivory: #ece1b1;\n  --wfp-earthybrown: #aa5628;\n  --wfp-orange: #f0512d;\n  --wfp-red: #e3002b;\n  --wfp-purple: #ac1294;\n  --wfp-burgundy: #950158;\n  --neutral-alpha-50: #00000006;\n  --neutral-alpha-100: #0000000f;\n  --neutral-alpha-200: #0000001c;\n  --neutral-alpha-300: #00000033;\n  --neutral-alpha-400: #00000051;\n  --neutral-alpha-500: #00000072;\n  --neutral-alpha-600: #0000008d;\n  --neutral-alpha-700: #000000ab;\n  --neutral-alpha-800: #000000c5;\n  --neutral-alpha-900: #000000d9;\n  --neutral-alpha-950: #000000e9;\n  --neutral-50: #f8f8f8;\n  --neutral-100: #f1f1f1;\n  --neutral-200: #e3e3e3;\n  --neutral-300: #cccccc;\n  --neutral-400: #aeaeae;\n  --neutral-500: #8d8d8d;\n  --neutral-600: #727272;\n  --neutral-700: #545454;\n  --neutral-800: #3a3a3a;\n  --neutral-900: #262626;\n  --neutral-950: #161616;\n  --blue-50: #f4f9fc;\n  --blue-100: #e9f2fa;\n  --blue-200: #d3e6f5;\n  --blue-300: #aed1ec;\n  --blue-400: #7bb5df;\n  --blue-500: #3f94cc;\n  --blue-600: #0078b8;\n  --blue-700: #005795;\n  --blue-800: #003b6d;\n  --blue-900: #00274e;\n  --blue-950: #001632;\n  --aqua-50: #f4f9fc;\n  --aqua-100: #e5f3f8;\n  --aqua-200: #cbe8f3;\n  --aqua-300: #9ed4e9;\n  --aqua-400: #65b9d8;\n  --aqua-500: #2399bd;\n  --aqua-600: #007c9e;\n  --aqua-700: #005b78;\n  --aqua-800: #003f55;\n  --aqua-900: #002a3b;\n  --aqua-950: #001925;\n  --green-50: #f5faf6;\n  --green-100: #e8f4eb;\n  --green-200: #d2e9d7;\n  --green-300: #abd6b5;\n  --green-400: #7abe8a;\n  --green-500: #38a05b;\n  --green-600: #008442;\n  --green-700: #006147;\n  --green-800: #034332;\n  --green-900: #022d21;\n  --green-950: #011b12;\n  --ivory-50: #fbf9ee;\n  --ivory-100: #f6f0d9;\n  --ivory-200: #ede3b7;\n  --ivory-300: #d7cc9d;\n  --ivory-400: #baaf81;\n  --ivory-500: #988e60;\n  --ivory-600: #7d7246;\n  --ivory-700: #5f5429;\n  --ivory-800: #443a0c;\n  --ivory-900: #302600;\n  --ivory-950: #1f1600;\n  --brown-50: #fdf9f7;\n  --brown-100: #faeee9;\n  --brown-200: #f5ded3;\n  --brown-300: #edc3af;\n  --brown-400: #dfa082;\n  --brown-500: #c97952;\n  --brown-600: #af5b2e;\n  --brown-700: #8b3e10;\n  --brown-800: #652801;\n  --brown-900: #461900;\n  --brown-950: #2d0c00;\n  --orange-50: #fff8f5;\n  --orange-100: #ffeee8;\n  --orange-200: #ffdcd0;\n  --orange-300: #ffbda8;\n  --orange-400: #ff9173;\n  --orange-500: #f65834;\n  --orange-600: #d23b16;\n  --orange-700: #a22300;\n  --orange-800: #751300;\n  --orange-900: #520900;\n  --orange-950: #340400;\n  --red-50: #fff7f6;\n  --red-100: #ffedeb;\n  --red-200: #ffdad6;\n  --red-300: #ffbbb5;\n  --red-400: #ff8f89;\n  --red-500: #ff4b4f;\n  --red-600: #e4052c;\n  --red-700: #ad000c;\n  --red-800: #7c0001;\n  --red-900: #560000;\n  --red-950: #370000;\n  --purple-50: #fdf8fb;\n  --purple-100: #faeef7;\n  --purple-200: #f6dcee;\n  --purple-300: #ecbfe0;\n  --purple-400: #de98ce;\n  --purple-500: #cc6bb9;\n  --purple-600: #ba40a5;\n  --purple-700: #a50067;\n  --purple-800: #760143;\n  --purple-900: #52002d;\n  --purple-950: #34001b;\n  --black: #000;\n  --white: #fff;\n  --font-sans:\n    Open Sans, Noto Sans Arabic, Noto Sans Bengali, Noto Sans JP, Noto Sans KR, Noto Sans SC,\n    Noto Sans, ui-sans-serif, sans-serif, system-ui;\n  --background: #fff;\n  --foreground: #000000e9;\n  --card: #fff;\n  --card-foreground: #000000e9;\n  --popover: #fff;\n  --popover-foreground: #000000e9;\n  --primary: #0078b8;\n  --primary-foreground: #fff;\n  --secondary: #e9f2fa;\n  --secondary-foreground: #005795;\n  --muted: #f8f8f8;\n  --muted-foreground: #0000008d;\n  --accent: #0000000f;\n  --accent-foreground: #000000e9;\n  --destructive: #e4052c;\n  --border: #0000001c;\n  --input: #8d8d8d;\n  --ring: #0078b8;\n  --chart-1: #7bb5df;\n  --chart-2: #3f94cc;\n  --chart-3: #0078b8;\n  --chart-4: #005795;\n  --chart-5: #003b6d;\n  --sidebar: #f8f8f8;\n  --sidebar-foreground: #000000e9;\n  --sidebar-primary: #0078b8;\n  --sidebar-primary-foreground: #fff;\n  --sidebar-accent: #0000000f;\n  --sidebar-accent-foreground: #000000e9;\n  --sidebar-border: #0000001c;\n  --sidebar-ring: #0078b8;\n  --warning-50: #fff8e7;\n  --warning-100: #fff0cf;\n  --warning-200: #fee09c;\n  --warning-300: #fcc524;\n  --warning-400: #dea600;\n  --warning-500: #ba8300;\n  --warning-600: #9d6700;\n  --warning-700: #7d4800;\n  --warning-800: #602c00;\n  --warning-900: #4a1500;\n  --warning-950: #370100;\n  --font-emoji: \"Noto Color Emoji\", sans-serif;\n}\n\n@layer base {\n  * {\n    @apply border-border outline-ring/50;\n  }\n  body {\n    @apply bg-background text-foreground;\n  }\n  html {\n    @apply font-sans;\n  }\n}\n\n@layer components {\n  /*\n   * Legacy WFP resets `border` on basic elements after Tailwind base styles.\n   * Here we restore new theme shadcn default border.\n   */\n  [data-slot] {\n    @apply border-border;\n  }\n\n  /*\n   * The legacy-wfp layer sets the page background (--ui-01) and outranks the\n   * `base` layer, so the app background must live in a layer above legacy-wfp.\n   * This is the single source of truth for the page background until the\n   * legacy theme is fully removed.\n   */\n  body {\n    @apply bg-muted;\n  }\n}\n\n* {\n  --tw-animation-fill-mode: forwards;\n}\n\n/*\n * Force the dialog backdrop fully opaque the moment it opens so swapping between\n * stacked dialogs (offer comments -> counter-offer / recall) never flashes the page\n * through the fading-in overlay (tw-animate `enter` keyframe animates opacity 0 -> 1).\n * `opacity: 1 !important` wins the cascade over the animation (important author beats\n * animations), which `animation: none` alone did not reliably do with Radix's mount\n * timing. Kept out of src/components/ui/dialog.tsx so a shadcn re-install can't\n * reintroduce the flash. Only the OPEN state is pinned; the close fade-out still plays.\n */\nhtml [data-slot=\"dialog-overlay\"][data-state=\"open\"] {\n  opacity: 1 !important;\n}\n","@property --tw-animation-delay{syntax:\"*\";inherits:false;initial-value:0s}@property --tw-animation-direction{syntax:\"*\";inherits:false;initial-value:normal}@property --tw-animation-duration{syntax:\"*\";inherits:false}@property --tw-animation-fill-mode{syntax:\"*\";inherits:false;initial-value:none}@property --tw-animation-iteration-count{syntax:\"*\";inherits:false;initial-value:1}@property --tw-enter-blur{syntax:\"*\";inherits:false;initial-value:0}@property --tw-enter-opacity{syntax:\"*\";inherits:false;initial-value:1}@property --tw-enter-rotate{syntax:\"*\";inherits:false;initial-value:0}@property --tw-enter-scale{syntax:\"*\";inherits:false;initial-value:1}@property --tw-enter-translate-x{syntax:\"*\";inherits:false;initial-value:0}@property --tw-enter-translate-y{syntax:\"*\";inherits:false;initial-value:0}@property --tw-exit-blur{syntax:\"*\";inherits:false;initial-value:0}@property --tw-exit-opacity{syntax:\"*\";inherits:false;initial-value:1}@property --tw-exit-rotate{syntax:\"*\";inherits:false;initial-value:0}@property --tw-exit-scale{syntax:\"*\";inherits:false;initial-value:1}@property --tw-exit-translate-x{syntax:\"*\";inherits:false;initial-value:0}@property --tw-exit-translate-y{syntax:\"*\";inherits:false;initial-value:0}@theme inline{--animation-delay-0: 0s; --animation-delay-75: 75ms; --animation-delay-100: .1s; --animation-delay-150: .15s; --animation-delay-200: .2s; --animation-delay-300: .3s; --animation-delay-500: .5s; --animation-delay-700: .7s; --animation-delay-1000: 1s; --animation-repeat-0: 0; --animation-repeat-1: 1; --animation-repeat-infinite: infinite; --animation-direction-normal: normal; --animation-direction-reverse: reverse; --animation-direction-alternate: alternate; --animation-direction-alternate-reverse: alternate-reverse; --animation-fill-mode-none: none; --animation-fill-mode-forwards: forwards; --animation-fill-mode-backwards: backwards; --animation-fill-mode-both: both; --percentage-0: 0; --percentage-5: .05; --percentage-10: .1; --percentage-15: .15; --percentage-20: .2; --percentage-25: .25; --percentage-30: .3; --percentage-35: .35; --percentage-40: .4; --percentage-45: .45; --percentage-50: .5; --percentage-55: .55; --percentage-60: .6; --percentage-65: .65; --percentage-70: .7; --percentage-75: .75; --percentage-80: .8; --percentage-85: .85; --percentage-90: .9; --percentage-95: .95; --percentage-100: 1; --percentage-translate-full: 1; --animate-in: enter var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); --animate-out: exit var(--tw-animation-duration,var(--tw-duration,.15s))var(--tw-ease,ease)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); @keyframes enter { from { opacity: var(--tw-enter-opacity,1); transform: translate3d(var(--tw-enter-translate-x,0),var(--tw-enter-translate-y,0),0)scale3d(var(--tw-enter-scale,1),var(--tw-enter-scale,1),var(--tw-enter-scale,1))rotate(var(--tw-enter-rotate,0)); filter: blur(var(--tw-enter-blur,0)); }}@keyframes exit { to { opacity: var(--tw-exit-opacity,1); transform: translate3d(var(--tw-exit-translate-x,0),var(--tw-exit-translate-y,0),0)scale3d(var(--tw-exit-scale,1),var(--tw-exit-scale,1),var(--tw-exit-scale,1))rotate(var(--tw-exit-rotate,0)); filter: blur(var(--tw-exit-blur,0)); }}--animate-accordion-down: accordion-down var(--tw-animation-duration,var(--tw-duration,.2s))var(--tw-ease,ease-out)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); --animate-accordion-up: accordion-up var(--tw-animation-duration,var(--tw-duration,.2s))var(--tw-ease,ease-out)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); --animate-collapsible-down: collapsible-down var(--tw-animation-duration,var(--tw-duration,.2s))var(--tw-ease,ease-out)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); --animate-collapsible-up: collapsible-up var(--tw-animation-duration,var(--tw-duration,.2s))var(--tw-ease,ease-out)var(--tw-animation-delay,0s)var(--tw-animation-iteration-count,1)var(--tw-animation-direction,normal)var(--tw-animation-fill-mode,none); @keyframes accordion-down { from { height: 0; }to { height: var(--radix-accordion-content-height,var(--bits-accordion-content-height,var(--reka-accordion-content-height,var(--kb-accordion-content-height,var(--ngp-accordion-content-height,auto))))); }}@keyframes accordion-up { from { height: var(--radix-accordion-content-height,var(--bits-accordion-content-height,var(--reka-accordion-content-height,var(--kb-accordion-content-height,var(--ngp-accordion-content-height,auto))))); }to { height: 0; }}@keyframes collapsible-down { from { height: 0; }to { height: var(--radix-collapsible-content-height,var(--bits-collapsible-content-height,var(--reka-collapsible-content-height,var(--kb-collapsible-content-height,auto)))); }}@keyframes collapsible-up { from { height: var(--radix-collapsible-content-height,var(--bits-collapsible-content-height,var(--reka-collapsible-content-height,var(--kb-collapsible-content-height,auto)))); }to { height: 0; }}--animate-caret-blink: caret-blink 1.25s ease-out infinite; @keyframes caret-blink { 0%,70%,100% { opacity: 1; }20%,50% { opacity: 0; }}}@utility animation-duration-*{--tw-animation-duration: calc(--value(number)*1ms); --tw-animation-duration: --value(--animation-duration-*,[duration],\"initial\",[*]); animation-duration: calc(--value(number)*1ms); animation-duration: --value(--animation-duration-*,[duration],\"initial\",[*]);}@utility delay-*{animation-delay: calc(--value(number)*1ms); animation-delay: --value(--animation-delay-*,[duration],\"initial\",[*]); --tw-animation-delay: calc(--value(number)*1ms); --tw-animation-delay: --value(--animation-delay-*,[duration],\"initial\",[*]);}@utility repeat-*{animation-iteration-count: --value(--animation-repeat-*,number,\"initial\",[*]); --tw-animation-iteration-count: --value(--animation-repeat-*,number,\"initial\",[*]);}@utility direction-*{animation-direction: --value(--animation-direction-*,\"initial\",[*]); --tw-animation-direction: --value(--animation-direction-*,\"initial\",[*]);}@utility fill-mode-*{animation-fill-mode: --value(--animation-fill-mode-*,\"initial\",[*]); --tw-animation-fill-mode: --value(--animation-fill-mode-*,\"initial\",[*]);}@utility running{animation-play-state: running;}@utility paused{animation-play-state: paused;}@utility play-state-*{animation-play-state: --value(\"initial\",[*]);}@utility blur-in{--tw-enter-blur: 20px;}@utility blur-in-*{--tw-enter-blur: calc(--value(number)*1px); --tw-enter-blur: --value(--blur-*,[*]);}@utility blur-out{--tw-exit-blur: 20px;}@utility blur-out-*{--tw-exit-blur: calc(--value(number)*1px); --tw-exit-blur: --value(--blur-*,[*]);}@utility fade-in{--tw-enter-opacity: 0;}@utility fade-in-*{--tw-enter-opacity: calc(--value(number)/100); --tw-enter-opacity: --value(--percentage-*,[*]);}@utility fade-out{--tw-exit-opacity: 0;}@utility fade-out-*{--tw-exit-opacity: calc(--value(number)/100); --tw-exit-opacity: --value(--percentage-*,[*]);}@utility zoom-in{--tw-enter-scale: 0;}@utility zoom-in-*{--tw-enter-scale: calc(--value(number)*1%); --tw-enter-scale: calc(--value(ratio)); --tw-enter-scale: --value(--percentage-*,[*]);}@utility -zoom-in-*{--tw-enter-scale: calc(--value(number)*-1%); --tw-enter-scale: calc(--value(ratio)*-1); --tw-enter-scale: --value(--percentage-*,[*]);}@utility zoom-out{--tw-exit-scale: 0;}@utility zoom-out-*{--tw-exit-scale: calc(--value(number)*1%); --tw-exit-scale: calc(--value(ratio)); --tw-exit-scale: --value(--percentage-*,[*]);}@utility -zoom-out-*{--tw-exit-scale: calc(--value(number)*-1%); --tw-exit-scale: calc(--value(ratio)*-1); --tw-exit-scale: --value(--percentage-*,[*]);}@utility spin-in{--tw-enter-rotate: 30deg;}@utility spin-in-*{--tw-enter-rotate: calc(--value(number)*1deg); --tw-enter-rotate: calc(--value(ratio)*360deg); --tw-enter-rotate: --value(--rotate-*,[*]);}@utility -spin-in{--tw-enter-rotate: -30deg;}@utility -spin-in-*{--tw-enter-rotate: calc(--value(number)*-1deg); --tw-enter-rotate: calc(--value(ratio)*-360deg); --tw-enter-rotate: --value(--rotate-*,[*]);}@utility spin-out{--tw-exit-rotate: 30deg;}@utility spin-out-*{--tw-exit-rotate: calc(--value(number)*1deg); --tw-exit-rotate: calc(--value(ratio)*360deg); --tw-exit-rotate: --value(--rotate-*,[*]);}@utility -spin-out{--tw-exit-rotate: -30deg;}@utility -spin-out-*{--tw-exit-rotate: calc(--value(number)*-1deg); --tw-exit-rotate: calc(--value(ratio)*-360deg); --tw-exit-rotate: --value(--rotate-*,[*]);}@utility slide-in-from-top{--tw-enter-translate-y: -100%;}@utility slide-in-from-top-*{--tw-enter-translate-y: calc(--value(integer)*var(--spacing)*-1); --tw-enter-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-enter-translate-y: calc(--value(ratio)*-100%); --tw-enter-translate-y: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-in-from-bottom{--tw-enter-translate-y: 100%;}@utility slide-in-from-bottom-*{--tw-enter-translate-y: calc(--value(integer)*var(--spacing)); --tw-enter-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-enter-translate-y: calc(--value(ratio)*100%); --tw-enter-translate-y: --value(--translate-*,[percentage],[length]);}@utility slide-in-from-left{--tw-enter-translate-x: -100%;}@utility slide-in-from-left-*{--tw-enter-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-enter-translate-x: calc(--value(ratio)*-100%); --tw-enter-translate-x: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-in-from-right{--tw-enter-translate-x: 100%;}@utility slide-in-from-right-*{--tw-enter-translate-x: calc(--value(integer)*var(--spacing)); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-enter-translate-x: calc(--value(ratio)*100%); --tw-enter-translate-x: --value(--translate-*,[percentage],[length]);}@utility slide-in-from-start{&:dir(ltr){ --tw-enter-translate-x: -100%; }&:dir(rtl){ --tw-enter-translate-x: 100%; }}@utility slide-in-from-start-*{&:where(:dir(ltr),[dir=\"ltr\"],[dir=\"ltr\"]*){ --tw-enter-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-enter-translate-x: calc(--value(ratio)*-100%); --tw-enter-translate-x: calc(--value(--translate-*,[percentage],[length])*-1); }&:where(:dir(rtl),[dir=\"rtl\"],[dir=\"rtl\"]*){ --tw-enter-translate-x: calc(--value(integer)*var(--spacing)); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-enter-translate-x: calc(--value(ratio)*100%); --tw-enter-translate-x: --value(--translate-*,[percentage],[length]); }}@utility slide-in-from-end{&:dir(ltr){ --tw-enter-translate-x: 100%; }&:dir(rtl){ --tw-enter-translate-x: -100%; }}@utility slide-in-from-end-*{&:where(:dir(ltr),[dir=\"ltr\"],[dir=\"ltr\"]*){ --tw-enter-translate-x: calc(--value(integer)*var(--spacing)); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-enter-translate-x: calc(--value(ratio)*100%); --tw-enter-translate-x: --value(--translate-*,[percentage],[length]); }&:where(:dir(rtl),[dir=\"rtl\"],[dir=\"rtl\"]*){ --tw-enter-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-enter-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-enter-translate-x: calc(--value(ratio)*-100%); --tw-enter-translate-x: calc(--value(--translate-*,[percentage],[length])*-1); }}@utility slide-out-to-top{--tw-exit-translate-y: -100%;}@utility slide-out-to-top-*{--tw-exit-translate-y: calc(--value(integer)*var(--spacing)*-1); --tw-exit-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-exit-translate-y: calc(--value(ratio)*-100%); --tw-exit-translate-y: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-out-to-bottom{--tw-exit-translate-y: 100%;}@utility slide-out-to-bottom-*{--tw-exit-translate-y: calc(--value(integer)*var(--spacing)); --tw-exit-translate-y: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-exit-translate-y: calc(--value(ratio)*100%); --tw-exit-translate-y: --value(--translate-*,[percentage],[length]);}@utility slide-out-to-left{--tw-exit-translate-x: -100%;}@utility slide-out-to-left-*{--tw-exit-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-exit-translate-x: calc(--value(ratio)*-100%); --tw-exit-translate-x: calc(--value(--translate-*,[percentage],[length])*-1);}@utility slide-out-to-right{--tw-exit-translate-x: 100%;}@utility slide-out-to-right-*{--tw-exit-translate-x: calc(--value(integer)*var(--spacing)); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-exit-translate-x: calc(--value(ratio)*100%); --tw-exit-translate-x: --value(--translate-*,[percentage],[length]);}@utility slide-out-to-start{&:dir(ltr){ --tw-exit-translate-x: -100%; }&:dir(rtl){ --tw-exit-translate-x: 100%; }}@utility slide-out-to-start-*{&:where(:dir(ltr),[dir=\"ltr\"],[dir=\"ltr\"]*){ --tw-exit-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-exit-translate-x: calc(--value(ratio)*-100%); --tw-exit-translate-x: calc(--value(--translate-*,[percentage],[length])*-1); }&:where(:dir(rtl),[dir=\"rtl\"],[dir=\"rtl\"]*){ --tw-exit-translate-x: calc(--value(integer)*var(--spacing)); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-exit-translate-x: calc(--value(ratio)*100%); --tw-exit-translate-x: --value(--translate-*,[percentage],[length]); }}@utility slide-out-to-end{&:dir(ltr){ --tw-exit-translate-x: 100%; }&:dir(rtl){ --tw-exit-translate-x: -100%; }}@utility slide-out-to-end-*{&:where(:dir(ltr),[dir=\"ltr\"],[dir=\"ltr\"]*){ --tw-exit-translate-x: calc(--value(integer)*var(--spacing)); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*100%); --tw-exit-translate-x: calc(--value(ratio)*100%); --tw-exit-translate-x: --value(--translate-*,[percentage],[length]); }&:where(:dir(rtl),[dir=\"rtl\"],[dir=\"rtl\"]*){ --tw-exit-translate-x: calc(--value(integer)*var(--spacing)*-1); --tw-exit-translate-x: calc(--value(--percentage-*,--percentage-translate-*)*-100%); --tw-exit-translate-x: calc(--value(ratio)*-100%); --tw-exit-translate-x: calc(--value(--translate-*,[percentage],[length])*-1); }}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
